(function() {
    'use strict';

    angular
        .module('mVtasWebApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
			sessionStorage.clear();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('ventahoyrealtime'); 
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('HomeController', HomeController);
		 
    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Ventahoyrealtime', '$interval'];

    function HomeController ($scope, Principal, LoginService, $state, Ventahoyrealtime, $interval) {
        var vm = this;
		var refreshTimer;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.ventahoyrealtimes = [];

        function loadAll() {
            Ventahoyrealtime.query(function(result) {
                vm.ventahoyrealtimes = result;
                vm.searchQuery = null;
            });
		}

        loadAll();

		//$window.location.reload();
		
		refreshTimer= $interval(loadAll, 300000);
		//if(refreshTimer)
		//	$interval.flush(60000*5);
			
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
		
		$scope.stop = function() {
			if(refreshTimer)
				$interval.cancel(refreshTimer);
		};
			
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

		$scope.$on('$destroy', function () {
			$scope.stop();
        }); 
		
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDialogController', ZetasrealtimeDialogController);

    ZetasrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zetasrealtime.id !== null) {
                Zetasrealtime.update(vm.zetasrealtime, onSaveSuccess, onSaveError);
            } else {
                Zetasrealtime.save(vm.zetasrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:zetasrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechadesde = false;
        vm.datePickerOpenStatus.fechahasta = false;
        vm.datePickerOpenStatus.fechaoperativa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDetailController', ZetasrealtimeDetailController);

    ZetasrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:zetasrealtimeUpdate', function(event, result) {
            vm.zetasrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDeleteController',ZetasrealtimeDeleteController);

    ZetasrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDeleteController($uibModalInstance, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zetasrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zetasrealtime', {
            parent: 'entity',
            url: '/zetasrealtime?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zetasrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtimes.html',
                    controller: 'ZetasrealtimeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zetasrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zetasrealtime-detail', {
            parent: 'zetasrealtime',
            url: '/zetasrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zetasrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-detail.html',
                    controller: 'ZetasrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zetasrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zetasrealtime', function($stateParams, Zetasrealtime) {
                    return Zetasrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zetasrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zetasrealtime-detail.edit', {
            parent: 'zetasrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zetasrealtime.new', {
            parent: 'zetasrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaproceso: null,
                                comercio: null,
                                ip: null,
                                pv: null,
                                nroz: null,
                                fechadesde: null,
                                fechahasta: null,
                                zetamontoventas: null,
                                zetamontoncredito: null,
                                ticketsmontoventas: null,
                                ticketsmontoncredito: null,
                                ticketscantventas: null,
                                ticketscantncredito: null,
                                itemscantventas: null,
                                itemscantncredito: null,
                                nivelproceso: null,
                                fechaoperativa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('zetasrealtime');
                });
            }]
        })
        .state('zetasrealtime.edit', {
            parent: 'zetasrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-dialog.html',
                    controller: 'ZetasrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zetasrealtime.delete', {
            parent: 'zetasrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zetasrealtime/zetasrealtime-delete-dialog.html',
                    controller: 'ZetasrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zetasrealtime', function(Zetasrealtime) {
                            return Zetasrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zetasrealtime', null, { reload: 'zetasrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Zetasrealtime', Zetasrealtime);

    Zetasrealtime.$inject = ['$resource', 'DateUtils'];

    function Zetasrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/zetasrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechadesde = DateUtils.convertDateTimeFromServer(data.fechadesde);
                        data.fechahasta = DateUtils.convertDateTimeFromServer(data.fechahasta);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeController', ZetasrealtimeController);

    ZetasrealtimeController.$inject = ['$state', 'Zetasrealtime', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ZetasrealtimeController($state, Zetasrealtime, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Zetasrealtime.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.zetasrealtimes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDialogController', ZetaDialogController);

    ZetaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zeta', 'Ticket', 'Venta'];

    function ZetaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zeta, Ticket, Venta) {
        var vm = this;

        vm.zeta = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.tickets = Ticket.query();
        vm.ventas = Venta.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zeta.id !== null) {
                Zeta.update(vm.zeta, onSaveSuccess, onSaveError);
            } else {
                Zeta.save(vm.zeta, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:zetaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechadesde = false;
        vm.datePickerOpenStatus.fechahasta = false;
        vm.datePickerOpenStatus.fechaoperativa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDetailController', ZetaDetailController);

    ZetaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zeta', 'Ticket', 'Venta'];

    function ZetaDetailController($scope, $rootScope, $stateParams, previousState, entity, Zeta, Ticket, Venta) {
        var vm = this;
        vm.zeta = entity;
        vm.previousState = previousState.name;
		vm.tickets = [];
		vm.vzeta = entity;
		vm.totalizado= 0.00;
		
        loadAll();

        function loadAll() {
            Ticket.queryByZeta({id: vm.zeta.id}, function(result) {
                vm.tickets = result;
                vm.searchQuery = null;
				vm.totalizado=0;				
				var maxl=vm.tickets.length;
				for (var i = 0; i < maxl; i++) { 
				  var tic = vm.tickets[i];
				  //es + ncredito porque tienen signo negativo.
				  vm.totalizado += (tic.montototal);
				}
				
            });
        } 
		
        var unsubscribe = $rootScope.$on('mVtasWebApp:zetaUpdate', function(event, result) {
            vm.zeta = result;
        });
        $scope.$on('$destroy', unsubscribe);
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'Tickets',
			  headers:true, 
			  caption: {
				  title:'Tickets',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {1:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mytimeformat = function(dateStr) {
			var date = new Date(dateStr);
			return date.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}); 
			};
		
		alasql.fn.mydateformat = function(dateStr) {
			var date = new Date(dateStr);
			return date.toLocaleDateString();
			};
		var dateFormat = "dd-MM-yyyy";				
		//var fechasel= vm.zeta.fechadesde;
		//var fechasel= Venta.fecha;
		var nombrearchivoexcel= vm.zeta.comercio;//+ '_' + fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
		vm.exportDataExcel = function () {
			alasql('SELECT mydateformat(fecha) as fecha, mytimeformat(fecha) as hora, nropv, nroticket, montototal, totalefectivo, totaltarjeta, cantitems, cliente, tipofactura, esncredito, codigomoneda  INTO XLSX("Venta_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.tickets]);   
			};
		vm.exportDataCSV = function () {
			alasql('SELECT mydateformat(fecha) as fecha, mytimeformat(fecha) as hora, nropv, nroticket, montototal, totalefectivo, totaltarjeta, cantitems, cliente, tipofactura, esncredito, codigomoneda INTO CSV("Venta_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.tickets]);   		
			};	

    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDeleteController',ZetaDeleteController);

    ZetaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zeta'];

    function ZetaDeleteController($uibModalInstance, entity, Zeta) {
        var vm = this;

        vm.zeta = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zeta.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zeta', {
            parent: 'entity',
            url: '/zeta',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zeta.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zeta/zetas.html',
                    controller: 'ZetaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zeta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zeta-detail', {
            parent: 'zeta',
            url: '/zeta/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zeta.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zeta/zeta-detail.html',
                    controller: 'ZetaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zeta');
					$translatePartialLoader.addPart('venta'); 
					$translatePartialLoader.addPart('ticket'); 
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zeta', function($stateParams, Zeta) {
                    return Zeta.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zeta',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zeta-detail.edit', {
            parent: 'zeta-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zeta.new', {
            parent: 'zeta',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comercio: null,
                                nropv: null,
                                fechadesde: null,
                                fechahasta: null,
                                ticketsmontoventas: null,
                                ticketsmontoncredito: null,
                                ticketscantventas: null,
                                ticketscantncredito: null,
                                itemscantventas: null,
                                itemscantncredito: null,
                                ip: null,
                                nroz: null,
                                fechaoperativa: null,
                                totalefectivo: null,
                                totaltarjeta: null,
                                id: null,
								aeropuerto: null,
								metodo: null,
								modimpresora: null,
								tax1a: null,
								razonsocial: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('zeta');
                });
            }]
        })
        .state('zeta.edit', {
            parent: 'zeta',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zeta.delete', {
            parent: 'zeta',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-delete-dialog.html',
                    controller: 'ZetaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Zeta', Zeta)
		.factory('ZetaFecha', ZetaFecha); 

    Zeta.$inject = ['$resource', 'DateUtils'];
	ZetaFecha.$inject = ['$resource', 'DateUtils'];

    function Zeta ($resource, DateUtils) {
        var resourceUrl =  'api/zetas/:id';

        return $resource(resourceUrl, {}, {
			'queryByVenta': {
                url: 'api/zetas/ventas/:id',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechadesde = DateUtils.convertDateTimeFromServer(data.fechadesde);
                        data.fechahasta = DateUtils.convertDateTimeFromServer(data.fechahasta);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function ZetaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/zetafecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaoperativa = DateUtils.convertDateTimeFromServer(data.fechaoperativa);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}


})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaController', ZetaController);

    ZetaController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Zeta",
		"ZetaFecha",
		"ParseLinks",
		"AlertService"
		];

    function ZetaController($scope,  $filter, $state, Zeta, ZetaFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		
		vm.ixcounter = 0;
		
		vm.nombrearchivocsv=null;
		vm.nombrearchivoexcel=null;
		vm.seleccionRazonSocial = null;
		vm.seleccionAeropuerto = null;
		  
		
		vm.onChangeDate = onChangeDate;
		vm.onChangeAep = onChangeAep;
		vm.onChangeRazonSocial = onChangeRazonSocial;
		
		vm.previousMonth = previousMonth;
		vm.today = today;
		
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";//"<Todos>";
		vm.arrayComercios = null;

		vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;

		vm.listaRazonSocial = null;
		vm.seleccionRazonSocial = "<Todos>";//"<Todos>";
		vm.arrayRazonSocial = null;

		vm.listaComerciosByRazonSocial = null;
		
		vm.toDate=JSON.parse( sessionStorage.getItem( 'zetasfechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'zetasfechadesde'), dateReviver );
		
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2022, 1, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };
		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'zetasfechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('zetasfechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  ZetaFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				//
				vm.listaComercios= new Map();
				vm.listaAeropuertos= new Map();
				vm.listaRazonSocial= new Map();
				vm.listaComerciosByRazonSocial = new Map();
				
				//
				result.forEach(function(zeta){
					//estas 2 cosas son un HACK, para reusar variables para la vista!!
					
					//2 zeta.ticketsmontoventas
					
					//3 esta sera neto sin impuestos
					//zeta.ticketscantventas=zeta.ticketsmontoventas - Math.abs(zeta.ticketsmontoncredito) - Math.abs(zeta.tax1a);
					//
					//1 esto es el neto de ventas menos ncredito
					zeta.ticketsmontoncredito= zeta.ticketsmontoventas - Math.abs(zeta.ticketsmontoncredito);
					
					if(!vm.listaComercios.has(zeta.comercio)){		
						vm.listaComercios.set(zeta.comercio, zeta.aeropuerto);   
						}
					if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				
						vm.listaAeropuertos.set(zeta.aeropuerto, true);    
						}				
					if(!vm.listaRazonSocial.has(zeta.razonsocial)){		
						vm.listaRazonSocial.set(zeta.razonsocial, zeta.aeropuerto);   
						}
					if(!vm.listaComerciosByRazonSocial.has(zeta.comercio)){		
						vm.listaComerciosByRazonSocial.set(zeta.comercio, zeta.razonsocial);   
						}
					})  
				//

				vm.arrayComercios= new Array();
				vm.listaComercios.forEach(function(value, key){ vm.arrayComercios.push([key, value])});
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift(["<Todos>", ""]);

				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");

				vm.arrayRazonSocial= new Array();
				vm.listaRazonSocial.forEach(function(value, key){ vm.arrayRazonSocial.push([key, value])});
				vm.arrayRazonSocial.sort();
				vm.arrayRazonSocial.unshift(["<Todos>", ""]);
				
				vm.zetas = result;
			}
		  );
 		}
		


		/*
		function onChangeRazonSocial() {
		  vm.arrayComercios = [];
		  vm.seleccionRazonSocial = $scope.vm.seleccionRazonSocial;
		  vm.seleccionAeropuerto = $scope.vm.seleccionAeropuerto;
		  if (!seleccionRazonSocial || !seleccionRazonSocial.length || seleccionRazonSocial[0] === "<Todos>") {
			vm.listaComercios.forEach(function(value, key) {
				if (!seleccionAeropuerto || !seleccionAeropuerto.length || seleccionAeropuerto === "<Todos>") {	
			  	  vm.arrayComercios.push([key, value]);
				} else {
					if(seleccionAeropuerto === value){
						vm.arrayComercios.push([key, value]);	
					}
				}
			});
		  } else {
			vm.aepselected = null;
			vm.listaRazonSocial.forEach(function (value1, key1) {
				if (seleccionRazonSocial[0] === key1) {
				  vm.aepselected = value1;
				  vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
					if (seleccionRazonSocial[0] === value2) {
						if(!vm.arrayComercios.length){
							vm.arrayComercios.push([key2, vm.aepselected]);
						}
						else {
							for (let i = 0; i < vm.arrayComercios.length; i++) {
								if (!(vm.arrayComercios[i][0] === key2)) {
									vm.arrayComercios.push([key2, vm.aepselected]);
									break;
								}
							}
						}
					}
				  });
				}
			  });
		  }
		  vm.arrayComercios.sort();
		  vm.arrayComercios.unshift(["<Todos>", ""]);
		}
		*/
		
		/*
		function AddAllComerciosAeropuerto()
		{
			vm.listaComercios.forEach(function(value, key) {
			if (!vm.seleccionAeropuerto || !vm.seleccionAeropuerto.length || vm.seleccionAeropuerto === "<Todos>") {	
		  	  vm.arrayComercios.push([key, value]);
			} else {
				if(vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);	
				}
			}
			});
		}
		
		
		function ProcessAddAllComerciosByRazonSocial()
		{
		vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
			if (vm.seleccionRazonSocial[0] === value2) {
				if(!vm.arrayComercios.length){
					vm.arrayComercios.push([key2, vm.aepselected]);
				}
				else {
					for (let i = 0; i < vm.arrayComercios.length; i++) {
						if (!(vm.arrayComercios[i][0] === key2)) {
							vm.arrayComercios.push([key2, vm.aepselected]);
							break;
						}
					}
				}
			}
		  });
		}
		
		*/
		
		function AddAllComerciosAeropuerto()
		{
			vm.listaComercios.forEach(function(value, key) {
			if (!vm.seleccionAeropuerto || !vm.seleccionAeropuerto.length || vm.seleccionAeropuerto === "<Todos>") {	
		  	  vm.arrayComercios.push([key, value]);
			} else {
				if(vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);	
				}
			}
			});
		}
				
		//lpmqlp Javascript, si uso let i=0...son variables creadas dentro de un forEach...data
		//error ocul;to en el packing war, pero en develop anda...que hdp! 2 dias renegando..
		//este codigo quedo suboptimo!.
		function addOnlyBySameRazonSocial( key2) {
			for (vm.ixcounter = 0; vm.ixcounter < vm.arrayComercios.length; vm.ixcounter++) {
				if (vm.arrayComercios[vm.ixcounter][0] != key2) {
					vm.arrayComercios.push([key2, vm.aepselected]);
					break;
				}
			}
		}
		
		function ProcessAddAllComerciosByRazonSocial()
		{
			vm.listaComerciosByRazonSocial.forEach(function (value2, key2) {
				if (vm.seleccionRazonSocial[0] === value2) {
					if(!vm.arrayComercios.length){
						vm.arrayComercios.push([key2, vm.aepselected]);
					} else {
						addOnlyBySameRazonSocial(key2);
					}
				}
			/*
			if (vm.seleccionRazonSocial[0] === value2) {
				if(!vm.arrayComercios.length){
					vm.arrayComercios.push([key2, vm.aepselected]);
				}
				else {
					for (let i = 0; i < vm.arrayComercios.length; i++) {
						if (!(vm.arrayComercios[i][0] === key2)) {
							vm.arrayComercios.push([key2, vm.aepselected]);
							break;
						}
					}
				}
			}
			*/
		  });
		
		}
		
		function AddAllComerciosByRazonSocial()
		{
		vm.aepselected = null;
		vm.listaRazonSocial.forEach(function (value1, key1) {
			if (vm.seleccionRazonSocial[0] === key1) {
			  vm.aepselected = value1;
			  ProcessAddAllComerciosByRazonSocial();
			  }
		  });
		}
		
		
		function onChangeRazonSocial() {
		  vm.arrayComercios = [];
		  vm.seleccionRazonSocial = $scope.vm.seleccionRazonSocial;
		  vm.seleccionAeropuerto = $scope.vm.seleccionAeropuerto;
		  if (!vm.seleccionRazonSocial || !vm.seleccionRazonSocial.length || vm.seleccionRazonSocial[0] === "<Todos>") {
			  AddAllComerciosAeropuerto();
		  } else {
			  AddAllComerciosByRazonSocial();
		  }
		  vm.arrayComercios.sort();
		  vm.arrayComercios.unshift(["<Todos>", ""]);
		}
		
					
		//esto para refrescar la lista de comercios en funcion del AEP!
		function onChangeAep() {
			vm.arrayRazonSocial.splice(0,vm.arrayRazonSocial.length);
			vm.listaRazonSocial.forEach(function(value, key){ 
				if("<Todos>" === $scope.vm.seleccionAeropuerto){	
					vm.arrayRazonSocial.push([key, value]);
					}
				else if($scope.vm.seleccionAeropuerto === value){
					vm.arrayRazonSocial.push([key, value]);
					}
				}
				);
			vm.arrayRazonSocial.sort();
			vm.arrayRazonSocial.unshift(["<Todos>", ""]);
			//
			vm.arrayComercios.splice(0,vm.arrayComercios.length);
			vm.listaComercios.forEach(function(value, key){ 
				if("<Todos>" === $scope.vm.seleccionAeropuerto){	
					vm.arrayComercios.push([key, value]);
					}
				else if($scope.vm.seleccionAeropuerto === value){
					vm.arrayComercios.push([key, value]);
					}
				}
				);
			vm.arrayComercios.sort();
			vm.arrayComercios.unshift(["<Todos>", ""]); 
			}




		$scope.filtraPorRazonSocial = function (zeta) {
			if( !$scope.vm.seleccionRazonSocial ||	!$scope.vm.seleccionRazonSocial.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionRazonSocial){
				return true;
				}
			if("<Todos>" === $scope.vm.seleccionRazonSocial[0]){
				return true;
				}
			if(zeta.razonsocial === $scope.vm.seleccionRazonSocial[0]){
				return true;	
				}	
			return false;
		}

			
		$scope.filtraPorComercio = function (zeta) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio){
				return true;
				}
			if("<Todos>" === $scope.vm.seleccionComercio[0]){
				return true;
				}
			if(zeta.comercio === $scope.vm.seleccionComercio[0]){
				return true;	
				}	
			return false;
		}
				
		
		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto || !$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				return true;
				}
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				return true;	
				}
			return false;
		}
	
		//---------------------------------------------------------------------------------------------------------------------------

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
				
		
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}
		
	

		 
		//area exportacion EXCEL/CSV
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'EstadoPV',
			  headers:false, 
			  caption: {
				  title:'EstadoPV',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mydateformat = function(value) {
            //var date = new Date(value);
            //return date.toLocaleDateString();
			if (value !== "") {
                var effectiveDate = new Date(value);
                var month = effectiveDate.getMonth() + 1;
                var date = effectiveDate.getDate();
                var year = effectiveDate.getFullYear();
                return date + "-" + month + "-" + year;
            } else {
                return ""
            }
        };
		
		var dateFormat = "dd-MM-yyyy";
		var emptyColumn = "";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nomcoFecha="Fecha";
		var nomcoAeropuerto="Aeropuerto";
		var nomcoRazonSocial="RazonSocial";
		var nomcoComercio="Comercio";
		var nomcoNroTerminal="NroTerminal";
		var nomcoVentasBrutas="VentasBrutas";
		var nomcoVentasBrutasSNCRED="VentasBrutasSNCRED";
		var nomcoMetodo="ModImpresora";
		var nomcoModImpresora="ModImpresora";
		var nomcoTickets="Tickets";
		
		//Fecha 	Aeropuerto 	RazonSocial 	Comercio 	NroTerminal 	Ventas Brutas 	Ventas Brutas s/NCred 	Metodo 	ModImpresora 	

		vm.exportDataCSV = function () {
			vm.estadopvfiltrado = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto).filter($scope.filtraPorRazonSocial).filter($scope.filtraPorComercio));			
			vm.nombrearchivocsv= fechadesde + '_al_' + fechahasta;
			alasql('select * INTO CSV("EstadoPV_'+ vm.nombrearchivocsv + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?, ? \
				union all SELECT \
				mydateformat(fechaoperativa) as Fecha, aeropuerto as Aeropuerto, razonsocial as [Razon Social], \
				comercio as Comercio, ip as [Nro Terminal], ticketsmontoncredito as [Ventas Brutas],  ticketsmontoventas as [Ventas S/NCRED], ticketscantventas as Tickets, \
				metodo as Metodo, modimpresora as [Mod.Impresora] \
				FROM ?)', 
				[mystyle, nomcoFecha,nomcoAeropuerto,nomcoRazonSocial,nomcoComercio,nomcoNroTerminal,nomcoVentasBrutas,nomcoVentasBrutasSNCRED,nomcoTickets, nomcoMetodo,
				nomcoModImpresora,vm.estadopvfiltrado]);
			}
			
			
		vm.exportDataExcel = function () {
			vm.estadopvfiltrado = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto).filter($scope.filtraPorRazonSocial).filter($scope.filtraPorComercio));			
			vm.nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
			alasql('select * INTO XLSX("EstadoPV_'+ vm.nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?, ? \
				union all SELECT \
				mydateformat(fechaoperativa) as Fecha, aeropuerto as Aeropuerto, razonsocial as [Razon Social], \
				comercio as Comercio, ip as [Nro Terminal], ticketsmontoncredito as [Ventas Brutas],  ticketsmontoventas as [Ventas S/NCRED], ticketscantventas as Tickets, \
				metodo as Metodo, modimpresora as [Mod.Impresora] \
				FROM ?)', 
				[mystyle, nomcoFecha,nomcoAeropuerto,nomcoRazonSocial,nomcoComercio,nomcoNroTerminal,nomcoVentasBrutas,nomcoVentasBrutasSNCRED,nomcoTickets, nomcoMetodo,
				nomcoModImpresora,vm.estadopvfiltrado]);
		}
			
	
	}
		
})();


(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDialogController', VentamesdiaDialogController);

    VentamesdiaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventamesdia'];

    function VentamesdiaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventamesdia.id !== null) {
                Ventamesdia.update(vm.ventamesdia, onSaveSuccess, onSaveError);
            } else {
                Ventamesdia.save(vm.ventamesdia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventamesdiaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDetailController', VentamesdiaDetailController);

    VentamesdiaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventamesdia'];

    function VentamesdiaDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventamesdiaUpdate', function(event, result) {
            vm.ventamesdia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaDeleteController',VentamesdiaDeleteController);

    VentamesdiaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventamesdia'];

    function VentamesdiaDeleteController($uibModalInstance, entity, Ventamesdia) {
        var vm = this;

        vm.ventamesdia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventamesdia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventamesdia', {
            parent: 'entity',
            url: '/ventamesdia',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventamesdia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventamesdia/ventamesdias.html',
                    controller: 'VentamesdiaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventamesdia');
					$translatePartialLoader.addPart('zeta'); 
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventamesdia-detail', {
            parent: 'ventamesdia',
            url: '/ventamesdia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventamesdia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-detail.html',
                    controller: 'VentamesdiaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventamesdia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventamesdia', function($stateParams, Ventamesdia) {
                    return Ventamesdia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventamesdia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventamesdia-detail.edit', {
            parent: 'ventamesdia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventamesdia.new', {
            parent: 'ventamesdia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                razonsocial: null,
                                comercio: null,
                                nrolocal: null,
                                contrato: null,
                                total: null,
                                tickets: null,
								items: null,
								tax1a: null,
                                tax1b: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('ventamesdia');
                });
            }]
        })
        .state('ventamesdia.edit', {
            parent: 'ventamesdia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventamesdia.delete', {
            parent: 'ventamesdia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-delete-dialog.html',
                    controller: 'VentamesdiaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventamesdia', Ventamesdia)
		.factory('VentamesdiaFecha', VentamesdiaFecha); 

    Ventamesdia.$inject = ['$resource', 'DateUtils'];
	VentamesdiaFecha.$inject = ['$resource', 'DateUtils'];

	
    function Ventamesdia ($resource, DateUtils) {
        var resourceUrl =  'api/ventamesdias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentamesdiaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasmesdiasfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesdiaController', VentamesdiaController);

    VentamesdiaController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Ventamesdia",
		"VentamesdiaFecha",
		"ParseLinks",
		"AlertService"
		];

    function VentamesdiaController($scope,  $filter, $state, Ventamesdia, VentamesdiaFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		vm.onChangeDate = onChangeDate;
		vm.previousMonth = previousMonth;
		vm.today = today;
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";
		vm.arrayComercios = null;
		vm.totalizado= 0.00;
		 
		vm.toDate=JSON.parse( sessionStorage.getItem( 'ventasmesdiafechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'ventasmesdiafechadesde'), dateReviver );
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2018, 8, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };

		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'ventasmesdiafechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('ventasmesdiafechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  VentamesdiaFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				vm.listaComercios= new Map();
				vm.totalizado=0;
				result.forEach(function(vtadia){
						//vtadia.total = Math.round((vtadia.total/1.21) * 100) / 100;	//DIVIDIMOS POR IVA21 para tener el neto!!
						vtadia.total = Math.round(vtadia.total-(vtadia.tax1a+vtadia.tax1b));	//DIVIDIMOS POR IVA21 para tener el neto!!
						vm.totalizado += (vtadia.total);						
						if(!vm.listaComercios.has(vtadia.comercio)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaComercios.set(vtadia.comercio, true);    // set any value to Map
							}
						})  
				vm.arrayComercios = Array.from(vm.listaComercios.keys());//console.log(vm.arrayComercios);
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift("<Todos>");
				vm.ventamesdias = result;
			}
		  );
		}

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'VentasMesDia',
			  headers:false, 
			  caption: {
				  title:'VentasMesDia',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
		
		alasql.fn.mydateformat = function(value) {
            //var date = new Date(value);
            //return date.toLocaleDateString();
			if (value !== "") {
                var effectiveDate = new Date(value);
                var month = effectiveDate.getMonth() + 1;
                var date = effectiveDate.getDate();
                var year = effectiveDate.getFullYear();
                return date + "-" + month + "-" + year;
            } else {
                return ""
            }
        };
			
		var cenComercial = "SHOPPING";
		
		var fixedcolumn_NomTVenta = "TOTAL";		
		var dateFormat = "dd-MM-yyyy";
		var emptyColumn = "";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
		var nomcoContrato="Contrato";
		var nomcoFecha="Fecha";
		var nomcoAlicuota="Alicuota";
		var nomcoTVenta="T.Venta";
		var nomcoCantidad="Cantidad";
		var nomcoItems="Items";
		var nomcoImporte="Importe";
		var nomcoObservaciones="Observaciones";
		var nomcoCenCom="Cen.Com.";
		var nomcoLocal="Local";
		var nomcoNomComercial="Nom.Comercial";
		var nomcoRazonSocial="Razon Social";
		var nomcoNomTVenta="Nom/T.Venta";
		
		vm.exportDataExcel = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}
			
			alasql('select * INTO XLSX("VentaMesDia_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all SELECT cast(contrato as NUMBER) as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta, vm.vtamesdiafiltrada]);
			
			
			};
		
		vm.exportDataExcelFull = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}				
		
			alasql('select * INTO XLSX("VentaMesDiaFull_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?, ?,?,?,?, ?,?,?,? \
				union all SELECT cast(contrato as NUMBER) as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, items as Items, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoItems,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta,vm.vtamesdiafiltrada]);
			
			};
		
		vm.exportDataCSV = function () {
			
			vm.vtamesdiafiltrada = angular.copy(vm.ventamesdias.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				//nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio_' + $scope.vm.seleccionComercio.replace(/\s+/g, '-');
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtamesdiafiltrada[0].comercio.replace(/\s+/g, '-') + ')_RazonSocial(' + vm.vtamesdiafiltrada[0].razonsocial.replace(/\s+/g, '-') + ')_Contrato(' +  vm.vtamesdiafiltrada[0].contrato + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}				
					
			alasql('select * INTO CSV("VentaMesDia_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all select ?,?,?,?, ?,?,?,?, ?,?,?,? \
				union all SELECT contrato as Contrato, mydateformat(fecha) as Fecha, 1 as Alicuota, 1 as [T.Venta], tickets as Cantidad, total as Importe, ? as Observaciones, ? as  [Cen.Com.], nrolocal as Local, comercio as [Nom.Comercial], razonsocial as [Razon Social], ? as [Nom/T.Venta] \
				FROM ?)', 
				[mystyle, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn,emptyColumn, emptyColumn, emptyColumn, emptyColumn, nomcoContrato,nomcoFecha,nomcoAlicuota,nomcoTVenta,nomcoCantidad,nomcoImporte,nomcoObservaciones,nomcoCenCom,nomcoLocal, nomcoNomComercial,nomcoRazonSocial,nomcoNomTVenta,emptyColumn, cenComercial, fixedcolumn_NomTVenta, vm.vtamesdiafiltrada]);
			
			};	

			
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}

		
		function soloUnComercio()
		{
		if( !vm.seleccionComercio ||	!vm.seleccionComercio.length)
			return false;
		if("<Todos>" === vm.seleccionComercio)
			return false;
		return true;
		}
		  
		$scope.calcTotal = function(comercio){
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return 0;
			vm.totalizado=0;
			if( !vm.ventadetalles ||	!vm.ventadetalles.length)
				return 0;		
			var maxl=vm.ventamesdias.length;
			if("<Todos>" === $scope.vm.seleccionComercio){
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.ventamesdias[i];
					vm.totalizado += zet.total;
					}
				return vm.totalizado;
				}
			//
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.ventamesdias[i];
				if(zet.comercio === $scope.vm.seleccionComercio){
					vm.totalizado += zet.total;
					}
				}
			return vm.totalizado;
		}
		
		$scope.filtraPorComercio = function (ventamesdia) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio){
				return true;
				}
			if(ventamesdia.comercio === $scope.vm.seleccionComercio){
				return true;
				}	
			return false;
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDialogController', VentamesDialogController);

    VentamesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventames'];

    function VentamesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventames.id !== null) {
                Ventames.update(vm.ventames, onSaveSuccess, onSaveError);
            } else {
                Ventames.save(vm.ventames, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventamesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDetailController', VentamesDetailController);

    VentamesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventames'];

    function VentamesDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventamesUpdate', function(event, result) {
            vm.ventames = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDeleteController',VentamesDeleteController);

    VentamesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventames'];

    function VentamesDeleteController($uibModalInstance, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventames.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventames', {
            parent: 'entity',
            url: '/ventames',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventames.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventames/ventames.html',
                    controller: 'VentamesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventames');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventames-detail', {
            parent: 'ventames',
            url: '/ventames/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventames.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventames/ventames-detail.html',
                    controller: 'VentamesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventames');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventames', function($stateParams, Ventames) {
                    return Ventames.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventames',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventames-detail.edit', {
            parent: 'ventames-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventames.new', {
            parent: 'ventames',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                anio: null,
                                mes: null,
                                diasventa: null,
                                cantcomercios: null,
                                cantpv: null,
                                monto: null,
                                tickets: null,
                                items: null,
                                filecsv: null,
                                mdepefectivomonto: null,
                                mdepefectivocantidad: null,
                                mdeptarjetasmonto: null,
                                mdeptarjetascantidad: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('ventames');
                });
            }]
        })
        .state('ventames.edit', {
            parent: 'ventames',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventames.delete', {
            parent: 'ventames',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-delete-dialog.html',
                    controller: 'VentamesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventames', Ventames);

    Ventames.$inject = ['$resource'];

    function Ventames ($resource) {
        var resourceUrl =  'api/ventames/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesController', VentamesController);

    VentamesController.$inject = ['Ventames'];

    function VentamesController(Ventames) {

        var vm = this;

        vm.ventames = [];

        loadAll();

        function loadAll() {
            Ventames.query(function(result) {
                vm.ventames = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDialogController', VentahoyrealtimeDialogController);

    VentahoyrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventahoyrealtime.id !== null) {
                Ventahoyrealtime.update(vm.ventahoyrealtime, onSaveSuccess, onSaveError);
            } else {
                Ventahoyrealtime.save(vm.ventahoyrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventahoyrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaproceso = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDetailController', VentahoyrealtimeDetailController);

    VentahoyrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventahoyrealtimeUpdate', function(event, result) {
            vm.ventahoyrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeDeleteController',VentahoyrealtimeDeleteController);

    VentahoyrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventahoyrealtime'];

    function VentahoyrealtimeDeleteController($uibModalInstance, entity, Ventahoyrealtime) {
        var vm = this;

        vm.ventahoyrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventahoyrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventahoyrealtime', {
            parent: 'entity',
            url: '/ventahoyrealtime',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventahoyrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtimes.html',
                    controller: 'VentahoyrealtimeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventahoyrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventahoyrealtime-detail', {
            parent: 'ventahoyrealtime',
            url: '/ventahoyrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventahoyrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-detail.html',
                    controller: 'VentahoyrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventahoyrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventahoyrealtime', function($stateParams, Ventahoyrealtime) {
                    return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventahoyrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventahoyrealtime-detail.edit', {
            parent: 'ventahoyrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventahoyrealtime.new', {
            parent: 'ventahoyrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaproceso: null,
                                cantpv: null,
                                totalmonto: null,
                                totaltickets: null,
                                totalitems: null,
                                hora: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('ventahoyrealtime');
                });
            }]
        })
        .state('ventahoyrealtime.edit', {
            parent: 'ventahoyrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventahoyrealtime.delete', {
            parent: 'ventahoyrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-delete-dialog.html',
                    controller: 'VentahoyrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventahoyrealtime', Ventahoyrealtime);

    Ventahoyrealtime.$inject = ['$resource', 'DateUtils'];

    function Ventahoyrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/ventahoyrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //data.fechaproceso = DateUtils.convertDateTimeFromServer(data.fechaproceso);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeController', VentahoyrealtimeController);

    VentahoyrealtimeController.$inject = ['Ventahoyrealtime'];

    function VentahoyrealtimeController(Ventahoyrealtime) {

        var vm = this;

        vm.ventahoyrealtimes = [];

        loadAll();

        function loadAll() {
            Ventahoyrealtime.query(function(result) {
                vm.ventahoyrealtimes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDialogController', VentadetalleDialogController);

    VentadetalleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ventadetalle'];

    function VentadetalleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ventadetalle.id !== null) {
                Ventadetalle.update(vm.ventadetalle, onSaveSuccess, onSaveError);
            } else {
                Ventadetalle.save(vm.ventadetalle, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventadetalleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDetailController', VentadetalleDetailController);

    VentadetalleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventadetalle'];

    function VentadetalleDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventadetalleUpdate', function(event, result) {
            vm.ventadetalle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDeleteController',VentadetalleDeleteController);

    VentadetalleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ventadetalle'];

    function VentadetalleDeleteController($uibModalInstance, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ventadetalle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventadetalle', {
            parent: 'entity',
            url: '/ventadetalle',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventadetalle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventadetalle/ventadetalles.html',
                    controller: 'VentadetalleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventadetalle');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventadetalle-detail', {
            parent: 'ventadetalle',
            url: '/ventadetalle/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventadetalle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-detail.html',
                    controller: 'VentadetalleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventadetalle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventadetalle', function($stateParams, Ventadetalle) {
                    return Ventadetalle.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventadetalle',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventadetalle-detail.edit', {
            parent: 'ventadetalle-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventadetalle.new', {
            parent: 'ventadetalle',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comercio: null,
                                ip: null,
                                fecha: null,
                                nroticket: null,
                                esncredito: null,
                                cliente: null,
                                tipofactura: null,
                                operacion: null,
                                descripcion: null,
                                monto: null,
                                cantidad: null,
                                mdepcategoria: null,
								codigomoneda: null,
								categoria: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('ventadetalle');
                });
            }]
        })
        .state('ventadetalle.edit', {
            parent: 'ventadetalle',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-dialog.html',
                    controller: 'VentadetalleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventadetalle.delete', {
            parent: 'ventadetalle',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventadetalle/ventadetalle-delete-dialog.html',
                    controller: 'VentadetalleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventadetalle', function(Ventadetalle) {
                            return Ventadetalle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventadetalle', null, { reload: 'ventadetalle' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventadetalle', Ventadetalle)
		.factory('VentadetalleFecha', VentadetalleFecha); 

    Ventadetalle.$inject = ['$resource', 'DateUtils'];
	VentadetalleFecha.$inject = ['$resource', 'DateUtils'];

	
    function Ventadetalle ($resource, DateUtils) {
        var resourceUrl =  'api/ventadetalles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentadetalleFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasdetallesfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}

	
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleController', VentadetalleController);

    VentadetalleController.$inject = [
		"$scope",
		"$filter",
		"$state",
		"Ventadetalle",
		"VentadetalleFecha",
		"ParseLinks",
		"AlertService"
		];

    function VentadetalleController($scope,  $filter, $state, Ventadetalle, VentadetalleFecha,  ParseLinks,  AlertService) {
        var vm = this;
		vm.transition = transition;
		vm.fromDate = null;
		vm.toDate = null;
		vm.onChangeDate = onChangeDate;
		vm.previousMonth = previousMonth;
		vm.today = today;
        vm.listaComercios = null;
		vm.seleccionComercio = "<Todos>";
		vm.arrayComercios = null;
		vm.totalizado= 0;

		vm.toDate=JSON.parse( sessionStorage.getItem( 'ventasdetallefechahasta'), dateReviver );
		vm.fromDate=JSON.parse( sessionStorage.getItem( 'ventasdetallefechadesde'), dateReviver );
		if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
			vm.today();	
		}
		if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
			vm.previousMonth();
		}
		//
		vm.onChangeDate();
		//
		$scope.today = function() {
		  $scope.dt = new Date();
		};
		$scope.today();

		$scope.clear = function() {
		  $scope.dt = null;
		};

		$scope.inlineOptions = {
		  customClass: getDayClass,
		  minDate: new Date(),
		  showWeeks: true
		};

		//aca llamaban a disabled para sacar los weekends...
		$scope.dateOptions = {
		  formatYear: "yy",
		  maxDate: new Date(2040, 12, 31),
		  minDate: new Date(2018, 8, 1),
		  startingDay: 1
		};

		// Disable weekend selection (no lo usamos!)
		function disabled(data) {
		  var date = data.date,
			mode = data.mode;
		  return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
		}

		$scope.toggleMin = function() {
		  $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
			? null
			: new Date();
		  $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
		};

		$scope.toggleMin();

		$scope.open1 = function() {
		  $scope.popup1.opened = true;
		};

		$scope.open2 = function() {
		  $scope.popup2.opened = true;
		};

		$scope.setDate = function(year, month, day) {
		  $scope.dt = new Date(year, month, day);
		};

		$scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
		$scope.format = $scope.formats[0];
		$scope.altInputFormats = ["M!/d!/yyyy"];

		$scope.popup1 = {   opened: false  };

		$scope.popup2 = {   opened: false  };

		var tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		var afterTomorrow = new Date();
		afterTomorrow.setDate(tomorrow.getDate() + 1);
		$scope.events = [
		  {
			date: tomorrow,
			status: "full"
		  },
		  {
			date: afterTomorrow,
			status: "partially"
		  }
		];

		function getDayClass(data) {
		  var date = data.date,
			mode = data.mode;
		  if (mode === "day") {
			var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

			for (var i = 0; i < $scope.events.length; i++) {
			  var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

			  if (dayToCheck === currentDay) {
				return $scope.events[i].status;
			  }
			}
		  }

		  return "";
		}

		
		function onChangeDate() {
		  var dateFormat = "yyyy-MM-dd";
		  var fromDate = $filter("date")(vm.fromDate, dateFormat);
		  var toDate = $filter("date")(vm.toDate, dateFormat);

		  if (fromDate > toDate) {
			AlertService.error(
			  "Fecha Hasta debe ser mayor o igual que Fecha Desde"
			);
			return false;
		  }
		  
		  sessionStorage.setItem( 'ventasdetallefechadesde', JSON.stringify(new Date(vm.fromDate)));
		  sessionStorage.setItem('ventasdetallefechahasta', JSON.stringify(new Date(vm.toDate)));
		  
		  //aca llama al service.js y de ahi al WS backend
		  VentadetalleFecha.query(
			{ fromDate: fromDate, toDate: toDate },
			function(result) {
				vm.totalizado=0;
				vm.listaComercios= new Map();
				result.forEach(function(vtadia){
						vm.totalizado += 1;
						if(!vm.listaComercios.has(vtadia.comercio)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaComercios.set(vtadia.comercio, true);    // set any value to Map
							}
						})  
				vm.arrayComercios = Array.from(vm.listaComercios.keys());//console.log(vm.arrayComercios);
				vm.arrayComercios.sort();
				vm.arrayComercios.unshift("<Todos>");
				vm.ventadetalles = result;
				
			}
		  );
		}

		function transition() {
		  $state.transitionTo($state.$current, {
		  });
		}

		// Date picker configuration
		function today() {
		  // Today + 1 day - needed if the current day must be included
		  var today = new Date();
		  vm.toDate = new Date(
			today.getFullYear(),
			today.getMonth(),
			today.getDate()
		  ); //+1 seria manana
		}

		function previousMonth() {
		  var fromDate = new Date();
		  if (fromDate.getMonth() === 0) {
			fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
		  } else {
			fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
		  }

		  vm.fromDate = fromDate;
		}
		
		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'Ventasdetalle',
			  headers:false, 
			  caption: {
				  title:'Ventasdetalle',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};

		//		
		//
		alasql.fn.mydateformat = function(value) {
			if (value !== "") {
				const options = {
					timeZone:"America/Argentina/Buenos_Aires",
					hour12 : false,
					hour:  "2-digit",
					minute: "2-digit",
					second: "2-digit",
					year: "numeric",
					month:"2-digit",
					day:"2-digit"
				}
				return new Date(value).toLocaleTimeString("es-AR",options);
			} else {
		        return ""
            }
        };
				
		var dateFormat = "dd-MM-yyyy";
		var fechadesde = $filter("date")(vm.fromDate, dateFormat);
		var fechahasta = $filter("date")(vm.toDate, dateFormat);
		var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
		var ncol_comercio="Comercio";
		var ncol_ip="Ip";
		var ncol_fecha="Fecha";
		var ncol_nroticket="Ticket";
		var ncol_esncredito="EsNCredito";
		var ncol_cliente="Cliente";
		var ncol_codigomoneda="Moneda";
		var ncol_factura="TipoFactura";
		var ncol_operacion="Operacion";
		var ncol_descripcion="Descripcion";
		var ncol_monto="Monto";
		var ncol_cantidad="Cantidad";
		var ncol_mdepcategoria="CategoriaMdeP";
		var ncol_categoria="Categoria";
				
		//Comercio	Pv	Ip	Fecha	Ticket	EsNCredito	Cliente	Factura	Operacion	Descripcion	Monto	Cantidad	CategoriaMdeP
		vm.exportDataExcel = function () {
			
			vm.vtadetallefiltrada = angular.copy(vm.ventadetalles.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtadetallefiltrada[0].comercio.replace(/\s+/g, '-') + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}
			
			alasql('select * INTO XLSX("Ventadetalle_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?,?,?, ?,?,?,? \
				union all select comercio,ip,mydateformat(fecha) as fecha,nroticket,esncredito,cliente,codigomoneda,tipofactura,operacion,descripcion,monto,cantidad, mdepcategoria, categoria FROM ?)', 
				[mystyle,ncol_comercio,ncol_ip,ncol_fecha,ncol_nroticket,ncol_esncredito,ncol_cliente,ncol_codigomoneda,ncol_factura,ncol_operacion,ncol_descripcion,ncol_monto,ncol_cantidad, ncol_mdepcategoria,ncol_categoria,vm.vtadetallefiltrada]);
		
			};
		
		vm.exportDataCSV = function () {
			
			vm.vtadetallefiltrada = angular.copy(vm.ventadetalles.filter($scope.filtraPorComercio));			
			
			if(soloUnComercio()==true){
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta + '_Comercio(' + vm.vtadetallefiltrada[0].comercio.replace(/\s+/g, '-') + ')';
				}
			else {
				nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
				}	
				
			alasql('select * INTO CSV("Ventadetalle_'+ nombrearchivoexcel + '",?) from ( \
				select ?,?,?,?, ?,?,?,?,?,?, ?,?,?,? \
				union all select comercio,ip,mydateformat(fecha) as fecha,nroticket,esncredito,cliente,codigomoneda, tipofactura,operacion,descripcion,monto,cantidad, mdepcategoria, categoria  FROM ?)', 
				[mystyle,ncol_comercio,ncol_ip,ncol_fecha,ncol_nroticket,ncol_esncredito,ncol_cliente,ncol_codigomoneda, ncol_factura,ncol_operacion,ncol_descripcion,ncol_monto,ncol_cantidad, ncol_mdepcategoria,ncol_categoria, vm.vtadetallefiltrada]);
			};	

			
		//para storage de Date's
		function dateReviver( key, value ) {
			if ( isSerializedDate( value ) ) {
				return( new Date( value ) );
			}
			// If it's not a date-string, we want to return the value as-is. If we fail to return
			// a value, it will be omitted from the resultant data structure.
			return( value );
		}


		// I determine if the given value is a string that matches the serialized-date pattern.
		function isSerializedDate( value ) {
			// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
			var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
			return( isString( value ) && datePattern.test( value ) );
		}

		// I determine if the given value is a String.
		function isString( value ) {
			return( {}.toString.call( value ) === "[object String]" );
		}

		
		function soloUnComercio()
		{
		if( !vm.seleccionComercio ||	!vm.seleccionComercio.length)
			return false;
		if("<Todos>" === vm.seleccionComercio)
			return false;
		return true;
		}
		

		$scope.calcTotal = function(comercio){
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return 0;
			if( !vm.ventadetalles ||	!vm.ventadetalles.length)
				return 0;
			
			vm.totalizado=0;
			var maxl=vm.ventadetalles.length;
			if("<Todos>" === $scope.vm.seleccionComercio){
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.ventadetalles[i];
					vm.totalizado += 1;
					}
				return vm.totalizado;
				}
			//
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.ventadetalles[i];
				if(zet.comercio === $scope.vm.seleccionComercio){
					vm.totalizado += 1;
					}
				}
			return vm.totalizado;
		}
		

		
		$scope.filtraPorComercio = function (ventadetalle) {
			if( !$scope.vm.seleccionComercio ||	!$scope.vm.seleccionComercio.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionComercio)
				return true;
			if(ventadetalle.comercio === $scope.vm.seleccionComercio)
				return true;
			return false;
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentaDialogController', VentaDialogController);

    VentaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Venta', 'Zeta'];

    function VentaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Venta, Zeta) {
        var vm = this;

        vm.venta = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.zetas = Zeta.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.venta.id !== null) {
                Venta.update(vm.venta, onSaveSuccess, onSaveError);
            } else {
                Venta.save(vm.venta, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ventaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
		.controller('VentaDetailController', VentaDetailController);

    VentaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$filter','previousState', 'entity', 'Venta', 'Zeta'];
				
    function VentaDetailController($scope, $rootScope, $stateParams, $filter, previousState, entity, Venta, Zeta) {
		
		//$rootScopeProvider.digestTtl(500);
		
        var vm = this;
		
        vm.venta = entity;
        vm.previousState = previousState.name;
		vm.totalizado= 0.00;

        vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;
		
        vm.zetas = [];
        loadAll();

        function loadAll() {
            Zeta.queryByVenta({id: vm.venta.id}, function(result) {
                vm.zetas = result;
                vm.searchQuery = null;
				//
				vm.listaAeropuertos= new Map();
				result.forEach(function(zeta){
						if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				//https://codeburst.io/javascript-array-distinct-5edc93501dc4
							vm.listaAeropuertos.set(zeta.aeropuerto, true);    // set any value to Map
							}
						})  
				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");
				//
				var maxl=vm.zetas.length;
				$scope.vm.totalizado=0;
				for (var i = 0; i < maxl; i++) { 
				  var zet = vm.zetas[i];
				  //es + ncredito porque tienen signo negativo.
				  vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
				}
				});
        }
		

		function soloUnAeropuerto()
		{
		if( !vm.seleccionAeropuerto ||	!vm.seleccionAeropuerto.length)
			return false;
		if("<Todos>" === vm.seleccionAeropuerto)
			return false;
		return true;
		}
    	
		//gracias maestra: https://teamtreehouse.com/community/angularjs-building-a-calculate-total-function-on-ngrepeat
		$scope.calcTotal = function(aeropuerto){
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return 0;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				vm.totalizado=0;
				var maxl=vm.zetas.length;
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.zetas[i];
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				return vm.totalizado;
				}
			//
			vm.totalizado=0;
			var maxl=vm.zetas.length;
			for (var i = 0; i < maxl; i++) { 
				var zet = vm.zetas[i];
				if(zet.aeropuerto === $scope.vm.seleccionAeropuerto){
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				}
			return vm.totalizado;
		}

		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				/*
				vm.totalizado=0;
				var maxl=vm.zetas.length;
				for (var i = 0; i < maxl; i++) { 
					var zet = vm.zetas[i];
					vm.totalizado += (zet.ticketsmontoventas+zet.ticketsmontoncredito);
					}
				*/
				return true;
				}
			
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				//$scope.vm.totalizado = $scope.vm.totalizado + (zeta.ticketsmontoventas+zeta.ticketsmontoncredito);
				return true;	
				}
			return false;
		}
		
        var unsubscribe = $rootScope.$on('mVtasWebApp:ventaUpdate', function(event, result) {
            vm.venta = result;
        });
        $scope.$on('$destroy', unsubscribe);
				
		var mystyle = {
			  sheetid: 'Ventas dia',
			  headers:true, 
			  caption: {
				  title:'Ventas',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {1:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};
					
					
		var fechasel= vm.venta.fecha;
		//var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
		
		vm.exportDataExcel = function () {
			
			vm.zetasfiltrada = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto));			
		
			var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();		
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate()	+ '_Aeropuerto(' + vm.zetasfiltrada[0].aeropuerto.replace(/\s+/g, '-') + ')';
				}
				
			alasql('SELECT aeropuerto, comercio,ip, ticketsmontoventas as VentasMonto, totalefectivo, totaltarjeta, ticketscantventas as VentasTickets, itemscantventas as VentasItems, ticketsmontoventas/ticketscantventas as ticketpromedio, ticketsmontoncredito as NotasDeCreditosMonto,  ticketscantncredito as NotasDeCreditoTickets,itemscantncredito as NotasDeCreditoItems INTO XLSX("VentaDelDia_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.zetasfiltrada]);   
			};
			
		vm.exportDataCSV = function () {
			
			vm.zetasfiltrada = angular.copy(vm.zetas.filter($scope.filtraPorAeropuerto));			
			var nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate();
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= fechasel.getFullYear() + '' + (fechasel.getMonth()+1) + '' + fechasel.getDate()	+ '_Aeropuerto(' + vm.zetasfiltrada[0].aeropuerto.replace(/\s+/g, '-') + ')';
				}
			
			alasql('SELECT aeropuerto, comercio,ip, ticketsmontoventas as VentasMonto, totalefectivo, totaltarjeta, ticketscantventas as VentasTickets, itemscantventas as VentasItems, ticketsmontoventas/ticketscantventas as ticketpromedio,ticketsmontoncredito as NotasDeCreditosMonto,  ticketscantncredito as NotasDeCreditoTickets,itemscantncredito as NotasDeCreditoItems INTO CSV("VentaDelDia_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.zetasfiltrada]);   
			};			
    }
})();














(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentaDeleteController',VentaDeleteController);

    VentaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Venta'];

    function VentaDeleteController($uibModalInstance, entity, Venta) {
        var vm = this;

        vm.venta = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Venta.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('venta', {
            parent: 'entity',
            url: '/venta',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.venta.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/venta/ventas.html',
                    controller: 'VentaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('venta');
                    $translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('zeta'); 
                    return $translate.refresh();
                }]
            }
        })
        .state('venta-detail', {
            parent: 'venta',
            url: '/venta/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.venta.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/venta/venta-detail.html',
                    controller: 'VentaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('venta');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Venta', function($stateParams, Venta) {
                    return Venta.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'venta',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('venta-detail.edit', {
            parent: 'venta-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/venta/venta-dialog.html',
                    controller: 'VentaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Venta', function(Venta) {
                            return Venta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('venta.new', {
            parent: 'venta',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/venta/venta-dialog.html',
                    controller: 'VentaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                cantcomercios: null,
                                cantpv: null,
                                cantz: null,
                                ventasmonto: null,
                                ventastickets: null,
                                ventasitems: null,
                                ncreditomonto: null,
                                ncreditotickets: null,
                                ncreditoitems: null,
                                totalefectivo: null,
                                totaltarjeta: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('venta', null, { reload: 'venta' });
                }, function() {
                    $state.go('venta');
                });
            }]
        })
        .state('venta.edit', {
            parent: 'venta',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/venta/venta-dialog.html',
                    controller: 'VentaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Venta', function(Venta) {
                            return Venta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('venta', null, { reload: 'venta' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('venta.delete', {
            parent: 'venta',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/venta/venta-delete-dialog.html',
                    controller: 'VentaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Venta', function(Venta) {
                            return Venta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('venta', null, { reload: 'venta' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Venta', Venta)
		.factory('VentaFecha', VentaFecha);
		
    Venta.$inject = ['$resource', 'DateUtils'];
	VentaFecha.$inject = ['$resource', 'DateUtils'];
	
	function Venta ($resource, DateUtils) {
        var resourceUrl =  'api/ventas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
})();

(function() {
  "use strict";

  angular.module("mVtasWebApp").controller("VentaController", VentaController);

  VentaController.$inject = [
    "$scope",
    "$filter",
    "$state",
    "Venta",
	"VentaFecha",
    "ParseLinks",
    "AlertService"
  ];

  function VentaController(
    $scope,
    $filter,
    $state,
    Venta,
	VentaFecha,
    ParseLinks,
    AlertService
  ) {
    var vm = this;
    vm.transition = transition;
    vm.fromDate = null;
    vm.toDate = null;
	vm.onChangeDate = onChangeDate;
    vm.previousMonth = previousMonth;
    vm.today = today;
	vm.totalizado= 0.00;
	
	vm.toDate=JSON.parse( sessionStorage.getItem( 'fechahasta'), dateReviver );
	vm.fromDate=JSON.parse( sessionStorage.getItem( 'fechadesde'), dateReviver );
	if ((typeof vm.toDate == 'undefined') || (vm.toDate == null)){
		vm.today();	
	}
	if ((typeof vm.fromDate == 'undefined') || (vm.fromDate == null)){
		vm.previousMonth();
	}
	//
	vm.onChangeDate();
	//
    $scope.today = function() {
      $scope.dt = new Date();
    };
    $scope.today();

    $scope.clear = function() {
      $scope.dt = null;
    };

    $scope.inlineOptions = {
      customClass: getDayClass,
      minDate: new Date(),
      showWeeks: true
    };

    //aca llamaban a disabled para sacar los weekends...
    $scope.dateOptions = {
      formatYear: "yy",
      maxDate: new Date(2040, 12, 31),
      minDate: new Date(2018, 8, 1),
      startingDay: 1
    };

    // Disable weekend selection (no lo usamos!)
    function disabled(data) {
      var date = data.date,
        mode = data.mode;
      return mode === "day" && (date.getDay() === 0 || date.getDay() === 6);
    }

    $scope.toggleMin = function() {
      $scope.inlineOptions.minDate = $scope.inlineOptions.minDate
        ? null
        : new Date();
      $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };

    $scope.toggleMin();

    $scope.open1 = function() {
      $scope.popup1.opened = true;
    };

    $scope.open2 = function() {
      $scope.popup2.opened = true;
    };

    $scope.setDate = function(year, month, day) {
      $scope.dt = new Date(year, month, day);
    };

    $scope.formats = ["dd-MMMM-yyyy", "yyyy/MM/dd", "dd.MM.yyyy", "shortDate"];
    $scope.format = $scope.formats[0];
    $scope.altInputFormats = ["M!/d!/yyyy"];

    $scope.popup1 = {   opened: false  };

    $scope.popup2 = {   opened: false  };

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var afterTomorrow = new Date();
    afterTomorrow.setDate(tomorrow.getDate() + 1);
    $scope.events = [
      {
        date: tomorrow,
        status: "full"
      },
      {
        date: afterTomorrow,
        status: "partially"
      }
    ];

    function getDayClass(data) {
      var date = data.date,
        mode = data.mode;
      if (mode === "day") {
        var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

        for (var i = 0; i < $scope.events.length; i++) {
          var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

          if (dayToCheck === currentDay) {
            return $scope.events[i].status;
          }
        }
      }
      return "";
    }

    
    function onChangeDate() {
      var dateFormat = "yyyy-MM-dd";
      var fromDate = $filter("date")(vm.fromDate, dateFormat);
      var toDate = $filter("date")(vm.toDate, dateFormat);

      if (fromDate > toDate) {
        AlertService.error(
          "Fecha Hasta debe ser mayor o igual que Fecha Desde"
        );
        return false;
      }
	  
	  sessionStorage.setItem('fechadesde', JSON.stringify(new Date(vm.fromDate)));
	  sessionStorage.setItem('fechahasta', JSON.stringify(new Date(vm.toDate)));

	   console.log('from ' + fromDate);
	   console.log('to ' + toDate);
	  
      //aca llama al service.js y de ahi al WS backend
      VentaFecha.query(
        { fromDate: fromDate, toDate: toDate },
        function(result) {
			vm.ventas = result;
			vm.totalizado=0;
			var maxl=vm.ventas.length;
			for (var i = 0; i < maxl; i++) { 
			  var vta = vm.ventas[i];
			  vm.totalizado += (vta.ventasmonto-vta.ncreditomonto);
			}
        }
      );
	  
    }

    function transition() {
      $state.transitionTo($state.$current, {
      });
    }

    // Date picker configuration
    function today() {
      // Today + 1 day - needed if the current day must be included
      var today = new Date();
      vm.toDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      ); //+1 seria manana
    }

    function previousMonth() {
      var fromDate = new Date();
      if (fromDate.getMonth() === 0) {
        fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
      } else {
        fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1); //fromDate.getDate());
      }
      vm.fromDate = fromDate;
    }
	
	//exportacion a Excel/CSV
	var mystyle = {
		  sheetid: 'Ventas',
		  headers:true, 
		  caption: {
			  title:'Ventas',
			  style:'font-size: 50px; color:blue;' 
			},
			style:'font-size:30px',
			column: {style:{Font:{Bold:"1"}}},
			rows: {1:{style:{Font:{Color:"#FF0077"}}}},
			cells: {1:{1:{
				style: {Font:{Color:"#00FFFF"}}
			}}}
	};

	alasql.fn.mydateformat = function(dateStr) {
        var date = new Date(dateStr);
        return date.toLocaleDateString();
        };
	var dateFormat = "dd-MM-yyyy";
    var fechadesde = $filter("date")(vm.fromDate, dateFormat);
    var fechahasta = $filter("date")(vm.toDate, dateFormat);
	var nombrearchivoexcel= fechadesde + '_al_' + fechahasta;
	vm.exportDataExcel = function () {
		alasql('SELECT mydateformat(fecha) as fecha, cantcomercios, cantpv, ventasmonto, totalefectivo, totaltarjeta, ventastickets, ventasitems,ventasmonto/ventastickets as ticketpromedio, ncreditomonto, ncreditotickets, ncreditoitems INTO XLSX("VentaPeriodo_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.ventas]);   
		};
	vm.exportDataCSV = function () {
		alasql('SELECT mydateformat(fecha) as fecha, cantcomercios, cantpv, ventasmonto, totalefectivo, totaltarjeta, ventastickets, ventasitems,ventasmonto/ventastickets as ticketpromedio, ncreditomonto, ncreditotickets, ncreditoitems  INTO CSV("VentaPeriodo_'+ nombrearchivoexcel + '",?) FROM ?', [mystyle,vm.ventas]);   		
		};	
		
	//para storage de Date's
	function dateReviver( key, value ) {
		if ( isSerializedDate( value ) ) {
			return( new Date( value ) );
		}
		// If it's not a date-string, we want to return the value as-is. If we fail to return
		// a value, it will be omitted from the resultant data structure.
		return( value );
	}


	// I determine if the given value is a string that matches the serialized-date pattern.
	function isSerializedDate( value ) {
		// Dates are serialized in TZ format, example: '1981-12-20T04:00:14.000Z'.
		var datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
		return( isString( value ) && datePattern.test( value ) );
	}


	// I determine if the given value is a String.
	function isString( value ) {
		return( {}.toString.call( value ) === "[object String]" );
	}
  }
})();



 
(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDialogController', UsuariologDialogController);

    UsuariologDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Usuariolog'];

    function UsuariologDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.usuariolog.id !== null) {
                Usuariolog.update(vm.usuariolog, onSaveSuccess, onSaveError);
            } else {
                Usuariolog.save(vm.usuariolog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:usuariologUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDetailController', UsuariologDetailController);

    UsuariologDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Usuariolog'];

    function UsuariologDetailController($scope, $rootScope, $stateParams, previousState, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:usuariologUpdate', function(event, result) {
            vm.usuariolog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDeleteController',UsuariologDeleteController);

    UsuariologDeleteController.$inject = ['$uibModalInstance', 'entity', 'Usuariolog'];

    function UsuariologDeleteController($uibModalInstance, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Usuariolog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('usuariolog', {
            parent: 'entity',
            url: '/usuariolog?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.usuariolog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/usuariolog/usuariologs.html',
                    controller: 'UsuariologController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('usuariolog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('usuariolog-detail', {
            parent: 'usuariolog',
            url: '/usuariolog/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.usuariolog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/usuariolog/usuariolog-detail.html',
                    controller: 'UsuariologDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('usuariolog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Usuariolog', function($stateParams, Usuariolog) {
                    return Usuariolog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'usuariolog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('usuariolog-detail.edit', {
            parent: 'usuariolog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuariolog/usuariolog-dialog.html',
                    controller: 'UsuariologDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Usuariolog', function(Usuariolog) {
                            return Usuariolog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usuariolog.new', {
            parent: 'usuariolog',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuariolog/usuariolog-dialog.html',
                    controller: 'UsuariologDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                apellido: null,
                                username: null,
                                userid: null,
                                msg: null,
                                fecha: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('usuariolog', null, { reload: 'usuariolog' });
                }, function() {
                    $state.go('usuariolog');
                });
            }]
        })
        .state('usuariolog.edit', {
            parent: 'usuariolog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuariolog/usuariolog-dialog.html',
                    controller: 'UsuariologDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Usuariolog', function(Usuariolog) {
                            return Usuariolog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('usuariolog', null, { reload: 'usuariolog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usuariolog.delete', {
            parent: 'usuariolog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuariolog/usuariolog-delete-dialog.html',
                    controller: 'UsuariologDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Usuariolog', function(Usuariolog) {
                            return Usuariolog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('usuariolog', null, { reload: 'usuariolog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Usuariolog', Usuariolog);

    Usuariolog.$inject = ['$resource', 'DateUtils'];

    function Usuariolog ($resource, DateUtils) {
        var resourceUrl =  'api/usuariologs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologController', UsuariologController);

    UsuariologController.$inject = ['$state', 'Usuariolog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UsuariologController($state, Usuariolog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Usuariolog.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuariologs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuarioDialogController', UsuarioDialogController);

    UsuarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Usuario'];

    function UsuarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Usuario) {
        var vm = this;

        vm.usuario = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.usuario.id !== null) {
                Usuario.update(vm.usuario, onSaveSuccess, onSaveError);
            } else {
                Usuario.save(vm.usuario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:usuarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuarioDetailController', UsuarioDetailController);

    UsuarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Usuario'];

    function UsuarioDetailController($scope, $rootScope, $stateParams, previousState, entity, Usuario) {
        var vm = this;

        vm.usuario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:usuarioUpdate', function(event, result) {
            vm.usuario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuarioDeleteController',UsuarioDeleteController);

    UsuarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Usuario'];

    function UsuarioDeleteController($uibModalInstance, entity, Usuario) {
        var vm = this;

        vm.usuario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Usuario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('usuario', {
            parent: 'entity',
            url: '/usuario?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.usuario.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/usuario/usuarios.html',
                    controller: 'UsuarioController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'nombre,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('usuario');
                    $translatePartialLoader.addPart('rol');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('usuario-detail', {
            parent: 'usuario',
            url: '/usuario/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.usuario.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/usuario/usuario-detail.html',
                    controller: 'UsuarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('usuario');
                    $translatePartialLoader.addPart('rol');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Usuario', function($stateParams, Usuario) {
                    return Usuario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'usuario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('usuario-detail.edit', {
            parent: 'usuario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
                    controller: 'UsuarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Usuario', function(Usuario) {
                            return Usuario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usuario.new', {
            parent: 'usuario',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
                    controller: 'UsuarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                chatid: null,
                                nombre: null,
                                rol: null,
                                alarmason: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('usuario', null, { reload: 'usuario' });
                }, function() {
                    $state.go('usuario');
                });
            }]
        })
        .state('usuario.edit', {
            parent: 'usuario',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
                    controller: 'UsuarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Usuario', function(Usuario) {
                            return Usuario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('usuario', null, { reload: 'usuario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('usuario.delete', {
            parent: 'usuario',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/usuario/usuario-delete-dialog.html',
                    controller: 'UsuarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Usuario', function(Usuario) {
                            return Usuario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('usuario', null, { reload: 'usuario' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Usuario', Usuario);

    Usuario.$inject = ['$resource'];

    function Usuario ($resource) {
        var resourceUrl =  'api/usuarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuarioController', UsuarioController);

    UsuarioController.$inject = ['$state', 'Usuario', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UsuarioController($state, Usuario, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Usuario.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDialogController', TicketrealtimeDialogController);

    TicketrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketrealtime.id !== null) {
                Ticketrealtime.update(vm.ticketrealtime, onSaveSuccess, onSaveError);
            } else {
                Ticketrealtime.save(vm.ticketrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ticketrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;
        vm.datePickerOpenStatus.fechaproceso = false;
        vm.datePickerOpenStatus.fechaenvio = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDetailController', TicketrealtimeDetailController);

    TicketrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ticketrealtimeUpdate', function(event, result) {
            vm.ticketrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDeleteController',TicketrealtimeDeleteController);

    TicketrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDeleteController($uibModalInstance, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ticketrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticketrealtime', {
            parent: 'entity',
            url: '/ticketrealtime?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticketrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtimes.html',
                    controller: 'TicketrealtimeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticketrealtime-detail', {
            parent: 'ticketrealtime',
            url: '/ticketrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticketrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-detail.html',
                    controller: 'TicketrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticketrealtime', function($stateParams, Ticketrealtime) {
                    return Ticketrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticketrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticketrealtime-detail.edit', {
            parent: 'ticketrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticketrealtime.new', {
            parent: 'ticketrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                ip: null,
                                nroticket: null,
                                esncredito: null,
                                montototal: null,
                                cantitems: null,
                                cliente: null,
                                mediodepago: null,
                                nrolocal: null,
                                flagproceso: null,
                                fechaproceso: null,
                                fechaenvio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('ticketrealtime');
                });
            }]
        })
        .state('ticketrealtime.edit', {
            parent: 'ticketrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-dialog.html',
                    controller: 'TicketrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticketrealtime.delete', {
            parent: 'ticketrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticketrealtime/ticketrealtime-delete-dialog.html',
                    controller: 'TicketrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticketrealtime', function(Ticketrealtime) {
                            return Ticketrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticketrealtime', null, { reload: 'ticketrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ticketrealtime', Ticketrealtime);

    Ticketrealtime.$inject = ['$resource', 'DateUtils'];

    function Ticketrealtime ($resource, DateUtils) {
        var resourceUrl =  'api/ticketrealtimes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                        data.fechaproceso = DateUtils.convertDateTimeFromServer(data.fechaproceso);
                        data.fechaenvio = DateUtils.convertDateTimeFromServer(data.fechaenvio);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeController', TicketrealtimeController);

    TicketrealtimeController.$inject = ['$state', 'Ticketrealtime', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TicketrealtimeController($state, Ticketrealtime, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Ticketrealtime.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ticketrealtimes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketDialogController', TicketDialogController);

    TicketDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ticket', 'Item', 'Zeta'];

    function TicketDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ticket, Item, Zeta) {
        var vm = this;

        vm.ticket = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.items = Item.query();
        vm.zetas = Zeta.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticket.id !== null) {
                Ticket.update(vm.ticket, onSaveSuccess, onSaveError);
            } else {
                Ticket.save(vm.ticket, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:ticketUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticket', 'Item', 'Zeta'];

    function TicketDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticket, Item, Zeta) {
        var vm = this;

        vm.ticket = entity;
        vm.previousState = previousState.name;
		vm.items = [];
        loadAll();

        function loadAll() {
            Item.queryByTicket({id: vm.ticket.id}, function(result) {
                vm.items = result;
                vm.searchQuery = null;
            });
        } 

        var unsubscribe = $rootScope.$on('mVtasWebApp:ticketUpdate', function(event, result) {
            vm.ticket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketDeleteController',TicketDeleteController);

    TicketDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ticket'];

    function TicketDeleteController($uibModalInstance, entity, Ticket) {
        var vm = this;

        vm.ticket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ticket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket', {
            parent: 'entity',
            url: '/ticket?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/tickets.html',
                    controller: 'TicketController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('item'); 					
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-detail', {
            parent: 'ticket',
            url: '/ticket/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ticket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket/ticket-detail.html',
                    controller: 'TicketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticket', function($stateParams, Ticket) {
                    return Ticket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-detail.edit', {
            parent: 'ticket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket.new', {
            parent: 'ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                ip: null,
                                nropv: null,
                                nroz: null,
                                nroticket: null,
                                esncredito: null,
                                montototal: null,
                                cantitems: null,
                                cliente: null,
								codigomoneda: null,
                                tipofactura: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('ticket');
                });
            }]
        })
        .state('ticket.edit', {
            parent: 'ticket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket.delete', {
            parent: 'ticket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket/ticket-delete-dialog.html',
                    controller: 'TicketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticket', function(Ticket) {
                            return Ticket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket', null, { reload: 'ticket' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ticket', Ticket);

    Ticket.$inject = ['$resource', 'DateUtils'];

    function Ticket ($resource, DateUtils) {
        var resourceUrl =  'api/tickets/:id';

        return $resource(resourceUrl, {}, {
			'queryByZeta': {
                url: 'api/tickets/zetas/:id',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketController', TicketController);

    TicketController.$inject = ['$state', 'Ticket', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TicketController($state, Ticket, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Ticket.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tickets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDialogController', RubroDialogController);

    RubroDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Rubro', 'Comercio'];

    function RubroDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Rubro, Comercio) {
        var vm = this;

        vm.rubro = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rubro.id !== null) {
                Rubro.update(vm.rubro, onSaveSuccess, onSaveError);
            } else {
                Rubro.save(vm.rubro, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:rubroUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDetailController', RubroDetailController);

    RubroDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Rubro', 'Comercio'];

    function RubroDetailController($scope, $rootScope, $stateParams, previousState, entity, Rubro, Comercio) {
        var vm = this;

        vm.rubro = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:rubroUpdate', function(event, result) {
            vm.rubro = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDeleteController',RubroDeleteController);

    RubroDeleteController.$inject = ['$uibModalInstance', 'entity', 'Rubro'];

    function RubroDeleteController($uibModalInstance, entity, Rubro) {
        var vm = this;

        vm.rubro = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Rubro.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rubro', {
            parent: 'entity',
            url: '/rubro?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.rubro.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rubro/rubros.html',
                    controller: 'RubroController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rubro');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rubro-detail', {
            parent: 'rubro',
            url: '/rubro/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.rubro.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rubro/rubro-detail.html',
                    controller: 'RubroDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rubro');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Rubro', function($stateParams, Rubro) {
                    return Rubro.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rubro',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rubro-detail.edit', {
            parent: 'rubro-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rubro/rubro-dialog.html',
                    controller: 'RubroDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rubro', function(Rubro) {
                            return Rubro.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rubro.new', {
            parent: 'rubro',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rubro/rubro-dialog.html',
                    controller: 'RubroDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descripcion: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rubro', null, { reload: 'rubro' });
                }, function() {
                    $state.go('rubro');
                });
            }]
        })
        .state('rubro.edit', {
            parent: 'rubro',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rubro/rubro-dialog.html',
                    controller: 'RubroDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rubro', function(Rubro) {
                            return Rubro.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rubro', null, { reload: 'rubro' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rubro.delete', {
            parent: 'rubro',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rubro/rubro-delete-dialog.html',
                    controller: 'RubroDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Rubro', function(Rubro) {
                            return Rubro.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rubro', null, { reload: 'rubro' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Rubro', Rubro);

    Rubro.$inject = ['$resource'];

    function Rubro ($resource) {
        var resourceUrl =  'api/rubros/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroController', RubroController);

    RubroController.$inject = ['$state', 'Rubro', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RubroController($state, Rubro, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Rubro.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rubros = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RegionDialogController', RegionDialogController);

    RegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Region', 'Provincia', 'Pais'];

    function RegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Region, Provincia, Pais) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.save = save;
        vm.provincias = Provincia.query();
        vm.pais = Pais.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.region.id !== null) {
                Region.update(vm.region, onSaveSuccess, onSaveError);
            } else {
                Region.save(vm.region, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:regionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RegionDetailController', RegionDetailController);

    RegionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Region', 'Provincia', 'Pais'];

    function RegionDetailController($scope, $rootScope, $stateParams, previousState, entity, Region, Provincia, Pais) {
        var vm = this;

        vm.region = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:regionUpdate', function(event, result) {
            vm.region = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RegionDeleteController',RegionDeleteController);

    RegionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Region'];

    function RegionDeleteController($uibModalInstance, entity, Region) {
        var vm = this;

        vm.region = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Region.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('region', {
            parent: 'entity',
            url: '/region?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.region.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/regions.html',
                    controller: 'RegionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('region-detail', {
            parent: 'region',
            url: '/region/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.region.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/region/region-detail.html',
                    controller: 'RegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('region');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Region', function($stateParams, Region) {
                    return Region.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'region',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('region-detail.edit', {
            parent: 'region-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.new', {
            parent: 'region',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                habilitado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('region');
                });
            }]
        })
        .state('region.edit', {
            parent: 'region',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-dialog.html',
                    controller: 'RegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('region.delete', {
            parent: 'region',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/region/region-delete-dialog.html',
                    controller: 'RegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Region', function(Region) {
                            return Region.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('region', null, { reload: 'region' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Region', Region);

    Region.$inject = ['$resource'];

    function Region ($resource) {
        var resourceUrl =  'api/regions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RegionController', RegionController);

    RegionController.$inject = ['$state', 'Region', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RegionController($state, Region, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Region.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.regions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDialogController', PvlogDialogController);

    PvlogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pvlog'];

    function PvlogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pvlog.id !== null) {
                Pvlog.update(vm.pvlog, onSaveSuccess, onSaveError);
            } else {
                Pvlog.save(vm.pvlog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:pvlogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDetailController', PvlogDetailController);

    PvlogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pvlog'];

    function PvlogDetailController($scope, $rootScope, $stateParams, previousState, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:pvlogUpdate', function(event, result) {
            vm.pvlog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDeleteController',PvlogDeleteController);

    PvlogDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pvlog'];

    function PvlogDeleteController($uibModalInstance, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pvlog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pvlog', {
            parent: 'entity',
            url: '/pvlog?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pvlog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pvlog/pvlogs.html',
                    controller: 'PvlogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pvlog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pvlog-detail', {
            parent: 'pvlog',
            url: '/pvlog/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pvlog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pvlog/pvlog-detail.html',
                    controller: 'PvlogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pvlog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pvlog', function($stateParams, Pvlog) {
                    return Pvlog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pvlog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pvlog-detail.edit', {
            parent: 'pvlog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pvlog.new', {
            parent: 'pvlog',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                nroterminal: null,
                                versiondesoft: null,
                                cpuserial: null,
                                cputemp: null,
                                cpureboot: null,
                                tottxbytes: null,
                                toterrconex: null,
                                serialok: null,
                                serialreopen: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('pvlog');
                });
            }]
        })
        .state('pvlog.edit', {
            parent: 'pvlog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-dialog.html',
                    controller: 'PvlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pvlog.delete', {
            parent: 'pvlog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pvlog/pvlog-delete-dialog.html',
                    controller: 'PvlogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pvlog', function(Pvlog) {
                            return Pvlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pvlog', null, { reload: 'pvlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Pvlog', Pvlog);

    Pvlog.$inject = ['$resource', 'DateUtils'];

    function Pvlog ($resource, DateUtils) {
        var resourceUrl =  'api/pvlogs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogController', PvlogController);

    PvlogController.$inject = ['$state', 'Pvlog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PvlogController($state, Pvlog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;
        vm.getTotErrConexClass=getTotErrConexClass
        vm.getSerialReopenClass= getSerialReopenClass;
        vm.getTemperatureClass= getTemperatureClass;
        vm.getLabelClass = getLabelClass;
        vm.getLabelClassText = getLabelClassText;       
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        function getTotErrConexClass (reconn) {
            if (reconn > 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }

        function getSerialReopenClass (reopen) {
            if (reopen > 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }

        function getLabelClass (statusState) {
            if (statusState === 0) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }
             
        function getTemperatureClass (temperature) {
            if (temperature >= 60) {
                return 'label-danger';
            } else {
                return 'label-success';
            }
        }
        
        function getLabelClassText (statusState) {
            if (statusState === 1) {
                return 'OK';
            } else {
                return 'ERROR';
            }
        }
        
        loadAll();

        function loadAll () {
            Pvlog.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pvlogs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDialogController', PvDialogController);

    PvDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pv', 'Modelosdeimpresora', 'Comercio'];

    function PvDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pv, Modelosdeimpresora, Comercio) {
        var vm = this;

        vm.pv = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modelosdeimpresoras = Modelosdeimpresora.query();
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pv.id !== null) {
                Pv.update(vm.pv, onSaveSuccess, onSaveError);
            } else {
                Pv.save(vm.pv, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:pvUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDetailController', PvDetailController);

    PvDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pv', 'Modelosdeimpresora', 'Comercio'];

    function PvDetailController($scope, $rootScope, $stateParams, previousState, entity, Pv, Modelosdeimpresora, Comercio) {
        var vm = this;

        vm.pv = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:pvUpdate', function(event, result) {
            vm.pv = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDeleteController',PvDeleteController);

    PvDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pv'];

    function PvDeleteController($uibModalInstance, entity, Pv) {
        var vm = this;

        vm.pv = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pv.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pv', {
            parent: 'entity',
            url: '/pv?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pv.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pv/pvs.html',
                    controller: 'PvController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'ip,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pv');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pv-detail', {
            parent: 'pv',
            url: '/pv/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pv.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pv/pv-detail.html',
                    controller: 'PvDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pv');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pv', function($stateParams, Pv) {
                    return Pv.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pv',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pv-detail.edit', {
            parent: 'pv-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pv/pv-dialog.html',
                    controller: 'PvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pv', function(Pv) {
                            return Pv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pv.new', {
            parent: 'pv',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pv/pv-dialog.html',
                    controller: 'PvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nropv: null,
                                ip: null,
                                specialmode: null,
                                habilitado: null,
                                id: null,
								comentario: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pv', null, { reload: 'pv' });
                }, function() {
                    $state.go('pv');
                });
            }]
        })
        .state('pv.edit', {
            parent: 'pv',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pv/pv-dialog.html',
                    controller: 'PvDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pv', function(Pv) {
                            return Pv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pv', null, { reload: 'pv' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pv.delete', {
            parent: 'pv',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pv/pv-delete-dialog.html',
                    controller: 'PvDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pv', function(Pv) {
                            return Pv.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pv', null, { reload: 'pv' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Pv', Pv);

    Pv.$inject = ['$resource'];

    function Pv ($resource) {
        var resourceUrl =  'api/pvs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvController', PvController);

    PvController.$inject = ['$state', 'Pv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$scope'];

    function PvController($state, Pv, ParseLinks, AlertService, paginationConstants, pagingParams,$scope) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.getLabelClassText = getLabelClassText;       
        vm.getLabelClass = getLabelClass;


		//$scope.names = ["SNIFFER", "DEMANDA"];
		vm.names = ["SNIFFER", "DEMANDA"];

        loadAll();

        function getLabelClass (statusState) {
			if (statusState === 1) {
                return 'label-success';
            } else {
				return 'label-primary';
            }
        }

        function getLabelClassText (statusState) {
            if (statusState === 1) {
                return 'DEMANDA';
            } else {
                return 'SNIFFER';
            }
        }

        function loadAll () {
            Pv.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pvs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ProvinciaDialogController', ProvinciaDialogController);

    ProvinciaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Provincia', 'Aeropuerto', 'Region'];

    function ProvinciaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Provincia, Aeropuerto, Region) {
        var vm = this;

        vm.provincia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.aeropuertos = Aeropuerto.query();
        vm.regions = Region.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.provincia.id !== null) {
                Provincia.update(vm.provincia, onSaveSuccess, onSaveError);
            } else {
                Provincia.save(vm.provincia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:provinciaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ProvinciaDetailController', ProvinciaDetailController);

    ProvinciaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provincia', 'Aeropuerto', 'Region'];

    function ProvinciaDetailController($scope, $rootScope, $stateParams, previousState, entity, Provincia, Aeropuerto, Region) {
        var vm = this;

        vm.provincia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:provinciaUpdate', function(event, result) {
            vm.provincia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ProvinciaDeleteController',ProvinciaDeleteController);

    ProvinciaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provincia'];

    function ProvinciaDeleteController($uibModalInstance, entity, Provincia) {
        var vm = this;

        vm.provincia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provincia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('provincia', {
            parent: 'entity',
            url: '/provincia?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.provincia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provincia/provincias.html',
                    controller: 'ProvinciaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provincia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('provincia-detail', {
            parent: 'provincia',
            url: '/provincia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.provincia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/provincia/provincia-detail.html',
                    controller: 'ProvinciaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('provincia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Provincia', function($stateParams, Provincia) {
                    return Provincia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'provincia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('provincia-detail.edit', {
            parent: 'provincia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provincia.new', {
            parent: 'provincia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                habilitado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('provincia');
                });
            }]
        })
        .state('provincia.edit', {
            parent: 'provincia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-dialog.html',
                    controller: 'ProvinciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('provincia.delete', {
            parent: 'provincia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/provincia/provincia-delete-dialog.html',
                    controller: 'ProvinciaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Provincia', function(Provincia) {
                            return Provincia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('provincia', null, { reload: 'provincia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Provincia', Provincia);

    Provincia.$inject = ['$resource'];

    function Provincia ($resource) {
        var resourceUrl =  'api/provincias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ProvinciaController', ProvinciaController);

    ProvinciaController.$inject = ['$state', 'Provincia', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProvinciaController($state, Provincia, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Provincia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.provincias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PaisDialogController', PaisDialogController);

    PaisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pais', 'Region'];

    function PaisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pais, Region) {
        var vm = this;

        vm.pais = entity;
        vm.clear = clear;
        vm.save = save;
        vm.regions = Region.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pais.id !== null) {
                Pais.update(vm.pais, onSaveSuccess, onSaveError);
            } else {
                Pais.save(vm.pais, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:paisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PaisDetailController', PaisDetailController);

    PaisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pais', 'Region'];

    function PaisDetailController($scope, $rootScope, $stateParams, previousState, entity, Pais, Region) {
        var vm = this;

        vm.pais = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:paisUpdate', function(event, result) {
            vm.pais = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PaisDeleteController',PaisDeleteController);

    PaisDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pais'];

    function PaisDeleteController($uibModalInstance, entity, Pais) {
        var vm = this;

        vm.pais = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pais.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pais', {
            parent: 'entity',
            url: '/pais?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pais.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pais/pais.html',
                    controller: 'PaisController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pais');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pais-detail', {
            parent: 'pais',
            url: '/pais/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.pais.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pais/pais-detail.html',
                    controller: 'PaisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pais');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pais', function($stateParams, Pais) {
                    return Pais.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pais',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pais-detail.edit', {
            parent: 'pais-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pais.new', {
            parent: 'pais',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                habilitado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('pais');
                });
            }]
        })
        .state('pais.edit', {
            parent: 'pais',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pais.delete', {
            parent: 'pais',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-delete-dialog.html',
                    controller: 'PaisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Pais', Pais);

    Pais.$inject = ['$resource'];

    function Pais ($resource) {
        var resourceUrl =  'api/pais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PaisController', PaisController);

    PaisController.$inject = ['$state', 'Pais', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PaisController($state, Pais, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Pais.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pais = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDialogController', MonitorDialogController);

    MonitorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Monitor'];

    function MonitorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.monitor.id !== null) {
                Monitor.update(vm.monitor, onSaveSuccess, onSaveError);
            } else {
                Monitor.save(vm.monitor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:monitorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDetailController', MonitorDetailController);

    MonitorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Monitor'];

    function MonitorDetailController($scope, $rootScope, $stateParams, previousState, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:monitorUpdate', function(event, result) {
            vm.monitor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorDeleteController',MonitorDeleteController);

    MonitorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Monitor'];

    function MonitorDeleteController($uibModalInstance, entity, Monitor) {
        var vm = this;

        vm.monitor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Monitor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('monitor', {
            parent: 'entity',
            url: '/monitor?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.monitor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitor/monitors.html',
                    controller: 'MonitorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('monitor-detail', {
            parent: 'monitor',
            url: '/monitor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.monitor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitor/monitor-detail.html',
                    controller: 'MonitorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Monitor', function($stateParams, Monitor) {
                    return Monitor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'monitor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('monitor-detail.edit', {
            parent: 'monitor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitor.new', {
            parent: 'monitor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                nroterminal: null,
                                versiondesoft: null,
                                cpuserial: null,
                                cputemp: null,
                                cpureboot: null,
                                tottxbytes: null,
                                toterrconex: null,
                                serialok: null,
                                serialreopen: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('monitor');
                });
            }]
        })
        .state('monitor.edit', {
            parent: 'monitor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-dialog.html',
                    controller: 'MonitorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitor.delete', {
            parent: 'monitor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitor/monitor-delete-dialog.html',
                    controller: 'MonitorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Monitor', function(Monitor) {
                            return Monitor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitor', null, { reload: 'monitor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Monitor', Monitor);

    Monitor.$inject = ['$resource', 'DateUtils'];

    function Monitor ($resource, DateUtils) {
        var resourceUrl =  'api/monitors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonitorController', MonitorController);

    MonitorController.$inject = ['$state', 'Monitor', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MonitorController($state, Monitor, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Monitor.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.monitors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDialogController', MonedaDialogController);

    MonedaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Moneda', 'Comercio'];

    function MonedaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Moneda, Comercio) {
        var vm = this;

        vm.moneda = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.moneda.id !== null) {
                Moneda.update(vm.moneda, onSaveSuccess, onSaveError);
            } else {
                Moneda.save(vm.moneda, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:monedaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDetailController', MonedaDetailController);

    MonedaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Moneda', 'Comercio'];

    function MonedaDetailController($scope, $rootScope, $stateParams, previousState, entity, Moneda, Comercio) {
        var vm = this;

        vm.moneda = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:monedaUpdate', function(event, result) {
            vm.moneda = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDeleteController',MonedaDeleteController);

    MonedaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Moneda'];

    function MonedaDeleteController($uibModalInstance, entity, Moneda) {
        var vm = this;

        vm.moneda = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Moneda.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moneda', {
            parent: 'entity',
            url: '/moneda?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.moneda.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moneda/monedas.html',
                    controller: 'MonedaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('moneda');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('moneda-detail', {
            parent: 'moneda',
            url: '/moneda/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.moneda.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/moneda/moneda-detail.html',
                    controller: 'MonedaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('moneda');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Moneda', function($stateParams, Moneda) {
                    return Moneda.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'moneda',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('moneda-detail.edit', {
            parent: 'moneda-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moneda.new', {
            parent: 'moneda',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descripcion: null,
                                codigo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('moneda');
                });
            }]
        })
        .state('moneda.edit', {
            parent: 'moneda',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-dialog.html',
                    controller: 'MonedaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('moneda.delete', {
            parent: 'moneda',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/moneda/moneda-delete-dialog.html',
                    controller: 'MonedaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Moneda', function(Moneda) {
                            return Moneda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('moneda', null, { reload: 'moneda' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Moneda', Moneda);

    Moneda.$inject = ['$resource'];

    function Moneda ($resource) {
        var resourceUrl =  'api/monedas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaController', MonedaController);

    MonedaController.$inject = ['$state', 'Moneda', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MonedaController($state, Moneda, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Moneda.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.monedas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDialogController', ModelosdeimpresoraDialogController);

    ModelosdeimpresoraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modelosdeimpresora', 'Pv'];

    function ModelosdeimpresoraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Modelosdeimpresora, Pv) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pvs = Pv.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modelosdeimpresora.id !== null) {
                Modelosdeimpresora.update(vm.modelosdeimpresora, onSaveSuccess, onSaveError);
            } else {
                Modelosdeimpresora.save(vm.modelosdeimpresora, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:modelosdeimpresoraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDetailController', ModelosdeimpresoraDetailController);

    ModelosdeimpresoraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Modelosdeimpresora', 'Pv'];

    function ModelosdeimpresoraDetailController($scope, $rootScope, $stateParams, previousState, entity, Modelosdeimpresora, Pv) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:modelosdeimpresoraUpdate', function(event, result) {
            vm.modelosdeimpresora = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDeleteController',ModelosdeimpresoraDeleteController);

    ModelosdeimpresoraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modelosdeimpresora'];

    function ModelosdeimpresoraDeleteController($uibModalInstance, entity, Modelosdeimpresora) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modelosdeimpresora.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modelosdeimpresora', {
            parent: 'entity',
            url: '/modelosdeimpresora',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.modelosdeimpresora.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresoras.html',
                    controller: 'ModelosdeimpresoraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelosdeimpresora');
                    $translatePartialLoader.addPart('protocolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modelosdeimpresora-detail', {
            parent: 'modelosdeimpresora',
            url: '/modelosdeimpresora/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.modelosdeimpresora.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-detail.html',
                    controller: 'ModelosdeimpresoraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelosdeimpresora');
                    $translatePartialLoader.addPart('protocolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Modelosdeimpresora', function($stateParams, Modelosdeimpresora) {
                    return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modelosdeimpresora',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modelosdeimpresora-detail.edit', {
            parent: 'modelosdeimpresora-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modelosdeimpresora.new', {
            parent: 'modelosdeimpresora',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descripcion: null,
                                protocolo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('modelosdeimpresora');
                });
            }]
        })
        .state('modelosdeimpresora.edit', {
            parent: 'modelosdeimpresora',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html',
                    controller: 'ModelosdeimpresoraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modelosdeimpresora.delete', {
            parent: 'modelosdeimpresora',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modelosdeimpresora/modelosdeimpresora-delete-dialog.html',
                    controller: 'ModelosdeimpresoraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modelosdeimpresora', function(Modelosdeimpresora) {
                            return Modelosdeimpresora.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modelosdeimpresora', null, { reload: 'modelosdeimpresora' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Modelosdeimpresora', Modelosdeimpresora);

    Modelosdeimpresora.$inject = ['$resource'];

    function Modelosdeimpresora ($resource) {
        var resourceUrl =  'api/modelosdeimpresoras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraController', ModelosdeimpresoraController);

    ModelosdeimpresoraController.$inject = ['Modelosdeimpresora'];

    function ModelosdeimpresoraController(Modelosdeimpresora) {

        var vm = this;

        vm.modelosdeimpresoras = [];

        loadAll();

        function loadAll() {
            Modelosdeimpresora.query(function(result) {
                vm.modelosdeimpresoras = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ItemDialogController', ItemDialogController);

    ItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Item', 'Ticket'];

    function ItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Item, Ticket) {
        var vm = this;

        vm.item = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.tickets = Ticket.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.item.id !== null) {
                Item.update(vm.item, onSaveSuccess, onSaveError);
            } else {
                Item.save(vm.item, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:itemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fecha = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ItemDetailController', ItemDetailController);

    ItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Item', 'Ticket'];

    function ItemDetailController($scope, $rootScope, $stateParams, previousState, entity, Item, Ticket) {
        var vm = this;

        vm.item = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:itemUpdate', function(event, result) {
            vm.item = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ItemDeleteController',ItemDeleteController);

    ItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Item'];

    function ItemDeleteController($uibModalInstance, entity, Item) {
        var vm = this;

        vm.item = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Item.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('item', {
            parent: 'entity',
            url: '/item?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.item.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/item/items.html',
                    controller: 'ItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('item');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('item-detail', {
            parent: 'item',
            url: '/item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.item.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/item/item-detail.html',
                    controller: 'ItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('item');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Item', function($stateParams, Item) {
                    return Item.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('item-detail.edit', {
            parent: 'item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/item/item-dialog.html',
                    controller: 'ItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Item', function(Item) {
                            return Item.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('item.new', {
            parent: 'item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/item/item-dialog.html',
                    controller: 'ItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                ip: null,
                                nropv: null,
                                nroz: null,
                                nroticket: null,
                                operacion: null,
                                descripcion: null,
                                monto: null,
                                cantidad: null,
                                cancelado: null,
                                mdepcategoria: null,
                                descextra1: null,
                                descextra2: null,
                                descextra3: null,
								unidades: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('item', null, { reload: 'item' });
                }, function() {
                    $state.go('item');
                });
            }]
        })
        .state('item.edit', {
            parent: 'item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/item/item-dialog.html',
                    controller: 'ItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Item', function(Item) {
                            return Item.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('item', null, { reload: 'item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('item.delete', {
            parent: 'item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/item/item-delete-dialog.html',
                    controller: 'ItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Item', function(Item) {
                            return Item.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('item', null, { reload: 'item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Item', Item);

    Item.$inject = ['$resource', 'DateUtils'];

    function Item ($resource, DateUtils) {
        var resourceUrl =  'api/items/:id';

        return $resource(resourceUrl, {}, {
			'queryByTicket': {
                url: 'api/items/tickets/:id',
                method: 'GET',
                isArray: true
            },            

            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ItemController', ItemController);

    ItemController.$inject = ['$state', 'Item', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ItemController($state, Item, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Item.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.items = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('EstadoactualDetailController', EstadoactualDetailController);

    EstadoactualDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Estadoactual'];

    function EstadoactualDetailController($scope, $rootScope, $stateParams, previousState, entity, Estadoactual) {
        var vm = this;

        vm.estadoactual = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:estadoactualUpdate', function(event, result) {
            vm.estadoactual = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('estadoactual', {
            parent: 'entity',
            url: '/estadoactual',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.estadoactual.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estadoactual/estadoactuals.html',
                    controller: 'EstadoactualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estadoactual');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('estadoactual-detail', {
            parent: 'estadoactual',
            url: '/estadoactual/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.estadoactual.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estadoactual/estadoactual-detail.html',
                    controller: 'EstadoactualDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estadoactual');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Estadoactual', function($stateParams, Estadoactual) {
                    return Estadoactual.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'estadoactual',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('estadoactual-detail.edit', {
            parent: 'estadoactual-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estadoactual.new', {
            parent: 'estadoactual',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechacontrol: null,
                                aeropuerto: null,
                                comercio: null,
                                nroterminal: null,
                                status: null,
                                razon: null,
								metodo: null,
								impresora: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('estadoactual');
                });
            }]
        })
        .state('estadoactual.edit', {
            parent: 'estadoactual',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-dialog.html',
                    controller: 'EstadoactualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estadoactual.delete', {
            parent: 'estadoactual',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estadoactual/estadoactual-delete-dialog.html',
                    controller: 'EstadoactualDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Estadoactual', function(Estadoactual) {
                            return Estadoactual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estadoactual', null, { reload: 'estadoactual' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Estadoactual', Estadoactual);

    Estadoactual.$inject = ['$resource', 'DateUtils'];

    function Estadoactual ($resource, DateUtils) {
        var resourceUrl =  'api/estadoactuals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechacontrol = DateUtils.convertDateTimeFromServer(data.fechacontrol);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('EstadoactualController', EstadoactualController);
	
	EstadoactualController.$inject = ['$scope', '$filter', 'Estadoactual'];
	
    function EstadoactualController($scope, $filter, Estadoactual) {

        var vm = this;
		vm.getLabelClass = getLabelClass;
        vm.estadoactuals = [];
		vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;


		function soloUnAeropuerto()
		{
		if( !vm.seleccionAeropuerto ||	!vm.seleccionAeropuerto.length)
			return false;
		if("<Todos>" === vm.seleccionAeropuerto)
			return false;
		return true;
		}

		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'EstadoActualDispositivos',
			  headers:false, 
			  caption: {
				  title:'EstadoActualDispositivos',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};

		const options = {
					timeZone:"America/Argentina/Buenos_Aires",
					hour12 : false,
					hour:  "2-digit",
					minute: "2-digit",
					second: "2-digit",
					year: "numeric",
					month:"2-digit",
					day:"2-digit"
				};
				
		alasql.fn.mydateformat = function(value) {
			if (value !== "") {
				
				return new Date(value).toLocaleTimeString("es-AR",options);
			} else {
		        return ""
            }
        };
		
		function GetFormattedDate(date) {
			return new Date(date).toLocaleString("es-AR", options);
		}
	
		var ncol_fechacontrol="FechaControl";
		var ncol_aeropuerto="Aeropuerto";
		var ncol_comercio="Comercio";
		var ncol_terminal="Terminal";
		var ncol_status="Status";
		var ncol_razon="Razon";
		var ncol_metodo="Metodo";
		var ncol_impresora="Impresora";
		
		var nombrearchivoexcel= "";

		vm.exportDataExcel = function () {
						
			vm.estadoactualsfiltrada = angular.copy(vm.estadoactuals.filter($scope.filtraPorAeropuerto));			
			
			var fechaRep= GetFormattedDate(vm.estadoactualsfiltrada[0].fechacontrol);
			//01234567890123456789
			//25/06/2022, 19:10:01
			var fechaRepAAAAMMDDHHMMSS= '_'+fechaRep.substring(6,10) + fechaRep.substring(3,5) + fechaRep.substring(0,2) + '_' + fechaRep.substring(12,14) + fechaRep.substring(15,17);
			
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= 'Aeropuerto_' + vm.estadoactualsfiltrada[0].aeropuerto.replace(/\s+/g, '-');
				}
			else {
				nombrearchivoexcel= 'Todos';
				}
									
			alasql('select * INTO XLSX("EstadoActualDispositivos_'+ nombrearchivoexcel + fechaRepAAAAMMDDHHMMSS + '",?) from ( \
				select ?,?,?,?,?,?,?,? \
				union all select mydateformat(fechacontrol),aeropuerto,comercio,nroterminal, status, razon, metodo, impresora FROM ?)', 
				[mystyle,ncol_fechacontrol,ncol_aeropuerto,ncol_comercio,ncol_terminal,ncol_status,ncol_razon,ncol_metodo, ncol_impresora, vm.estadoactualsfiltrada]);
		
			};
		
		vm.exportDataCSV = function () {
				
			vm.estadoactualsfiltrada = angular.copy(vm.estadoactuals.filter($scope.filtraPorAeropuerto));			

			var fechaRep= GetFormattedDate(vm.estadoactualsfiltrada[0].fechacontrol);
			//01234567890123456789
			//25/06/2022, 19:10:01
			var fechaRepAAAAMMDDHHMMSS= '_'+fechaRep.substring(6,10) + fechaRep.substring(3,5) + fechaRep.substring(0,2) + '_' + fechaRep.substring(12,14) + fechaRep.substring(15,17);
			//console.log(fechaRepAAAAMMDDHHMMSS);

			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= 'Aeropuerto_' + vm.estadoactualsfiltrada[0].aeropuerto.replace(/\s+/g, '-');
				}
			else {
				nombrearchivoexcel= 'Todos';
				}
			
			alasql('select * INTO CSV("EstadoActualDispositivos_'+ nombrearchivoexcel + fechaRepAAAAMMDDHHMMSS + '",?) from ( \
				select ?,?,?,?,?,?,?,? \
				union all select mydateformat(fechacontrol),aeropuerto,comercio,nroterminal, status, razon, metodo, impresora FROM ?)', 
				[mystyle,ncol_fechacontrol,ncol_aeropuerto,ncol_comercio,ncol_terminal,ncol_status,ncol_razon,ncol_metodo, ncol_impresora, vm.estadoactualsfiltrada]);
		
			};
	
		function getLabelClass (statusState) {
            if (statusState === 'ERROR') {
                return 'label-danger';
            } else {
                return 'label-warning';
            }
        }
		
        function loadAll() {
            Estadoactual.query(function(result) {
                vm.estadoactuals = result;
				vm.listaAeropuertos= new Map();
				result.forEach(function(zeta){
						if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				
							vm.listaAeropuertos.set(zeta.aeropuerto, true);    
							}
						})  
				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");
            });
        }
		
		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				return true;
				}
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				return true;	
				}
			return false;
		}

        loadAll();
		
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDialogController', ConexionesDialogController);

    ConexionesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Conexiones'];

    function ConexionesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.conexiones.id !== null) {
                Conexiones.update(vm.conexiones, onSaveSuccess, onSaveError);
            } else {
                Conexiones.save(vm.conexiones, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:conexionesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.ultimafechaconexion = false;
        vm.datePickerOpenStatus.ultimafechatx = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDetailController', ConexionesDetailController);

    ConexionesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Conexiones'];

    function ConexionesDetailController($scope, $rootScope, $stateParams, previousState, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:conexionesUpdate', function(event, result) {
            vm.conexiones = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDeleteController',ConexionesDeleteController);

    ConexionesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Conexiones'];

    function ConexionesDeleteController($uibModalInstance, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Conexiones.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('conexiones', {
            parent: 'entity',
            url: '/conexiones?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.conexiones.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conexiones/conexiones.html',
                    controller: 'ConexionesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conexiones');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('conexiones-detail', {
            parent: 'conexiones',
            url: '/conexiones/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.conexiones.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conexiones/conexiones-detail.html',
                    controller: 'ConexionesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conexiones');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Conexiones', function($stateParams, Conexiones) {
                    return Conexiones.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'conexiones',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('conexiones-detail.edit', {
            parent: 'conexiones-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conexiones.new', {
            parent: 'conexiones',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ip: null,
                                ultimafechaconexion: null,
                                ultimafechatx: null,
                                contadorconn: null,
                                contadortx: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('conexiones');
                });
            }]
        })
        .state('conexiones.edit', {
            parent: 'conexiones',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-dialog.html',
                    controller: 'ConexionesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conexiones.delete', {
            parent: 'conexiones',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conexiones/conexiones-delete-dialog.html',
                    controller: 'ConexionesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Conexiones', function(Conexiones) {
                            return Conexiones.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conexiones', null, { reload: 'conexiones' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Conexiones', Conexiones);

    Conexiones.$inject = ['$resource', 'DateUtils'];

    function Conexiones ($resource, DateUtils) {
        var resourceUrl =  'api/conexiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.ultimafechaconexion = DateUtils.convertDateTimeFromServer(data.ultimafechaconexion);
                        data.ultimafechatx = DateUtils.convertDateTimeFromServer(data.ultimafechatx);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesController', ConexionesController);

    ConexionesController.$inject = ['$state', 'Conexiones', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ConexionesController($state, Conexiones, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Conexiones.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.conexiones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDialogController', ComercioDialogController);

    ComercioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comercio', 'Pv', 'Aeropuerto', 'Rubro',  'Moneda' ];

    function ComercioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comercio, Pv, Aeropuerto, Rubro, Moneda) {
        var vm = this;

        vm.comercio = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pvs = Pv.query();
        vm.aeropuertos = Aeropuerto.query();
        vm.rubros = Rubro.query();
        vm.monedas = Moneda.query();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comercio.id !== null) {
                Comercio.update(vm.comercio, onSaveSuccess, onSaveError);
            } else {
                Comercio.save(vm.comercio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:comercioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDetailController', ComercioDetailController);

    ComercioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comercio', 'Pv', 'Aeropuerto', 'Rubro', 'Moneda'];

    function ComercioDetailController($scope, $rootScope, $stateParams, previousState, entity, Comercio, Pv, Aeropuerto, Rubro, Moneda) {
        var vm = this;

        vm.comercio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:comercioUpdate', function(event, result) {
            vm.comercio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioDeleteController',ComercioDeleteController);

    ComercioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comercio'];

    function ComercioDeleteController($uibModalInstance, entity, Comercio) {
        var vm = this;

        vm.comercio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comercio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comercio', {
            parent: 'entity',
            url: '/comercio?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.comercio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercio/comercios.html',
                    controller: 'ComercioController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'nombre,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comercio-detail', {
            parent: 'comercio',
            url: '/comercio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.comercio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercio/comercio-detail.html',
                    controller: 'ComercioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comercio', function($stateParams, Comercio) {
                    return Comercio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comercio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comercio-detail.edit', {
            parent: 'comercio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercio/comercio-dialog.html',
                    controller: 'ComercioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercio', function(Comercio) {
                            return Comercio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercio.new', {
            parent: 'comercio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercio/comercio-dialog.html',
                    controller: 'ComercioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                nrolocal: null,
                                habilitado: null,
                                razonsocial: null,
                                contrato: null,
								apikey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comercio', null, { reload: 'comercio' });
                }, function() {
                    $state.go('comercio');
                });
            }]
        })
        .state('comercio.edit', {
            parent: 'comercio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercio/comercio-dialog.html',
                    controller: 'ComercioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercio', function(Comercio) {
                            return Comercio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercio', null, { reload: 'comercio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercio.delete', {
            parent: 'comercio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercio/comercio-delete-dialog.html',
                    controller: 'ComercioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comercio', function(Comercio) {
                            return Comercio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercio', null, { reload: 'comercio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Comercio', Comercio);

    Comercio.$inject = ['$resource'];

    function Comercio ($resource) {
        var resourceUrl =  'api/comercios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ComercioController', ComercioController);

    ComercioController.$inject = ['$state', 'Comercio', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ComercioController($state, Comercio, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Comercio.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.comercios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDialogController', AeropuertoDialogController);

    AeropuertoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aeropuerto', 'Comercio', 'Provincia'];

    function AeropuertoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aeropuerto, Comercio, Provincia) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();
        vm.provincias = Provincia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aeropuerto.id !== null) {
                Aeropuerto.update(vm.aeropuerto, onSaveSuccess, onSaveError);
            } else {
                Aeropuerto.save(vm.aeropuerto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:aeropuertoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDetailController', AeropuertoDetailController);

    AeropuertoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aeropuerto', 'Comercio', 'Provincia'];

    function AeropuertoDetailController($scope, $rootScope, $stateParams, previousState, entity, Aeropuerto, Comercio, Provincia) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:aeropuertoUpdate', function(event, result) {
            vm.aeropuerto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoDeleteController',AeropuertoDeleteController);

    AeropuertoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aeropuerto'];

    function AeropuertoDeleteController($uibModalInstance, entity, Aeropuerto) {
        var vm = this;

        vm.aeropuerto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aeropuerto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aeropuerto', {
            parent: 'entity',
            url: '/aeropuerto?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.aeropuerto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aeropuerto/aeropuertos.html',
                    controller: 'AeropuertoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aeropuerto');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aeropuerto-detail', {
            parent: 'aeropuerto',
            url: '/aeropuerto/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.aeropuerto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-detail.html',
                    controller: 'AeropuertoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aeropuerto');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aeropuerto', function($stateParams, Aeropuerto) {
                    return Aeropuerto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aeropuerto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aeropuerto-detail.edit', {
            parent: 'aeropuerto-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aeropuerto.new', {
            parent: 'aeropuerto',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                habilitado: null,
                                id: null,
								email: null,
								iata: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('aeropuerto');
                });
            }]
        })
        .state('aeropuerto.edit', {
            parent: 'aeropuerto',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-dialog.html',
                    controller: 'AeropuertoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aeropuerto.delete', {
            parent: 'aeropuerto',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aeropuerto/aeropuerto-delete-dialog.html',
                    controller: 'AeropuertoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aeropuerto', function(Aeropuerto) {
                            return Aeropuerto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aeropuerto', null, { reload: 'aeropuerto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Aeropuerto', Aeropuerto);

    Aeropuerto.$inject = ['$resource'];

    function Aeropuerto ($resource) {
        var resourceUrl =  'api/aeropuertos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AeropuertoController', AeropuertoController);

    AeropuertoController.$inject = ['$state', 'Aeropuerto', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AeropuertoController($state, Aeropuerto, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Aeropuerto.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.aeropuertos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('mVtasWebApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'es': { name: 'Español' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

/* https://codepen.io/bachly/pen/yeRmmL */

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('fileDownload', fileDownload);

	// Hook in a directive
	function fileDownload(){
	  return {
		restrict: 'E', // applied on 'element'
		scope: {
		  fileurl: '@fileurl',
		  linktext: '@linktext'      
		},
		template: '<a href="{{ fileurl }}" download>{{ linktext }}</a>', // need this so that the inner HTML can be re-used
		link: function(scope, elem, attrs) {
		  /* Ref: https://thinkster.io/egghead/isolate-scope-at
		   * This block is used when we have
		   * scope: {
			   fileurl: '=fileurl',
			   linktext: '=linktext'     
			 }          
		   scope.fileurl = attrs.fileurl;
		   scope.linktext = attrs.linktext;*/
		}               
	  }
	}
})();	

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('mVtasWebApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('mVtasWebApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('mVtasWebApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('mVtasWebApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('mVtasWebApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 15;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "es"');
                $cookies.putObject(name, 'es');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('es');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('mVtasWebApp')
        .constant('VERSION', "20250810AU")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1754878742846)
;
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.includes('jcache.statistics')) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('mVtasWebApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('mVtasWebApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><a ui-sref="venta"><h4><span>Acceso directo Ventas por dia</span></h4></a><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><br><br><div class="table-responsive" has-authority="ROLE_USER"><h3>Ventas del dia actual</h3><h5>Nota: no incluyen x sniffer/tcp!</h5><table class="jh-table table table-striped"><thead><tr><th><h5><span data-translate="mVtasWebApp.ventahoyrealtime.fechaproceso">Fechaproceso</span></h5></th><th><h5><span data-translate="mVtasWebApp.ventahoyrealtime.totalmonto">Totalmonto</span></h5></th><th><h5><span data-translate="mVtasWebApp.ventahoyrealtime.totaltickets">Totaltickets</span></h5></th><th><h5><span data-translate="mVtasWebApp.ventahoyrealtime.totalitems">Totalitems</span></h5></th><th><h5><span data-translate="mVtasWebApp.ventahoyrealtime.cantpv">Cantpv</span></h5></th><th><h5></h5></th></tr></thead><tbody><tr ng-repeat="ventahoyrealtime in vm.ventahoyrealtimes track by ventahoyrealtime.id"><td><h4>{{ventahoyrealtime.fechaproceso| limitTo : 2 : 6}}/{{ventahoyrealtime.fechaproceso| limitTo : 2 : 4}}/{{ventahoyrealtime.fechaproceso| limitTo : 4 : 0}} {{ventahoyrealtime.fechaproceso| limitTo : 2 : 8}}:{{ventahoyrealtime.fechaproceso| limitTo : 2 : 10}}</h4></td><td><h4>$ {{ventahoyrealtime.totalmonto | number: 2}}</h4></td><td><h4>{{ventahoyrealtime.totaltickets}}</h4></td><td><h4>{{ventahoyrealtime.totalitems}}</h4></td><td><h4>{{ventahoyrealtime.cantpv}}</h4></td></tr></tbody></table><h6><i>Informacion se actualizara automaticamente cada 5 minutos o presione F5</i></h6></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/aeropuerto/aeropuerto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aeropuerto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.aeropuerto.delete.question" translate-values="{id: \'{{vm.aeropuerto.nombre}}\'}">Are you sure you want to delete this Aeropuerto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aeropuerto/aeropuerto-detail.html','<div><h2><span data-translate="mVtasWebApp.aeropuerto.detail.title">Aeropuerto</span> {{vm.aeropuerto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.aeropuerto.nombre">Nombre</span></dt><dd><span>{{vm.aeropuerto.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.aeropuerto.iata">Codigo IATA</span></dt><dd><span>{{vm.aeropuerto.iata}}</span></dd><dt><span data-translate="mVtasWebApp.aeropuerto.habilitado">Habilitado</span></dt><dd><span>{{vm.aeropuerto.habilitado}}</span></dd><dt><span data-translate="mVtasWebApp.aeropuerto.email">Email Soporte</span></dt><dd><span>{{vm.aeropuerto.email}}</span></dd><dt><span data-translate="mVtasWebApp.aeropuerto.provincia">Provincia</span></dt><dd><a ui-sref="provincia-detail({id:vm.aeropuerto.provincia.id})">{{vm.aeropuerto.provincia.nombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aeropuerto-detail.edit({id:vm.aeropuerto.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aeropuerto/aeropuerto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAeropuertoLabel" data-translate="mVtasWebApp.aeropuerto.home.createOrEditLabel">Create or edit a Aeropuerto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aeropuerto.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aeropuerto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.aeropuerto.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.aeropuerto.nombre" required ng-minlength="1" ng-maxlength="30"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.aeropuerto.iata" for="field_nombre">Iata</label><input type="text" class="form-control" name="iata" id="field_iata" ng-model="vm.aeropuerto.iata" required ng-minlength="3" ng-maxlength="3"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.aeropuerto.email">Email Soporte</label><input type="email" class="form-control" name="email" ng-model="vm.aeropuerto.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.aeropuerto.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.aeropuerto.habilitado"></div><div class="form-group"><label data-translate="mVtasWebApp.aeropuerto.provincia" for="field_provincia">Provincia</label><select class="form-control" id="field_provincia" name="provincia" ng-model="vm.aeropuerto.provincia" ng-options="provincia as provincia.nombre for provincia in vm.provincias track by provincia.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aeropuerto/aeropuertos.html','<div><h2 data-translate="mVtasWebApp.aeropuerto.home.title">Aeropuertos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aeropuerto.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.aeropuerto.home.createLabel">Create new Aeropuerto</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.aeropuerto.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="iata"><span data-translate="mVtasWebApp.aeropuerto.iata">Codigo IATA</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="mVtasWebApp.aeropuerto.email">Email Soporte</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.aeropuerto.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="provincia.nombre"><span data-translate="mVtasWebApp.aeropuerto.provincia">Provincia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="aeropuerto in vm.aeropuertos track by aeropuerto.id"><td><a ui-sref="aeropuerto-detail({id:aeropuerto.id})">{{aeropuerto.id}}</a></td><td>{{aeropuerto.nombre}}</td><td>{{aeropuerto.iata}}</td><td>{{aeropuerto.email}}</td><td>{{aeropuerto.habilitado ? \'Si\':\'No\'}}</td><td><a ui-sref="provincia-detail({id:aeropuerto.provincia.id})">{{aeropuerto.provincia.nombre}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aeropuerto-detail({id:aeropuerto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aeropuerto.edit({id:aeropuerto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aeropuerto.delete({id:aeropuerto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/comercio/comercio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comercio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.comercio.delete.question" translate-values="{id: \'{{vm.comercio.nombre}}\'}">Are you sure you want to delete this Comercio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comercio/comercio-detail.html','<div><h2><span data-translate="mVtasWebApp.comercio.detail.title">Comercio</span> {{vm.comercio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.comercio.nombre">Nombre</span></dt><dd><span>{{vm.comercio.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.nrolocal">Nrolocal</span></dt><dd><span>{{vm.comercio.nrolocal}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.habilitado">Habilitado</span></dt><dd><span>{{vm.comercio.habilitado}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.razonsocial">Razonsocial</span></dt><dd><span>{{vm.comercio.razonsocial}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.contrato">Contrato</span></dt><dd><span>{{vm.comercio.contrato}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.aeropuerto">Aeropuerto</span></dt><dd><a ui-sref="aeropuerto-detail({id:vm.comercio.aeropuerto.id})">{{vm.comercio.aeropuerto.nombre}}</a></dd><dt><span data-translate="mVtasWebApp.comercio.apikey">ApiKey</span></dt><dd><span>{{vm.comercio.apikey}}</span></dd><dt><span data-translate="mVtasWebApp.comercio.rubro">Rubro</span></dt><dd><a ui-sref="rubro-detail({id:vm.comercio.rubro.id})">{{vm.comercio.rubro.descripcion}}</a></dd><dt><span data-translate="mVtasWebApp.comercio.moneda">Moneda</span></dt><dd><a ui-sref="moneda-detail({id:vm.comercio.moneda.id})">{{vm.comercio.moneda.descripcion}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comercio-detail.edit({id:vm.comercio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/comercio/comercio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComercioLabel" data-translate="mVtasWebApp.comercio.home.createOrEditLabel">Create or edit a Comercio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comercio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comercio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.comercio.nombre" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.nrolocal" for="field_nrolocal">Nrolocal</label><input type="text" class="form-control" name="nrolocal" id="field_nrolocal" ng-model="vm.comercio.nrolocal" ng-maxlength="50"><div ng-show="editForm.nrolocal.$invalid"><p class="help-block" ng-show="editForm.nrolocal.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.comercio.habilitado"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.razonsocial" for="field_razonsocial">Razonsocial</label><input type="text" class="form-control" name="razonsocial" id="field_razonsocial" ng-model="vm.comercio.razonsocial" ng-maxlength="30"><div ng-show="editForm.razonsocial.$invalid"><p class="help-block" ng-show="editForm.razonsocial.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.contrato" for="field_contrato">Contrato</label><input type="text" class="form-control" name="contrato" id="field_contrato" ng-model="vm.comercio.contrato" ng-maxlength="10"><div ng-show="editForm.contrato.$invalid"><p class="help-block" ng-show="editForm.contrato.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label data-translate="mVtasWebApp.comercio.aeropuerto" for="field_aeropuerto">Aeropuerto</label><select class="form-control" id="field_aeropuerto" name="aeropuerto" ng-model="vm.comercio.aeropuerto" ng-options="aeropuerto as aeropuerto.nombre for aeropuerto in vm.aeropuertos track by aeropuerto.id"><option value=""></option></select></div><div class="form-group"><label data-translate="mVtasWebApp.comercio.rubro" for="field_rubro">Rubro</label><select class="form-control" id="field_rubro" name="rubro" ng-model="vm.comercio.rubro" ng-options="rubro as rubro.descripcion for rubro in vm.rubros track by rubro.id"><option value=""></option></select></div><div class="form-group"><label data-translate="mVtasWebApp.comercio.moneda" for="field_moneda">Moneda</label><select class="form-control" id="field_moneda" name="moneda" ng-model="vm.comercio.moneda" ng-options="moneda as moneda.descripcion for moneda in vm.monedas track by moneda.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.comercio.apikey" for="field_contrato">ApiKey</label><input type="text" class="form-control" name="apikey" id="field_apikey" ng-model="vm.comercio.apikey" ng-maxlength="100"><div ng-show="editForm.apikey.$invalid"><p class="help-block" ng-show="editForm.apikey.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comercio/comercios.html','<div><h2 data-translate="mVtasWebApp.comercio.home.title">Comercios</h2><jhi-alert></jhi-alert><div class="container-fluid" has-authority="ROLE_ADMIN"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comercio.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.comercio.home.createLabel">Create new Comercio</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.comercio.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nrolocal"><span data-translate="mVtasWebApp.comercio.nrolocal">Nrolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.comercio.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="razonsocial"><span data-translate="mVtasWebApp.comercio.razonsocial">Razonsocial</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contrato"><span data-translate="mVtasWebApp.comercio.contrato">Contrato</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aeropuerto.nombre"><span data-translate="mVtasWebApp.comercio.aeropuerto">Aeropuerto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="apikey"><span data-translate="mVtasWebApp.comercio.apikey">Apikey</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rubro.descripcion"><span data-translate="mVtasWebApp.comercio.rubro">Rubro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="moneda.descripcion"><span data-translate="mVtasWebApp.comercio.moneda">Moneda</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="comercio in vm.comercios track by comercio.id"><td>{{comercio.nombre}}</td><td>{{comercio.nrolocal}}</td><td>{{comercio.habilitado ? \'Si\':\'No\'}}</td><td>{{comercio.razonsocial}}</td><td>{{comercio.contrato}}</td><td><a ui-sref="aeropuerto-detail({id:comercio.aeropuerto.id})">{{comercio.aeropuerto.nombre}}</a></td><td>{{comercio.apikey ? \'Si\':\'No\'}}</td><td><a ui-sref="rubro-detail({id:comercio.rubro.id})">{{comercio.rubro.descripcion}}</a></td><td><a ui-sref="moneda-detail({id:comercio.moneda.id})">{{comercio.moneda.descripcion}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comercio-detail({id:comercio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" has-authority="ROLE_ADMIN" ui-sref="comercio.edit({id:comercio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" has-authority="ROLE_ADMIN" ui-sref="comercio.delete({id:comercio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/conexiones/conexiones-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.conexiones.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.conexiones.delete.question" translate-values="{id: \'{{vm.conexiones.id}}\'}">Are you sure you want to delete this Conexiones?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/conexiones/conexiones-detail.html','<div><h2><span data-translate="mVtasWebApp.conexiones.detail.title">Conexiones</span> {{vm.conexiones.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.conexiones.ip">Ip</span></dt><dd><span>{{vm.conexiones.ip}}</span></dd><dt><span data-translate="mVtasWebApp.conexiones.ultimafechaconexion">Ultimafechaconexion</span></dt><dd><span>{{vm.conexiones.ultimafechaconexion | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.conexiones.ultimafechatx">Ultimafechatx</span></dt><dd><span>{{vm.conexiones.ultimafechatx | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.conexiones.contadorconn">Contadorconn</span></dt><dd><span>{{vm.conexiones.contadorconn}}</span></dd><dt><span data-translate="mVtasWebApp.conexiones.contadortx">Contadortx</span></dt><dd><span>{{vm.conexiones.contadortx}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="conexiones-detail.edit({id:vm.conexiones.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/conexiones/conexiones-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConexionesLabel" data-translate="mVtasWebApp.conexiones.home.createOrEditLabel">Create or edit a Conexiones</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.conexiones.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.conexiones.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.conexiones.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.conexiones.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.conexiones.ultimafechaconexion" for="field_ultimafechaconexion">Ultimafechaconexion</label><div class="input-group"><input id="field_ultimafechaconexion" type="text" class="form-control" name="ultimafechaconexion" datetime-picker="{{dateformat}}" ng-model="vm.conexiones.ultimafechaconexion" is-open="vm.datePickerOpenStatus.ultimafechaconexion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultimafechaconexion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.conexiones.ultimafechatx" for="field_ultimafechatx">Ultimafechatx</label><div class="input-group"><input id="field_ultimafechatx" type="text" class="form-control" name="ultimafechatx" datetime-picker="{{dateformat}}" ng-model="vm.conexiones.ultimafechatx" is-open="vm.datePickerOpenStatus.ultimafechatx"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ultimafechatx\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.conexiones.contadorconn" for="field_contadorconn">Contadorconn</label><input type="number" class="form-control" name="contadorconn" id="field_contadorconn" ng-model="vm.conexiones.contadorconn"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.conexiones.contadortx" for="field_contadortx">Contadortx</label><input type="number" class="form-control" name="contadortx" id="field_contadortx" ng-model="vm.conexiones.contadortx"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/conexiones/conexiones.html','<div><h2 data-translate="mVtasWebApp.conexiones.home.title">Conexiones</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="ip"><span data-translate="mVtasWebApp.conexiones.ip">Ip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ultimafechaconexion"><span data-translate="mVtasWebApp.conexiones.ultimafechaconexion">Ultimafechaconexion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ultimafechatx"><span data-translate="mVtasWebApp.conexiones.ultimafechatx">Ultimafechatx</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contadorconn"><span data-translate="mVtasWebApp.conexiones.contadorconn">Contadorconn</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contadortx"><span data-translate="mVtasWebApp.conexiones.contadortx">Contadortx</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="conexiones in vm.conexiones track by conexiones.id"><td>{{conexiones.ip}}</td><td>{{conexiones.ultimafechaconexion | date:\'medium\'}}</td><td>{{conexiones.ultimafechatx | date:\'medium\'}}</td><td>{{conexiones.contadorconn}}</td><td>{{conexiones.contadortx}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="conexiones-detail({id:conexiones.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/estadoactual/estadoactual-detail.html','<div><h2><span data-translate="mVtasWebApp.estadoactual.detail.title">Estadoactual</span> {{vm.estadoactual.nroterminal}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.estadoactual.fechacontrol">Fechacontrol</span></dt><dd><span>{{vm.estadoactual.fechacontrol | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.aeropuerto">Aeropuerto</span></dt><dd><span>{{vm.estadoactual.aeropuerto}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.comercio">Comercio</span></dt><dd><span>{{vm.estadoactual.comercio}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.nroterminal">Nroterminal</span></dt><dd><span>{{vm.estadoactual.nroterminal}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.status">Status</span></dt><dd><span>{{vm.estadoactual.status}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.impresora">Impresora</span></dt><dd><span>{{vm.estadoactual.impresora}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.razon">Razon</span></dt><dd><span>{{vm.estadoactual.razon}}</span></dd><dt><span data-translate="mVtasWebApp.estadoactual.metodo">Metodo</span></dt><dd><span>{{vm.estadoactual.metodo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/estadoactual/estadoactuals.html','<div><h2 data-translate="mVtasWebApp.estadoactual.home.title">Estadoactuals</h2><label for="repeatSelect">Filtrar por Aeropuerto:</label><select name="repeatSelect" class="input-sm" style="font-size:14px" ng-model="vm.seleccionAeropuerto" ng-options="selaeropuerto as selaeropuerto for selaeropuerto in vm.arrayAeropuertos" ng-init="Aeropuerto =\'\'"></select><input type="hidden" name="vm.seleccionAeropuerto" ng-model="vm.seleccionAeropuerto"><jhi-alert></jhi-alert><br><style>.full button span {\n\t\t\tbackground-color: limegreen;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }\n\t\t  .partially button span {\n\t\t\tbackground-color: orange;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }</style><div class="row"><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><br><br></div></div><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr><!-- <th><span data-translate="global.field.id">ID</span></th> --><th><span data-translate="mVtasWebApp.estadoactual.fechacontrol">Fechacontrol</span></th><th><span data-translate="mVtasWebApp.estadoactual.aeropuerto">Aeropuerto</span></th><th><span data-translate="mVtasWebApp.estadoactual.comercio">Comercio</span></th><th><span data-translate="mVtasWebApp.estadoactual.nroterminal">Nroterminal</span></th><th><span data-translate="mVtasWebApp.estadoactual.status">Status</span></th><th><span data-translate="mVtasWebApp.estadoactual.impresora">Impresora</span></th><th><span data-translate="mVtasWebApp.estadoactual.metodo">Metodo</span></th><th><span data-translate="mVtasWebApp.estadoactual.razon">Razon</span></th><th></th></tr></thead><tbody><tr ng-repeat="estadoactual in vm.estadoactuals | filter:filtraPorAeropuerto "><td>{{estadoactual.fechacontrol | date:\'medium\'}}</td><td>{{estadoactual.aeropuerto}}</td><td>{{estadoactual.comercio}}</td><td>{{estadoactual.nroterminal}}</td><td><span class="label" ng-class="vm.getLabelClass(estadoactual.status)">{{estadoactual.status}}</span></td><td>{{estadoactual.impresora}}</td><td>{{estadoactual.metodo}}</td><td>{{estadoactual.razon}}</td></tr></tbody></table></div>');
$templateCache.put('app/entities/item/item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.item.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.item.delete.question" translate-values="{id: \'{{vm.item.id}}\'}">Are you sure you want to delete this Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/item/item-detail.html','<div><h2><span data-translate="mVtasWebApp.item.detail.title">Item</span> {{vm.item.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.item.fecha">Fecha</span></dt><dd><span>{{vm.item.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.item.ip">Ip</span></dt><dd><span>{{vm.item.ip}}</span></dd><dt><span data-translate="mVtasWebApp.item.nropv">Nropv</span></dt><dd><span>{{vm.item.nropv}}</span></dd><dt><span data-translate="mVtasWebApp.item.nroz">Nroz</span></dt><dd><span>{{vm.item.nroz}}</span></dd><dt><span data-translate="mVtasWebApp.item.nroticket">Nroticket</span></dt><dd><span>{{vm.item.nroticket}}</span></dd><dt><span data-translate="mVtasWebApp.item.operacion">Operacion</span></dt><dd><span>{{vm.item.operacion}}</span></dd><dt><span data-translate="mVtasWebApp.item.descripcion">Descripcion</span></dt><dd><span>{{vm.item.descripcion}}</span></dd><dt><span data-translate="mVtasWebApp.item.monto">Monto</span></dt><dd><span>{{vm.item.monto}}</span></dd><dt><span data-translate="mVtasWebApp.item.cantidad">Cantidad</span></dt><dd><span>{{vm.item.cantidad}}</span></dd><dt><span data-translate="mVtasWebApp.item.unidades">Unidades</span></dt><dd><span>{{vm.item.unidades}}</span></dd><dt><span data-translate="mVtasWebApp.item.cancelado">Cancelado</span></dt><dd><span>{{vm.item.cancelado}}</span></dd><dt><span data-translate="mVtasWebApp.item.mdepcategoria">Mdepcategoria</span></dt><dd><span>{{vm.item.mdepcategoria}}</span></dd><dt><span data-translate="mVtasWebApp.item.descextra1">Descextra 1</span></dt><dd><span>{{vm.item.descextra1}}</span></dd><dt><span data-translate="mVtasWebApp.item.descextra2">Descextra 2</span></dt><dd><span>{{vm.item.descextra2}}</span></dd><dt><span data-translate="mVtasWebApp.item.descextra3">Descextra 3</span></dt><dd><span>{{vm.item.descextra3}}</span></dd><dt><span data-translate="mVtasWebApp.item.ticket">Ticket</span></dt><dd><a ui-sref="ticket-detail({id:vm.item.ticket.id})">{{vm.item.ticket.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="item-detail.edit({id:vm.item.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/item/item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myItemLabel" data-translate="mVtasWebApp.item.home.createOrEditLabel">Create or edit a Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.item.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.item.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.item.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.item.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.nropv" for="field_nropv">Nropv</label><input type="text" class="form-control" name="nropv" id="field_nropv" ng-model="vm.item.nropv" ng-maxlength="18"><div ng-show="editForm.nropv.$invalid"><p class="help-block" ng-show="editForm.nropv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.nroz" for="field_nroz">Nroz</label><input type="number" class="form-control" name="nroz" id="field_nroz" ng-model="vm.item.nroz"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.nroticket" for="field_nroticket">Nroticket</label><input type="number" class="form-control" name="nroticket" id="field_nroticket" ng-model="vm.item.nroticket"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.operacion" for="field_operacion">Operacion</label><input type="text" class="form-control" name="operacion" id="field_operacion" ng-model="vm.item.operacion" ng-maxlength="30"><div ng-show="editForm.operacion.$invalid"><p class="help-block" ng-show="editForm.operacion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.item.descripcion" ng-maxlength="50"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.monto" for="field_monto">Monto</label><input type="number" class="form-control" name="monto" id="field_monto" ng-model="vm.item.monto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.cantidad" for="field_cantidad">Cantidad</label><input type="number" class="form-control" name="cantidad" id="field_cantidad" ng-model="vm.item.cantidad"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.unidades" for="field_cantidad">Unidades</label><input type="number" class="form-control" name="unidades" id="field_unidades" ng-model="vm.item.unidades"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.cancelado" for="field_cancelado">Cancelado</label><input type="number" class="form-control" name="cancelado" id="field_cancelado" ng-model="vm.item.cancelado"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.item.mdepcategoria" for="field_mdepcategoria">Mdepcategoria</label><input type="text" class="form-control" name="mdepcategoria" id="field_mdepcategoria" ng-model="vm.item.mdepcategoria" ng-maxlength="10"><div ng-show="editForm.mdepcategoria.$invalid"><p class="help-block" ng-show="editForm.mdepcategoria.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label data-translate="mVtasWebApp.item.ticket" for="field_ticket">Ticket</label><select class="form-control" id="field_ticket" name="ticket" ng-model="vm.item.ticket" ng-options="ticket as ticket.id for ticket in vm.tickets track by ticket.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/item/items.html','<div><h2 data-translate="mVtasWebApp.item.home.title">Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="item.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.item.home.createLabel">Create new Item</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fecha"><span data-translate="mVtasWebApp.item.fecha">Fecha</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ip"><span data-translate="mVtasWebApp.item.ip">Ip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nropv"><span data-translate="mVtasWebApp.item.nropv">Nropv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroz"><span data-translate="mVtasWebApp.item.nroz">Nroz</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroticket"><span data-translate="mVtasWebApp.item.nroticket">Nroticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="operacion"><span data-translate="mVtasWebApp.item.operacion">Operacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descripcion"><span data-translate="mVtasWebApp.item.descripcion">Descripcion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="monto"><span data-translate="mVtasWebApp.item.monto">Monto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cantidad"><span data-translate="mVtasWebApp.item.cantidad">Cantidad</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unidades"><span data-translate="mVtasWebApp.item.unidades">Unidades</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cancelado"><span data-translate="mVtasWebApp.item.cancelado">Cancelado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mdepcategoria"><span data-translate="mVtasWebApp.item.mdepcategoria">Mdepcategoria</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descextra1"><span data-translate="mVtasWebApp.item.descextra1">Descextra 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descextra2"><span data-translate="mVtasWebApp.item.descextra2">Descextra 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descextra3"><span data-translate="mVtasWebApp.item.descextra3">Descextra 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket.id"><span data-translate="mVtasWebApp.item.ticket">Ticket</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.items track by item.id"><td><a ui-sref="item-detail({id:item.id})">{{item.id}}</a></td><td>{{item.fecha | date:\'medium\'}}</td><td>{{item.ip}}</td><td>{{item.nropv}}</td><td>{{item.nroz}}</td><td>{{item.nroticket}}</td><td>{{item.operacion}}</td><td>{{item.descripcion}}</td><td>{{item.monto}}</td><td>{{item.cantidad}}</td><td>{{item.unidades}}</td><td>{{item.cancelado}}</td><td>{{item.mdepcategoria}}</td><td>{{item.descextra1}}</td><td>{{item.descextra2}}</td><td>{{item.descextra3}}</td><td><a ui-sref="ticket-detail({id:item.ticket.id})">{{item.ticket.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="item-detail({id:item.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="item.edit({id:item.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="item.delete({id:item.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/modelosdeimpresora/modelosdeimpresora-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.modelosdeimpresora.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.modelosdeimpresora.delete.question" translate-values="{id: \'{{vm.modelosdeimpresora.id}}\'}">Are you sure you want to delete this Modelosdeimpresora?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/modelosdeimpresora/modelosdeimpresora-detail.html','<div><h2><span data-translate="mVtasWebApp.modelosdeimpresora.detail.title">Modelosdeimpresora</span> {{vm.modelosdeimpresora.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.modelosdeimpresora.descripcion">Descripcion</span></dt><dd><span>{{vm.modelosdeimpresora.descripcion}}</span></dd><dt><span data-translate="mVtasWebApp.modelosdeimpresora.protocolo">Protocolo</span></dt><dd><span data-translate="{{\'mVtasWebApp.Protocolo.\' + vm.modelosdeimpresora.protocolo}}">{{vm.modelosdeimpresora.protocolo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="modelosdeimpresora-detail.edit({id:vm.modelosdeimpresora.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/modelosdeimpresora/modelosdeimpresora-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModelosdeimpresoraLabel" data-translate="mVtasWebApp.modelosdeimpresora.home.createOrEditLabel">Create or edit a Modelosdeimpresora</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.modelosdeimpresora.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.modelosdeimpresora.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.modelosdeimpresora.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.modelosdeimpresora.descripcion" required ng-minlength="4" ng-maxlength="50"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descripcion.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.descripcion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.modelosdeimpresora.protocolo" for="field_protocolo">Protocolo</label><select class="form-control" name="protocolo" ng-model="vm.modelosdeimpresora.protocolo" id="field_protocolo"><option value="EPSON220" data-translate="mVtasWebApp.Protocolo.EPSON220">EPSON220</option><option value="HASAR441" data-translate="mVtasWebApp.Protocolo.HASAR441">HASAR441</option><option value="EPSONNP" data-translate="mVtasWebApp.Protocolo.EPSONNP">EPSONNP</option><option value="HASAR250_2G" data-translate="mVtasWebApp.Protocolo.HASAR250_2G">HASAR250_2G</option><option value="MORETTI" data-translate="mVtasWebApp.Protocolo.MORETTI">MORETTI</option><option value="HASARREG" data-translate="mVtasWebApp.Protocolo.HASARREG">HASARREG</option><option value="HASARTCP" data-translate="mVtasWebApp.Protocolo.HASARTCP">HASARTCP</option><option value="EPSONTCP" data-translate="mVtasWebApp.Protocolo.EPSONTCP">EPSONTCP</option><option value="EPSONCTD" data-translate="mVtasWebApp.Protocolo.EPSONTCP">EPSONCTD</option><option value="SAM4S_ELLIX40F" data-translate="mVtasWebApp.Protocolo.EPSONTCP">SAM4S_ELLIX40F</option><option value="VMALLAPI" data-translate="mVtasWebApp.Protocolo.VMALLAPI">VMALLAPI</option><option value="HASARXMLZETA" data-translate="mVtasWebApp.Protocolo.HASARXMLZETA">HASARXMLZETA</option><option value="HASARCTD" data-translate="mVtasWebApp.Protocolo.HASARCTD">HASARCTD</option><option value="TERMICA1" data-translate="mVtasWebApp.Protocolo.TERMICA1">TERMICA1</option><option value="TERMICA2" data-translate="mVtasWebApp.Protocolo.TERMICA2">TERMICA2</option><option value="TERMICA3" data-translate="mVtasWebApp.Protocolo.TERMICA3">TERMICA3</option><option value="TERMICA4" data-translate="mVtasWebApp.Protocolo.TERMICA4">TERMICA4</option><option value="TERMICA5TCP" data-translate="mVtasWebApp.Protocolo.TERMICA5TCP">TERMICA5TCP</option><option value="USBSNIFFER1" data-translate="mVtasWebApp.Protocolo.USBSNIFFER1">USBSNIFFER1</option><option value="LEPAINTCP" data-translate="mVtasWebApp.Protocolo.LEPAINTCP">LEPAINTCP</option><option value="BEJUICE" data-translate="mVtasWebApp.Protocolo.BEJUICE">BEJUICE</option><option value="PATRIA" data-translate="mVtasWebApp.Protocolo.BEJUICE">PATRIA</option><option value="PICKPOCK" data-translate="mVtasWebApp.Protocolo.PICKPOCK">PATRIA</option><option value="TRAVELMARKET" data-translate="mVtasWebApp.Protocolo.TRAVELMARKET">TRAVELMARKET</option><option value="SANROQUE" data-translate="mVtasWebApp.Protocolo.SANROQUE">SANROQUE</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/modelosdeimpresora/modelosdeimpresoras.html','<div><h2 data-translate="mVtasWebApp.modelosdeimpresora.home.title">Modelosdeimpresoras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="modelosdeimpresora.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.modelosdeimpresora.home.createLabel">Create new Modelosdeimpresora</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr><th><span data-translate="mVtasWebApp.modelosdeimpresora.descripcion">Descripcion</span></th><th><span data-translate="mVtasWebApp.modelosdeimpresora.protocolo">Protocolo</span></th><th></th></tr></thead><tbody><tr ng-repeat="modelosdeimpresora in vm.modelosdeimpresoras track by modelosdeimpresora.id"><td>{{modelosdeimpresora.descripcion}}</td><td data-translate="{{\'mVtasWebApp.Protocolo.\' + modelosdeimpresora.protocolo}}">{{modelosdeimpresora.protocolo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="modelosdeimpresora-detail({id:modelosdeimpresora.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="modelosdeimpresora.edit({id:modelosdeimpresora.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="modelosdeimpresora.delete({id:modelosdeimpresora.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/moneda/moneda-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.moneda.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.moneda.delete.question" translate-values="{id: \'{{vm.moneda.id}}\'}">Are you sure you want to delete this Moneda?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/moneda/moneda-detail.html','<div><h2><span data-translate="mVtasWebApp.moneda.detail.title">Moneda</span> {{vm.moneda.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.moneda.descripcion">Descripcion</span></dt><dd><span>{{vm.moneda.descripcion}}</span></dd><dt><span data-translate="mVtasWebApp.moneda.codigo">Codigo</span></dt><dd><span>{{vm.moneda.codigo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="moneda-detail.edit({id:vm.moneda.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/moneda/moneda-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMonedaLabel" data-translate="mVtasWebApp.moneda.home.createOrEditLabel">Create or edit a Moneda</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.moneda.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.moneda.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.moneda.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.moneda.descripcion" required ng-minlength="1" ng-maxlength="50"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descripcion.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.descripcion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.moneda.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="vm.moneda.codigo" required ng-minlength="3" ng-maxlength="3"><div ng-show="editForm.codigo.$invalid"><p class="help-block" ng-show="editForm.codigo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.codigo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p><p class="help-block" ng-show="editForm.codigo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/moneda/monedas.html','<div><h2 data-translate="mVtasWebApp.moneda.home.title">Monedas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="moneda.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.moneda.home.createLabel">Create new Moneda</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descripcion"><span data-translate="mVtasWebApp.moneda.descripcion">Descripcion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codigo"><span data-translate="mVtasWebApp.moneda.codigo">Codigo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="moneda in vm.monedas track by moneda.id"><td><a ui-sref="moneda-detail({id:moneda.id})">{{moneda.id}}</a></td><td>{{moneda.descripcion}}</td><td>{{moneda.codigo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="moneda-detail({id:moneda.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="moneda.edit({id:moneda.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="moneda.delete({id:moneda.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/monitor/monitor-delete-dialog.html','<div><h2>Monitoreo</h2><iframe src="http://127.0.0.1:3000/d/ts5zmafZk/vemall-monitor?orgId=1&theme=dark&from=now-6h&to=now-1m&refresh=5m" width="1100" height="800" frameborder="0"></iframe></div>');
$templateCache.put('app/entities/monitor/monitor-detail.html','<div><h2><span data-translate="mVtasWebApp.monitor.detail.title">Monitor</span> {{vm.monitor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.monitor.fecha">Fecha</span></dt><dd><span>{{vm.monitor.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.nroterminal">Nroterminal</span></dt><dd><span>{{vm.monitor.nroterminal}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.versiondesoft">Versiondesoft</span></dt><dd><span>{{vm.monitor.versiondesoft}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.cpuserial">Cpuserial</span></dt><dd><span>{{vm.monitor.cpuserial}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.cputemp">Cputemp</span></dt><dd><span>{{vm.monitor.cputemp}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.cpureboot">Cpureboot</span></dt><dd><span>{{vm.monitor.cpureboot}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.tottxbytes">Tottxbytes</span></dt><dd><span>{{vm.monitor.tottxbytes}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.toterrconex">Toterrconex</span></dt><dd><span>{{vm.monitor.toterrconex}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.serialok">Serialok</span></dt><dd><span>{{vm.monitor.serialok}}</span></dd><dt><span data-translate="mVtasWebApp.monitor.serialreopen">Serialreopen</span></dt><dd><span>{{vm.monitor.serialreopen}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="monitor-detail.edit({id:vm.monitor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/monitor/monitor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMonitorLabel" data-translate="mVtasWebApp.monitor.home.createOrEditLabel">Create or edit a Monitor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.monitor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.monitor.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.monitor.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.nroterminal" for="field_nroterminal">Nroterminal</label><input type="text" class="form-control" name="nroterminal" id="field_nroterminal" ng-model="vm.monitor.nroterminal" ng-maxlength="20"><div ng-show="editForm.nroterminal.$invalid"><p class="help-block" ng-show="editForm.nroterminal.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.versiondesoft" for="field_versiondesoft">Versiondesoft</label><input type="text" class="form-control" name="versiondesoft" id="field_versiondesoft" ng-model="vm.monitor.versiondesoft" ng-maxlength="20"><div ng-show="editForm.versiondesoft.$invalid"><p class="help-block" ng-show="editForm.versiondesoft.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.cpuserial" for="field_cpuserial">Cpuserial</label><input type="text" class="form-control" name="cpuserial" id="field_cpuserial" ng-model="vm.monitor.cpuserial" ng-maxlength="20"><div ng-show="editForm.cpuserial.$invalid"><p class="help-block" ng-show="editForm.cpuserial.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.cputemp" for="field_cputemp">Cputemp</label><input type="number" class="form-control" name="cputemp" id="field_cputemp" ng-model="vm.monitor.cputemp"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.cpureboot" for="field_cpureboot">Cpureboot</label><input type="number" class="form-control" name="cpureboot" id="field_cpureboot" ng-model="vm.monitor.cpureboot"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.tottxbytes" for="field_tottxbytes">Tottxbytes</label><input type="number" class="form-control" name="tottxbytes" id="field_tottxbytes" ng-model="vm.monitor.tottxbytes"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.toterrconex" for="field_toterrconex">Toterrconex</label><input type="number" class="form-control" name="toterrconex" id="field_toterrconex" ng-model="vm.monitor.toterrconex"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.serialok" for="field_serialok">Serialok</label><input type="number" class="form-control" name="serialok" id="field_serialok" ng-model="vm.monitor.serialok"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.monitor.serialreopen" for="field_serialreopen">Serialreopen</label><input type="number" class="form-control" name="serialreopen" id="field_serialreopen" ng-model="vm.monitor.serialreopen"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/monitor/monitors.html','<div><h2>Monitoreo</h2><iframe src="https://au.vmall.host:33000/d/ts5zmafZk/vemall-monitor?orgId=1&theme=dark&from=now-2d&to=now&refresh=5m" width="1100" height="800" frameborder="0"></iframe></div>');
$templateCache.put('app/entities/pais/pais-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pais.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.pais.delete.question" translate-values="{id: \'{{vm.pais.nombre}}\'}">Are you sure you want to delete this Pais?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pais/pais-detail.html','<div><h2><span data-translate="mVtasWebApp.pais.detail.title">Pais</span> {{vm.pais.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.pais.nombre">Nombre</span></dt><dd><span>{{vm.pais.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.pais.habilitado">Habilitado</span></dt><dd><span>{{vm.pais.habilitado}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pais-detail.edit({id:vm.pais.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pais/pais-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaisLabel" data-translate="mVtasWebApp.pais.home.createOrEditLabel">Create or edit a Pais</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pais.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pais.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pais.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.pais.nombre" required ng-minlength="1" ng-maxlength="30"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pais.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.pais.habilitado"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pais/pais.html','<div><h2 data-translate="mVtasWebApp.pais.home.title">Pais</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pais.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.pais.home.createLabel">Create new Pais</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.pais.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.pais.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pais in vm.pais track by pais.id"><td><a ui-sref="pais-detail({id:pais.id})">{{pais.id}}</a></td><td>{{pais.nombre}}</td><td>{{pais.habilitado ? \'Si\':\'No\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pais-detail({id:pais.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pais.edit({id:pais.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pais.delete({id:pais.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/provincia/provincia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.provincia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.provincia.delete.question" translate-values="{id: \'{{vm.provincia.nombre}}\'}">Are you sure you want to delete this Provincia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/provincia/provincia-detail.html','<div><h2><span data-translate="mVtasWebApp.provincia.detail.title">Provincia</span> {{vm.provincia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.provincia.nombre">Nombre</span></dt><dd><span>{{vm.provincia.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.provincia.habilitado">Habilitado</span></dt><dd><span>{{vm.provincia.habilitado}}</span></dd><dt><span data-translate="mVtasWebApp.provincia.region">Region</span></dt><dd><a ui-sref="region-detail({id:vm.provincia.region.id})">{{vm.provincia.region.nombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="provincia-detail.edit({id:vm.provincia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/provincia/provincia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProvinciaLabel" data-translate="mVtasWebApp.provincia.home.createOrEditLabel">Create or edit a Provincia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.provincia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.provincia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.provincia.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.provincia.nombre" required ng-minlength="1" ng-maxlength="30"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.provincia.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.provincia.habilitado"></div><div class="form-group"><label data-translate="mVtasWebApp.provincia.region" for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.provincia.region" ng-options="region as region.nombre for region in vm.regions track by region.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/provincia/provincias.html','<div><h2 data-translate="mVtasWebApp.provincia.home.title">Provincias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="provincia.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.provincia.home.createLabel">Create new Provincia</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.provincia.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.provincia.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="region.nombre"><span data-translate="mVtasWebApp.provincia.region">Region</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="provincia in vm.provincias track by provincia.id"><td><a ui-sref="provincia-detail({id:provincia.id})">{{provincia.id}}</a></td><td>{{provincia.nombre}}</td><td>{{provincia.habilitado ? \'Si\':\'No\'}}</td><td><a ui-sref="region-detail({id:provincia.region.id})">{{provincia.region.nombre}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="provincia-detail({id:provincia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="provincia.edit({id:provincia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="provincia.delete({id:provincia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/pv/pv-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pv.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.pv.delete.question" translate-values="{id: \'{{vm.pv.ip}}\'}">Are you sure you want to delete this Pv?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pv/pv-detail.html','<div><h2><span data-translate="mVtasWebApp.pv.detail.title">Pv</span> {{vm.pv.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.pv.nropv">Nropv</span></dt><dd><span>{{vm.pv.nropv}}</span></dd><dt><span data-translate="mVtasWebApp.pv.ip">Ip</span></dt><dd><span>{{vm.pv.ip}}</span></dd><dt><span data-translate="mVtasWebApp.pv.specialmode">Specialmode</span></dt><dd><span>{{vm.pv.specialmode}}</span></dd><dt><span data-translate="mVtasWebApp.pv.daemonmode">Daemonmode</span></dt><dd><span>{{vm.pv.daemonmode}}</span></dd><dt><span data-translate="mVtasWebApp.pv.horadesde">horadesde</span></dt><dd><span>{{vm.pv.horadesde}}</span></dd><dt><span data-translate="mVtasWebApp.pv.horahasta">horahasta</span></dt><dd><span>{{vm.pv.horahasta}}</span></dd><dt><span data-translate="mVtasWebApp.pv.comentario">comentario</span></dt><dd><span>{{vm.pv.comentario}}</span></dd><dt><span data-translate="mVtasWebApp.pv.modelosdeimpresora">Modelosdeimpresora</span></dt><dd><a ui-sref="modelosdeimpresora-detail({id:vm.pv.modelosdeimpresora.id})">{{vm.pv.modelosdeimpresora.descripcion}}</a></dd><dt><span data-translate="mVtasWebApp.pv.habilitado">Habilitado</span></dt><dd><span>{{vm.pv.habilitado}}</span></dd><dt><span data-translate="mVtasWebApp.pv.comercio">Comercio</span></dt><dd><a ui-sref="comercio-detail({id:vm.pv.comercio.id})">{{vm.pv.comercio.nombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pv-detail.edit({id:vm.pv.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pv/pv-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPvLabel" data-translate="mVtasWebApp.pv.home.createOrEditLabel">Create or edit a Pv</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pv.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pv.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.nropv" for="field_nropv">Nropv</label><input type="text" class="form-control" name="nropv" id="field_nropv" ng-model="vm.pv.nropv" required ng-minlength="1" ng-maxlength="18"><div ng-show="editForm.nropv.$invalid"><p class="help-block" ng-show="editForm.nropv.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nropv.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.nropv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.pv.ip" required ng-minlength="1" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.ip.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.specialmode" for="field_specialmode">Specialmode</label><input type="number" class="form-control" name="specialmode" id="field_specialmode" min="0" max="1" ng-model="vm.pv.specialmode"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.daemonmode" for="field_daemonmode">Daemonmode</label><input type="number" class="form-control" name="daemonmode" id="field_daemonmode" min="0" max="1" ng-model="vm.pv.daemonmode"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.horadesde" for="field_horadesde">horadesde</label><input type="number" class="form-control" name="horadesde" id="field_horadesde" min="0" max="24" ng-model="vm.pv.horadesde"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.horahasta" for="field_horahasta">horahasta</label><input type="number" class="form-control" name="horahasta" id="field_horahasta" min="0" max="24" ng-model="vm.pv.horahasta"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.comentario" for="field_comentario">Comentario</label><input type="text" class="form-control" name="comentario" id="field_comentario" ng-model="vm.pv.comentario" ng-maxlength="100"><div ng-show="editForm.comentario.$invalid"><p class="help-block" ng-show="editForm.comentario.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><!--\t\t\n\t\t\n\t\t \n\t\t ng-options="modelosdeimpresora as modelosdeimpresora.descripcion for modelosdeimpresora in vm.modelosdeimpresoras track by modelosdeimpresora.id\n\n      <div class="form-group">\n\t        <label class="control-label" data-translate="mVtasWebApp.pv.daemonmode" for="field_daemonmode">Daemonmode</label>\n            <select class="form-control" name="daemonmode" ng-model="vm.pv.daemonmode" id="field_daemonmode">\n                <option value="0" >SNIFFER</option>\n                <option value="1" >DEMANDA</option>\n            </select>\n        </div>\n\n\t\tng-options="modelosdeimpresora as modelosdeimpresora.descripcion for modelosdeimpresora in vm.modelosdeimpresoras track by modelosdeimpresora.id">\n\n      <div class="form-group">\n\t        <label class="control-label" data-translate="mVtasWebApp.pv.daemonmode" for="field_daemonmode">Daemonmode</label>\n            <select class="form-control" name="daemonmode" ng-model="vm.pv.daemonmode" id="field_daemonmode" ng-options="item for item in vm.names">\n                <option value=""></option>\n            </select>\n        </div>\n\n--><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pv.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.pv.habilitado"></div><div class="form-group"><label data-translate="mVtasWebApp.pv.modelosdeimpresora" for="field_modelosdeimpresora">Modelosdeimpresora</label><select class="form-control" id="field_modelosdeimpresora" name="modelosdeimpresora" ng-model="vm.pv.modelosdeimpresora" ng-options="modelosdeimpresora as modelosdeimpresora.descripcion for modelosdeimpresora in vm.modelosdeimpresoras track by modelosdeimpresora.id"><option value=""></option></select></div><div class="form-group"><label data-translate="mVtasWebApp.pv.comercio" for="field_comercio">Comercio</label><select class="form-control" id="field_comercio" name="comercio" ng-model="vm.pv.comercio" ng-options="comercio as comercio.nombre for comercio in vm.comercios track by comercio.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pv/pvs.html','<div><h2 data-translate="mVtasWebApp.pv.home.title">Pvs</h2><jhi-alert></jhi-alert><div class="container-fluid" has-authority="ROLE_ADMIN"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pv.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.pv.home.createLabel">Create new Pv</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="comercio.nombre"><span data-translate="mVtasWebApp.pv.comercio">Comercio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ip"><span data-translate="mVtasWebApp.pv.ip">Ip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="modelosdeimpresora.descripcion"><span data-translate="mVtasWebApp.pv.modelosdeimpresora">Modelosdeimpresora</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nropv"><span data-translate="mVtasWebApp.pv.nropv">Nropv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.pv.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="specialmode"><span data-translate="mVtasWebApp.pv.specialmode">Specialmode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="daemonmode"><span data-translate="mVtasWebApp.pv.daemonmode">Daemonmode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horadesde"><span data-translate="mVtasWebApp.pv.horadesde">horadesde</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horahasta"><span data-translate="mVtasWebApp.pv.horahasta">horahasta</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comentario"><span data-translate="mVtasWebApp.pv.comentario">comentario</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pv in vm.pvs track by pv.id"><td><a ui-sref="comercio-detail({id:pv.comercio.id})">{{pv.comercio.nombre}}</a></td><td>{{pv.ip}}</td><td><a ui-sref="modelosdeimpresora-detail({id:pv.modelosdeimpresora.id})">{{pv.modelosdeimpresora.descripcion}}</a></td><td>{{pv.nropv}}</td><td>{{pv.habilitado ? \'Si\':\'No\'}}</td><td>{{pv.specialmode}}</td><td><span class="label" ng-class="vm.getLabelClass(pv.daemonmode)">{{vm.getLabelClassText(pv.daemonmode)}}</span></td><td>{{pv.horadesde}}</td><td>{{pv.horahasta}}</td><td>{{pv.comentario}}</td><td class="text-right" has-authority="ROLE_ADMIN"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pv.edit({id:pv.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pv.delete({id:pv.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/pvlog/pvlog-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pvlog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.pvlog.delete.question" translate-values="{id: \'{{vm.pvlog.id}}\'}">Are you sure you want to delete this Pvlog?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pvlog/pvlog-detail.html','<div><h2><span data-translate="mVtasWebApp.pvlog.detail.title">Pvlog</span> {{vm.pvlog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.pvlog.fecha">Fecha</span></dt><dd><span>{{vm.pvlog.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.nroterminal">Nroterminal</span></dt><dd><span>{{vm.pvlog.nroterminal}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.versiondesoft">Versiondesoft</span></dt><dd><span>{{vm.pvlog.versiondesoft}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.cpuserial">Cpuserial</span></dt><dd><span>{{vm.pvlog.cpuserial}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.cputemp">Cputemp</span></dt><dd><span>{{vm.pvlog.cputemp}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.cpureboot">Cpureboot</span></dt><dd><span>{{vm.pvlog.cpureboot}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.tottxbytes">Tottxbytes</span></dt><dd><span>{{vm.pvlog.tottxbytes}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.toterrconex">Toterrconex</span></dt><dd><span>{{vm.pvlog.toterrconex}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.serialok">Serialok</span></dt><dd><span>{{vm.pvlog.serialok}}</span></dd><dt><span data-translate="mVtasWebApp.pvlog.serialreopen">Serialreopen</span></dt><dd><span>{{vm.pvlog.serialreopen}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/pvlog/pvlog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPvlogLabel" data-translate="mVtasWebApp.pvlog.home.createOrEditLabel">Create or edit a Pvlog</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pvlog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pvlog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.pvlog.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.nroterminal" for="field_nroterminal">Nroterminal</label><input type="text" class="form-control" name="nroterminal" id="field_nroterminal" ng-model="vm.pvlog.nroterminal" ng-maxlength="20"><div ng-show="editForm.nroterminal.$invalid"><p class="help-block" ng-show="editForm.nroterminal.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.versiondesoft" for="field_versiondesoft">Versiondesoft</label><input type="text" class="form-control" name="versiondesoft" id="field_versiondesoft" ng-model="vm.pvlog.versiondesoft" ng-maxlength="20"><div ng-show="editForm.versiondesoft.$invalid"><p class="help-block" ng-show="editForm.versiondesoft.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.cpuserial" for="field_cpuserial">Cpuserial</label><input type="text" class="form-control" name="cpuserial" id="field_cpuserial" ng-model="vm.pvlog.cpuserial" ng-maxlength="20"><div ng-show="editForm.cpuserial.$invalid"><p class="help-block" ng-show="editForm.cpuserial.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.cputemp" for="field_cputemp">Cputemp</label><input type="number" class="form-control" name="cputemp" id="field_cputemp" ng-model="vm.pvlog.cputemp"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.cpureboot" for="field_cpureboot">Cpureboot</label><input type="number" class="form-control" name="cpureboot" id="field_cpureboot" ng-model="vm.pvlog.cpureboot"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.tottxbytes" for="field_tottxbytes">Tottxbytes</label><input type="number" class="form-control" name="tottxbytes" id="field_tottxbytes" ng-model="vm.pvlog.tottxbytes"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.toterrconex" for="field_toterrconex">Toterrconex</label><input type="number" class="form-control" name="toterrconex" id="field_toterrconex" ng-model="vm.pvlog.toterrconex"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.serialok" for="field_serialok">Serialok</label><input type="number" class="form-control" name="serialok" id="field_serialok" ng-model="vm.pvlog.serialok"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.pvlog.serialreopen" for="field_serialreopen">Serialreopen</label><input type="number" class="form-control" name="serialreopen" id="field_serialreopen" ng-model="vm.pvlog.serialreopen"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pvlog/pvlogs.html','<div><h2 data-translate="mVtasWebApp.pvlog.home.title">Pvlogs</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fecha"><span data-translate="mVtasWebApp.pvlog.fecha">Fecha</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroterminal"><span data-translate="mVtasWebApp.pvlog.nroterminal">Nroterminal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="versiondesoft"><span data-translate="mVtasWebApp.pvlog.versiondesoft">Versiondesoft</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cputemp"><span data-translate="mVtasWebApp.pvlog.cputemp">Cputemp</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cpureboot"><span data-translate="mVtasWebApp.pvlog.cpureboot">Cpureboot</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tottxbytes"><span data-translate="mVtasWebApp.pvlog.tottxbytes">Tottxbytes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="toterrconex"><span data-translate="mVtasWebApp.pvlog.toterrconex">Toterrconex</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="serialok"><span data-translate="mVtasWebApp.pvlog.serialok">Serialok</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="serialreopen"><span data-translate="mVtasWebApp.pvlog.serialreopen">Serialreopen</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pvlog in vm.pvlogs track by pvlog.id"><td><a ui-sref="pvlog-detail({id:pvlog.id})">{{pvlog.id}}</a></td><td>{{pvlog.fecha | date:\'medium\'}}</td><td>{{pvlog.nroterminal}}</td><td>{{pvlog.versiondesoft}}</td><td><span class="label" ng-class="vm.getTemperatureClass(pvlog.cputemp)">{{pvlog.cputemp}}</span></td><td>{{pvlog.cpureboot}}</td><td>{{pvlog.tottxbytes}}</td><td><span class="label" ng-class="vm.getTotErrConexClass(pvlog.toterrconex)">{{pvlog.toterrconex}}</span></td><td><span class="label" ng-class="vm.getLabelClass(pvlog.serialok)">{{vm.getLabelClassText(pvlog.serialok)}}</span></td><td><span class="label" ng-class="vm.getSerialReopenClass(pvlog.serialreopen)">{{pvlog.serialreopen}}</span></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/region/region-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.region.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.region.delete.question" translate-values="{id: \'{{vm.region.nombre}}\'}">Are you sure you want to delete this Region?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/region/region-detail.html','<div><h2><span data-translate="mVtasWebApp.region.detail.title">Region</span> {{vm.region.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.region.nombre">Nombre</span></dt><dd><span>{{vm.region.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.region.habilitado">Habilitado</span></dt><dd><span>{{vm.region.habilitado}}</span></dd><dt><span data-translate="mVtasWebApp.region.pais">Pais</span></dt><dd><a ui-sref="pais-detail({id:vm.region.pais.id})">{{vm.region.pais.nombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="region-detail.edit({id:vm.region.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/region/region-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegionLabel" data-translate="mVtasWebApp.region.home.createOrEditLabel">Create or edit a Region</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.region.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.region.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.region.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.region.nombre" required ng-minlength="1" ng-maxlength="30"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nombre.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.region.habilitado" for="field_habilitado">Habilitado</label><input type="checkbox" name="habilitado" id="field_habilitado" ng-model="vm.region.habilitado"></div><div class="form-group"><label data-translate="mVtasWebApp.region.pais" for="field_pais">Pais</label><select class="form-control" id="field_pais" name="pais" ng-model="vm.region.pais" ng-options="pais as pais.nombre for pais in vm.pais track by pais.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/region/regions.html','<div><h2 data-translate="mVtasWebApp.region.home.title">Regions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="region.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.region.home.createLabel">Create new Region</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.region.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="habilitado"><span data-translate="mVtasWebApp.region.habilitado">Habilitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pais.nombre"><span data-translate="mVtasWebApp.region.pais">Pais</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="region in vm.regions track by region.id"><td><a ui-sref="region-detail({id:region.id})">{{region.id}}</a></td><td>{{region.nombre}}</td><td>{{region.habilitado ? \'Si\':\'No\'}}</td><td><a ui-sref="pais-detail({id:region.pais.id})">{{region.pais.nombre}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="region-detail({id:region.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="region.edit({id:region.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="region.delete({id:region.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/rubro/rubro-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rubro.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.rubro.delete.question" translate-values="{id: \'{{vm.rubro.id}}\'}">Are you sure you want to delete this Rubro?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rubro/rubro-detail.html','<div><h2><span data-translate="mVtasWebApp.rubro.detail.title">Rubro</span> {{vm.rubro.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.rubro.descripcion">Descripcion</span></dt><dd><span>{{vm.rubro.descripcion}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rubro-detail.edit({id:vm.rubro.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rubro/rubro-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRubroLabel" data-translate="mVtasWebApp.rubro.home.createOrEditLabel">Create or edit a Rubro</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rubro.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rubro.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.rubro.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.rubro.descripcion" required ng-minlength="4" ng-maxlength="50"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descripcion.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="4">This field is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.descripcion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rubro/rubros.html','<div><h2 data-translate="mVtasWebApp.rubro.home.title">Rubros</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rubro.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.rubro.home.createLabel">Create new Rubro</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descripcion"><span data-translate="mVtasWebApp.rubro.descripcion">Descripcion</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="rubro in vm.rubros track by rubro.id"><td><a ui-sref="rubro-detail({id:rubro.id})">{{rubro.id}}</a></td><td>{{rubro.descripcion}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rubro-detail({id:rubro.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rubro.edit({id:rubro.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rubro.delete({id:rubro.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/ticket/ticket-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticket.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ticket.delete.question" translate-values="{id: \'{{vm.ticket.id}}\'}">Are you sure you want to delete this Ticket?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket/ticket-detail.html','<div><h2><span data-translate="mVtasWebApp.ticket.detail.title">Ticket</span> <b>{{vm.ticket.nroticket}}</b></h2><hr><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="mVtasWebApp.item.fecha">Fecha</span></th><th><span data-translate="mVtasWebApp.item.operacion">Operacion</span></th><th><span data-translate="mVtasWebApp.item.descripcion">Descripcion</span></th><th class="text-right"><span data-translate="mVtasWebApp.item.monto">Monto</span></th><th class="text-right"><span data-translate="mVtasWebApp.item.cantidad">Cantidad</span></th><th class="text-right"><span data-translate="mVtasWebApp.item.unidades">Unidades</span></th><th class="text-right"><span data-translate="mVtasWebApp.item.cancelado">Cancelado</span></th><th><span data-translate="mVtasWebApp.item.categoria">Categoria</span></th><th><span data-translate="mVtasWebApp.item.descextra1">DescExtra1</span></th><th><span data-translate="mVtasWebApp.item.descextra2">DescExtra2</span></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.items track by item.id"><td>{{item.fecha | date:\'medium\'}}</td><td>{{item.operacion}}</td><td>{{item.descripcion}}</td><td class="text-right">$ {{item.monto | number: 2 }}</td><td class="text-right">{{item.cantidad}}</td><td class="text-right">{{item.unidades | number: 3 }}</td><td class="text-right">{{item.cancelado ? \'Si\':\'No\'}}</td><td>{{item.categoria}}</td><td>{{item.descextra1}}</td><td>{{item.descextra2}}</td></tr></tbody></table></div><!--\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>\n\n\t--></div>');
$templateCache.put('app/entities/ticket/ticket-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketLabel" data-translate="mVtasWebApp.ticket.home.createOrEditLabel">Create or edit a Ticket</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticket.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticket.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.ticket.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.ticket.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.nropv" for="field_nropv">Nropv</label><input type="text" class="form-control" name="nropv" id="field_nropv" ng-model="vm.ticket.nropv" ng-maxlength="18"><div ng-show="editForm.nropv.$invalid"><p class="help-block" ng-show="editForm.nropv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.nroz" for="field_nroz">Nroz</label><input type="number" class="form-control" name="nroz" id="field_nroz" ng-model="vm.ticket.nroz"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.nroticket" for="field_nroticket">Nroticket</label><input type="number" class="form-control" name="nroticket" id="field_nroticket" ng-model="vm.ticket.nroticket"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.esncredito" for="field_esncredito">Esncredito</label><input type="number" class="form-control" name="esncredito" id="field_esncredito" ng-model="vm.ticket.esncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.montototal" for="field_montototal">Montototal</label><input type="number" class="form-control" name="montototal" id="field_montototal" ng-model="vm.ticket.montototal"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.cantitems" for="field_cantitems">Cantitems</label><input type="number" class="form-control" name="cantitems" id="field_cantitems" ng-model="vm.ticket.cantitems"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.cliente" for="field_cliente">Cliente</label><input type="text" class="form-control" name="cliente" id="field_cliente" ng-model="vm.ticket.cliente" ng-maxlength="50"><div ng-show="editForm.cliente.$invalid"><p class="help-block" ng-show="editForm.cliente.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.codigomoneda" for="field_codigomoneda">Moneda</label><input type="text" class="form-control" name="codigomoneda" id="field_codigomoneda" ng-model="vm.ticket.codigomoneda" ng-maxlength="3"><div ng-show="editForm.codigomoneda.$invalid"><p class="help-block" ng-show="editForm.codigomoneda.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.tipofactura" for="field_tipofactura">Tipofactura</label><input type="text" class="form-control" name="tipofactura" id="field_tipofactura" ng-model="vm.ticket.tipofactura" ng-maxlength="2"><div ng-show="editForm.tipofactura.$invalid"><p class="help-block" ng-show="editForm.tipofactura.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticket.nrozfiscal" for="field_nrozfiscal">Nrozfiscal</label><input type="number" class="form-control" name="nrozfiscal" id="field_nrozfiscal" ng-model="vm.ticket.nrozfiscal"></div><div class="form-group"><label data-translate="mVtasWebApp.ticket.zeta" for="field_zeta">Zeta</label><select class="form-control" id="field_zeta" name="zeta" ng-model="vm.ticket.zeta" ng-options="zeta as zeta.id for zeta in vm.zetas track by zeta.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket/tickets.html','<div><h2 data-translate="mVtasWebApp.ticket.home.title">Tickets</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="fecha"><span data-translate="mVtasWebApp.ticket.fecha">Fecha</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ip"><span data-translate="mVtasWebApp.ticket.ip">Ip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nropv"><span data-translate="mVtasWebApp.ticket.nropv">Nropv</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroz"><span data-translate="mVtasWebApp.ticket.nroz">Nroz</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroticket"><span data-translate="mVtasWebApp.ticket.nroticket">Nroticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="montototal"><span data-translate="mVtasWebApp.ticket.montototal">Montototal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cantitems"><span data-translate="mVtasWebApp.ticket.cantitems">Cantitems</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cliente"><span data-translate="mVtasWebApp.ticket.cliente">Cliente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codigomoneda"><span data-translate="mVtasWebApp.ticket.codigomoneda">Moneda</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="esncredito"><span data-translate="mVtasWebApp.ticket.esncredito">Esncredito</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipofactura"><span data-translate="mVtasWebApp.ticket.tipofactura">Tipofactura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nrozfiscal"><span data-translate="mVtasWebApp.ticket.nrozfiscal">Nrozfiscal</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ticket in vm.tickets track by ticket.id"><td>{{ticket.fecha | date:\'medium\'}}</td><td>{{ticket.ip}}</td><td>{{ticket.nropv}}</td><td>{{ticket.nroz}}</td><td>{{ticket.nroticket}}</td><td>{{ticket.montototal}}</td><td>{{ticket.cantitems}}</td><td>{{ticket.cliente}}</td><td>{{ticket.codigomoneda}}</td><td>{{ticket.esncredito}}</td><td>{{ticket.tipofactura}}</td><td>{{ticket.nrozfiscal}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-detail({id:ticket.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ticketrealtime/ticketrealtime-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketrealtime.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ticketrealtime.delete.question" translate-values="{id: \'{{vm.ticketrealtime.id}}\'}">Are you sure you want to delete this Ticketrealtime?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticketrealtime/ticketrealtime-detail.html','<div><h2><span data-translate="mVtasWebApp.ticketrealtime.detail.title">Ticketrealtime</span> {{vm.ticketrealtime.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.ticketrealtime.fecha">Fecha</span></dt><dd><span>{{vm.ticketrealtime.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.ip">Ip</span></dt><dd><span>{{vm.ticketrealtime.ip}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.nroticket">Nroticket</span></dt><dd><span>{{vm.ticketrealtime.nroticket}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.esncredito">Esncredito</span></dt><dd><span>{{vm.ticketrealtime.esncredito}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.montototal">Montototal</span></dt><dd><span>{{vm.ticketrealtime.montototal}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.cantitems">Cantitems</span></dt><dd><span>{{vm.ticketrealtime.cantitems}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.cliente">Cliente</span></dt><dd><span>{{vm.ticketrealtime.cliente}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.mediodepago">Mediodepago</span></dt><dd><span>{{vm.ticketrealtime.mediodepago}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.nrolocal">Nrolocal</span></dt><dd><span>{{vm.ticketrealtime.nrolocal}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.flagproceso">Flagproceso</span></dt><dd><span>{{vm.ticketrealtime.flagproceso}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.fechaproceso">Fechaproceso</span></dt><dd><span>{{vm.ticketrealtime.fechaproceso | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.ticketrealtime.fechaenvio">Fechaenvio</span></dt><dd><span>{{vm.ticketrealtime.fechaenvio | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticketrealtime-detail.edit({id:vm.ticketrealtime.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticketrealtime/ticketrealtime-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketrealtimeLabel" data-translate="mVtasWebApp.ticketrealtime.home.createOrEditLabel">Create or edit a Ticketrealtime</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketrealtime.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketrealtime.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.ticketrealtime.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.ticketrealtime.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.nroticket" for="field_nroticket">Nroticket</label><input type="number" class="form-control" name="nroticket" id="field_nroticket" ng-model="vm.ticketrealtime.nroticket"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.esncredito" for="field_esncredito">Esncredito</label><input type="number" class="form-control" name="esncredito" id="field_esncredito" ng-model="vm.ticketrealtime.esncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.montototal" for="field_montototal">Montototal</label><input type="number" class="form-control" name="montototal" id="field_montototal" ng-model="vm.ticketrealtime.montototal"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.cantitems" for="field_cantitems">Cantitems</label><input type="number" class="form-control" name="cantitems" id="field_cantitems" ng-model="vm.ticketrealtime.cantitems"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.cliente" for="field_cliente">Cliente</label><input type="text" class="form-control" name="cliente" id="field_cliente" ng-model="vm.ticketrealtime.cliente" ng-maxlength="50"><div ng-show="editForm.cliente.$invalid"><p class="help-block" ng-show="editForm.cliente.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.mediodepago" for="field_mediodepago">Mediodepago</label><input type="text" class="form-control" name="mediodepago" id="field_mediodepago" ng-model="vm.ticketrealtime.mediodepago" ng-maxlength="30"><div ng-show="editForm.mediodepago.$invalid"><p class="help-block" ng-show="editForm.mediodepago.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.nrolocal" for="field_nrolocal">Nrolocal</label><input type="text" class="form-control" name="nrolocal" id="field_nrolocal" ng-model="vm.ticketrealtime.nrolocal" ng-maxlength="50"><div ng-show="editForm.nrolocal.$invalid"><p class="help-block" ng-show="editForm.nrolocal.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.flagproceso" for="field_flagproceso">Flagproceso</label><input type="number" class="form-control" name="flagproceso" id="field_flagproceso" ng-model="vm.ticketrealtime.flagproceso"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.fechaproceso" for="field_fechaproceso">Fechaproceso</label><div class="input-group"><input id="field_fechaproceso" type="text" class="form-control" name="fechaproceso" datetime-picker="{{dateformat}}" ng-model="vm.ticketrealtime.fechaproceso" is-open="vm.datePickerOpenStatus.fechaproceso"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaproceso\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ticketrealtime.fechaenvio" for="field_fechaenvio">Fechaenvio</label><div class="input-group"><input id="field_fechaenvio" type="text" class="form-control" name="fechaenvio" datetime-picker="{{dateformat}}" ng-model="vm.ticketrealtime.fechaenvio" is-open="vm.datePickerOpenStatus.fechaenvio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaenvio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticketrealtime/ticketrealtimes.html','<div><h2 data-translate="mVtasWebApp.ticketrealtime.home.title">Ticketrealtimes</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover table-scroll"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="fecha"><span data-translate="mVtasWebApp.ticketrealtime.fecha">Fecha</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ip"><span data-translate="mVtasWebApp.ticketrealtime.ip">Ip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nroticket"><span data-translate="mVtasWebApp.ticketrealtime.nroticket">Nroticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="esncredito"><span data-translate="mVtasWebApp.ticketrealtime.esncredito">Esncredito</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="montototal"><span data-translate="mVtasWebApp.ticketrealtime.montototal">Montototal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cantitems"><span data-translate="mVtasWebApp.ticketrealtime.cantitems">Cantitems</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cliente"><span data-translate="mVtasWebApp.ticketrealtime.cliente">Cliente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mediodepago"><span data-translate="mVtasWebApp.ticketrealtime.mediodepago">Mediodepago</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nrolocal"><span data-translate="mVtasWebApp.ticketrealtime.nrolocal">Nrolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="flagproceso"><span data-translate="mVtasWebApp.ticketrealtime.flagproceso">Flagproceso</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fechaproceso"><span data-translate="mVtasWebApp.ticketrealtime.fechaproceso">Fechaproceso</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fechaenvio"><span data-translate="mVtasWebApp.ticketrealtime.fechaenvio">Fechaenvio</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketrealtime in vm.ticketrealtimes track by ticketrealtime.id"><td>{{ticketrealtime.fecha | date:\'medium\'}}</td><td>{{ticketrealtime.ip}}</td><td>{{ticketrealtime.nroticket}}</td><td>{{ticketrealtime.esncredito}}</td><td>{{ticketrealtime.montototal}}</td><td>{{ticketrealtime.cantitems}}</td><td>{{ticketrealtime.cliente}}</td><td>{{ticketrealtime.mediodepago}}</td><td>{{ticketrealtime.nrolocal}}</td><td>{{ticketrealtime.flagproceso}}</td><td>{{ticketrealtime.fechaproceso | date:\'medium\'}}</td><td>{{ticketrealtime.fechaenvio | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticketrealtime-detail({id:ticketrealtime.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/usuario/usuario-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.usuario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.usuario.delete.question" translate-values="{id: \'{{vm.usuario.id}}\'}">Are you sure you want to delete this Usuario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/usuario/usuario-detail.html','<div><h2><span data-translate="mVtasWebApp.usuario.detail.title">Usuario</span> {{vm.usuario.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.usuario.chatid">Chatid</span></dt><dd><span>{{vm.usuario.chatid}}</span></dd><dt><span data-translate="mVtasWebApp.usuario.nombre">Nombre</span></dt><dd><span>{{vm.usuario.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.usuario.rol">Rol</span></dt><dd><span data-translate="{{\'mVtasWebApp.Rol.\' + vm.usuario.rol}}">{{vm.usuario.rol}}</span></dd><dt><span data-translate="mVtasWebApp.usuario.alarmason">Alarmason</span></dt><dd><span>{{vm.usuario.alarmason}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="usuario-detail.edit({id:vm.usuario.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/usuario/usuario-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUsuarioLabel" data-translate="mVtasWebApp.usuario.home.createOrEditLabel">Create or edit a Usuario</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.usuario.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.usuario.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuario.chatid" for="field_chatid">Chatid</label><input type="number" class="form-control" name="chatid" id="field_chatid" ng-model="vm.usuario.chatid"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuario.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.usuario.nombre" ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuario.rol" for="field_rol">Rol</label><select class="form-control" name="rol" ng-model="vm.usuario.rol" id="field_rol"><option value="ADMIN" data-translate="mVtasWebApp.Rol.ADMIN">ADMIN</option><option value="OPERADOR" data-translate="mVtasWebApp.Rol.OPERADOR">OPERADOR</option><option value="COMERCIAL" data-translate="mVtasWebApp.Rol.COMERCIAL">COMERCIAL</option></select></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuario.alarmason" for="field_alarmason">Alarmason</label><input type="number" class="form-control" name="alarmason" id="field_alarmason" ng-model="vm.usuario.alarmason"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/usuario/usuarios.html','<div><h2 data-translate="mVtasWebApp.usuario.home.title">Usuarios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="usuario.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.usuario.home.createLabel">Create new Usuario</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.usuario.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="chatid"><span data-translate="mVtasWebApp.usuario.chatid">Chatid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rol"><span data-translate="mVtasWebApp.usuario.rol">Rol</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="alarmason"><span data-translate="mVtasWebApp.usuario.alarmason">Alarmason</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="usuario in vm.usuarios track by usuario.id"><td>{{usuario.nombre}}</td><td>{{usuario.chatid}}</td><td data-translate="{{\'mVtasWebApp.Rol.\' + usuario.rol}}">{{usuario.rol}}</td><td>{{usuario.alarmason ? \'Si\':\'No\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="usuario-detail({id:usuario.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="usuario.edit({id:usuario.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="usuario.delete({id:usuario.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/usuariolog/usuariolog-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.usuariolog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.usuariolog.delete.question" translate-values="{id: \'{{vm.usuariolog.id}}\'}">Are you sure you want to delete this Usuariolog?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/usuariolog/usuariolog-detail.html','<div><h2><span data-translate="mVtasWebApp.usuariolog.detail.title">Usuariolog</span> {{vm.usuariolog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.usuariolog.nombre">Nombre</span></dt><dd><span>{{vm.usuariolog.nombre}}</span></dd><dt><span data-translate="mVtasWebApp.usuariolog.apellido">Apellido</span></dt><dd><span>{{vm.usuariolog.apellido}}</span></dd><dt><span data-translate="mVtasWebApp.usuariolog.username">Username</span></dt><dd><span>{{vm.usuariolog.username}}</span></dd><dt><span data-translate="mVtasWebApp.usuariolog.userid">Userid</span></dt><dd><span>{{vm.usuariolog.userid}}</span></dd><dt><span data-translate="mVtasWebApp.usuariolog.msg">Msg</span></dt><dd><span>{{vm.usuariolog.msg}}</span></dd><dt><span data-translate="mVtasWebApp.usuariolog.fecha">Fecha</span></dt><dd><span>{{vm.usuariolog.fecha | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="usuariolog-detail.edit({id:vm.usuariolog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/usuariolog/usuariolog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUsuariologLabel" data-translate="mVtasWebApp.usuariolog.home.createOrEditLabel">Create or edit a Usuariolog</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.usuariolog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.usuariolog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.usuariolog.nombre" ng-maxlength="50"><div ng-show="editForm.nombre.$invalid"><p class="help-block" ng-show="editForm.nombre.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.apellido" for="field_apellido">Apellido</label><input type="text" class="form-control" name="apellido" id="field_apellido" ng-model="vm.usuariolog.apellido" ng-maxlength="50"><div ng-show="editForm.apellido.$invalid"><p class="help-block" ng-show="editForm.apellido.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.username" for="field_username">Username</label><input type="text" class="form-control" name="username" id="field_username" ng-model="vm.usuariolog.username" ng-maxlength="50"><div ng-show="editForm.username.$invalid"><p class="help-block" ng-show="editForm.username.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.userid" for="field_userid">Userid</label><input type="text" class="form-control" name="userid" id="field_userid" ng-model="vm.usuariolog.userid" ng-maxlength="20"><div ng-show="editForm.userid.$invalid"><p class="help-block" ng-show="editForm.userid.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.msg" for="field_msg">Msg</label><input type="text" class="form-control" name="msg" id="field_msg" ng-model="vm.usuariolog.msg" ng-maxlength="50"><div ng-show="editForm.msg.$invalid"><p class="help-block" ng-show="editForm.msg.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.usuariolog.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.usuariolog.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/usuariolog/usuariologs.html','<div><h2 data-translate="mVtasWebApp.usuariolog.home.title">Usuariologs</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="mVtasWebApp.usuariolog.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="apellido"><span data-translate="mVtasWebApp.usuariolog.apellido">Apellido</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="username"><span data-translate="mVtasWebApp.usuariolog.username">Username</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userid"><span data-translate="mVtasWebApp.usuariolog.userid">Userid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="msg"><span data-translate="mVtasWebApp.usuariolog.msg">Msg</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fecha"><span data-translate="mVtasWebApp.usuariolog.fecha">Fecha</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="usuariolog in vm.usuariologs track by usuariolog.id"><td><a ui-sref="usuariolog-detail({id:usuariolog.id})">{{usuariolog.id}}</a></td><td>{{usuariolog.nombre}}</td><td>{{usuariolog.apellido}}</td><td>{{usuariolog.username}}</td><td>{{usuariolog.userid}}</td><td>{{usuariolog.msg}}</td><td>{{usuariolog.fecha | date:\'medium\'}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/venta/venta-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.venta.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.venta.delete.question" translate-values="{id: \'{{vm.venta.id}}\'}">Are you sure you want to delete this Venta?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/venta/venta-detail.html','<div><h2><span data-translate="mVtasWebApp.venta.detail.title">Venta</span> <b>{{vm.venta.fecha | date:\'dd/MM/yyyy\'}}</b></h2><!-- http://marcoceppi.github.io/bootstrap-glyphicons/ --> <button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><label for="repeatSelect">Filtrar por Aeropuerto:</label><select name="repeatSelect" class="input-sm" style="font-size:14px" ng-model="vm.seleccionAeropuerto" ng-options="selaeropuerto as selaeropuerto for selaeropuerto in vm.arrayAeropuertos" ng-init="Aeropuerto =\'\'"></select><input type="hidden" name="vm.seleccionAeropuerto" ng-model="vm.seleccionAeropuerto"><h4></h4><jhi-alert-error></jhi-alert-error><div class="table-responsive text-right"><table class="jh-table table table-hover"><thead><tr><!-- <th colspan="1" style="text-align:center; background-color:#90ffbc">TOTAL: $ {{vm.totalizado | number: 2}}</th> --><th colspan="1" style="text-align:center; background-color:#90ffbc">TOTAL: $ {{calcTotal(vm.seleccionAeropuerto) | number: 2}}</th><th colspan="2" style="text-align:center; background-color:#ffc890">COLECTORES</th><!-- http://www.chem.utoronto.ca/~dstone/html/col-align.html --><th colspan="6" style="text-align:center; background-color:#daffb4">VENTAS</th><th colspan="3" style="text-align:center; background-color:#d6d6f5">NOTAS DE CREDITO</th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>Seleccion</th><th><span data-translate="mVtasWebApp.zeta.comercio">Comercio</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ip">Terminal</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ticketsmontoventas">Ticketsmontoventas</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.totalefectivo">Totalefectivo</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.totaltarjeta">Totaltarjeta</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ticketscantventas">Ticketscantventas</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.itemscantventas">Itemscantventas</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ticketpromedio">Ticketpromedio</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ticketsmontoncredito">Ticketsmontoncredito</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.ticketscantncredito">Ticketscantncredito</span></th><th class="text-right"><span data-translate="mVtasWebApp.zeta.itemscantncredito">Itemscantncredito</span></th><!--\t\t\t\t<th class="text-right">Descargar</th> --><th></th></tr></thead><tbody><tr ng-repeat="zeta in vm.zetas | filter:filtraPorAeropuerto "><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="zeta-detail({id:zeta.id})" class="btn btn-primary btn-sm"><span class="hidden-sm-down" data-translate="entity.action.tickets"></span></button></div></td><td class="text-left">{{zeta.comercio}}</td><td>{{zeta.ip}}</td><td>$ {{zeta.ticketsmontoventas | number: 2 }}</td><td>$ {{zeta.totalefectivo | number: 2 }}</td><td>$ {{zeta.totaltarjeta | number: 2 }}</td><td>{{zeta.ticketscantventas}}</td><td>{{zeta.itemscantventas}}</td><td>$ {{(zeta.ticketsmontoventas / (zeta.ticketscantventas ? zeta.ticketscantventas:1) ) | number: 2 }}</td><td>$ {{zeta.ticketsmontoncredito | number: 2 }}</td><td>{{zeta.ticketscantncredito}}</td><td>{{zeta.itemscantncredito}}</td><!--\t\t\t\t\t<td><file-download fileurl="{{zeta.comercio}}.csv" linktext="Descarga .csv"></file-download></td>                     --></tr></tbody></table></div><!--\t\n\t<button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>\n\t--></div>');
$templateCache.put('app/entities/venta/venta-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVentaLabel" data-translate="mVtasWebApp.venta.home.createOrEditLabel">Create or edit a Venta</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.venta.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.venta.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.venta.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.cantcomercios" for="field_cantcomercios">Cantcomercios</label><input type="number" class="form-control" name="cantcomercios" id="field_cantcomercios" ng-model="vm.venta.cantcomercios"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.cantpv" for="field_cantpv">Cantpv</label><input type="number" class="form-control" name="cantpv" id="field_cantpv" ng-model="vm.venta.cantpv"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.cantz" for="field_cantz">Cantz</label><input type="number" class="form-control" name="cantz" id="field_cantz" ng-model="vm.venta.cantz"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ventasmonto" for="field_ventasmonto">Ventasmonto</label><input type="number" class="form-control" name="ventasmonto" id="field_ventasmonto" ng-model="vm.venta.ventasmonto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ventastickets" for="field_ventastickets">Ventastickets</label><input type="number" class="form-control" name="ventastickets" id="field_ventastickets" ng-model="vm.venta.ventastickets"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ventasitems" for="field_ventasitems">Ventasitems</label><input type="number" class="form-control" name="ventasitems" id="field_ventasitems" ng-model="vm.venta.ventasitems"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ncreditomonto" for="field_ncreditomonto">Ncreditomonto</label><input type="number" class="form-control" name="ncreditomonto" id="field_ncreditomonto" ng-model="vm.venta.ncreditomonto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ncreditotickets" for="field_ncreditotickets">Ncreditotickets</label><input type="number" class="form-control" name="ncreditotickets" id="field_ncreditotickets" ng-model="vm.venta.ncreditotickets"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.venta.ncreditoitems" for="field_ncreditoitems">Ncreditoitems</label><input type="number" class="form-control" name="ncreditoitems" id="field_ncreditoitems" ng-model="vm.venta.ncreditoitems"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/venta/ventas.html','<div><h2 data-translate="mVtasWebApp.venta.home.title">Ventas</h2><jhi-alert></jhi-alert><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><h4></h4><style>.full button span {\n\t\t\tbackground-color: limegreen;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }\n\t\t  .partially button span {\n\t\t\tbackground-color: orange;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }</style><div class="row"><div class="col-md-5"><p class="input-group"><input type="text" name="start" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" is-open="popup1.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" name="end" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.toDate" ng-change="vm.onChangeDate()" is-open="popup2.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-scroll"><thead><tr><th colspan="1" style="text-align:center; background-color:#90ffbc">TOTAL:</th><th colspan="1" style="text-align:center; background-color:#90ffbc">$ {{vm.totalizado | number: 2}}</th><th colspan="2" style="text-align:center; background-color:#ffc890">COLECTORES</th><!-- http://www.chem.utoronto.ca/~dstone/html/col-align.html --><th colspan="6" style="text-align:center; background-color:#daffb4">VENTAS</th><th colspan="3" style="text-align:center; background-color:#d6d6f5">NOTAS DE CREDITO</th></tr><tr jh-sort="vm.predicate" callback="vm.transition()"><th>Seleccion</th><th><span data-translate="mVtasWebApp.venta.fecha">Fecha</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.cantcomercios">Cantcomercios</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.cantpv">Cantpv</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ventasmonto">Ventasmonto</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.totalefectivo">Totalefectivo</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.totaltarjeta">Totaltarjeta</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ventastickets">Ventastickets</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ventasitems">Ventasitems</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ticketpromedio">Ticketpromedio</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ncreditomonto">Ncreditomonto</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ncreditotickets">Ncreditotickets</span></th><th class="text-right"><span data-translate="mVtasWebApp.venta.ncreditoitems">Ncreditoitems</span></th><th></th></tr></thead><tbody><!-- |  FALTA --><tr ng-repeat="venta in vm.ventas | filter:filter "><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="venta-detail({id:venta.id})" class="btn btn-primary btn-sm"><span class="hidden-sm-down" data-translate="entity.action.comercio"></span></button></div></td><td>{{venta.fecha | date:\'dd/MM/yyyy\'}}</td><td class="text-right">{{venta.cantcomercios}}</td><td class="text-right">{{venta.cantpv}}</td><td class="text-right">$ {{venta.ventasmonto | number: 2}}</td><td class="text-right">$ {{venta.totalefectivo | number: 2}}</td><td class="text-right">$ {{venta.totaltarjeta | number: 2}}</td><td class="text-right">{{venta.ventastickets}}</td><td class="text-right">{{venta.ventasitems}}</td><td class="text-right">$ {{(venta.ventasmonto / (venta.ventastickets ? venta.ventastickets:1) ) | number: 2 }}</td><td class="text-right">$ {{venta.ncreditomonto | number: 2}}</td><td class="text-right">{{venta.ncreditotickets}}</td><td class="text-right">{{venta.ncreditoitems}}</td></tr></tbody></table></div><!--funcionaba\n\t\n    <div class="text-center">\n        <uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination>\n    </div>\n\t-->');
$templateCache.put('app/entities/ventadetalle/ventadetalle-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ventadetalle.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ventadetalle.delete.question" translate-values="{id: \'{{vm.ventadetalle.id}}\'}">Are you sure you want to delete this Ventadetalle?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ventadetalle/ventadetalle-detail.html','<div><h2><span data-translate="mVtasWebApp.ventadetalle.detail.title">Ventadetalle</span> {{vm.ventadetalle.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.ventadetalle.comercio">Comercio</span></dt><dd><span>{{vm.ventadetalle.comercio}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.ip">Ip</span></dt><dd><span>{{vm.ventadetalle.ip}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.fecha">Fecha</span></dt><dd><span>{{vm.ventadetalle.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.nroticket">Nroticket</span></dt><dd><span>{{vm.ventadetalle.nroticket}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.esncredito">Esncredito</span></dt><dd><span>{{vm.ventadetalle.esncredito}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.cliente">Cliente</span></dt><dd><span>{{vm.ventadetalle.cliente}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.codigomoneda">Moneda</span></dt><dd><span>{{vm.ventadetalle.codigomoneda}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.tipofactura">Tipofactura</span></dt><dd><span>{{vm.ventadetalle.tipofactura}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.operacion">Operacion</span></dt><dd><span>{{vm.ventadetalle.operacion}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.descripcion">Descripcion</span></dt><dd><span>{{vm.ventadetalle.descripcion}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.monto">Monto</span></dt><dd><span>{{vm.ventadetalle.monto}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.cantidad">Cantidad</span></dt><dd><span>{{vm.ventadetalle.cantidad}}</span></dd><dt><span data-translate="mVtasWebApp.ventadetalle.mdepcategoria">Mdepcategoria</span></dt><dd><span>{{vm.ventadetalle.mdepcategoria}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ventadetalle-detail.edit({id:vm.ventadetalle.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ventadetalle/ventadetalle-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVentadetalleLabel" data-translate="mVtasWebApp.ventadetalle.home.createOrEditLabel">Create or edit a Ventadetalle</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ventadetalle.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ventadetalle.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.comercio" for="field_comercio">Comercio</label><input type="text" class="form-control" name="comercio" id="field_comercio" ng-model="vm.ventadetalle.comercio" ng-maxlength="50"><div ng-show="editForm.comercio.$invalid"><p class="help-block" ng-show="editForm.comercio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.ventadetalle.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.ventadetalle.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.nroticket" for="field_nroticket">Nroticket</label><input type="number" class="form-control" name="nroticket" id="field_nroticket" ng-model="vm.ventadetalle.nroticket"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.esncredito" for="field_esncredito">Esncredito</label><input type="number" class="form-control" name="esncredito" id="field_esncredito" ng-model="vm.ventadetalle.esncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.cliente" for="field_cliente">Cliente</label><input type="text" class="form-control" name="cliente" id="field_cliente" ng-model="vm.ventadetalle.cliente" ng-maxlength="50"><div ng-show="editForm.cliente.$invalid"><p class="help-block" ng-show="editForm.cliente.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.codigomoneda" for="field_cliente">Moneda</label><input type="text" class="form-control" name="codigomoneda" id="field_codigomoneda" ng-model="vm.ventadetalle.codigomoneda" ng-maxlength="3"><div ng-show="editForm.codigomoneda.$invalid"><p class="help-block" ng-show="editForm.codigomoneda.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.tipofactura" for="field_tipofactura">Tipofactura</label><input type="text" class="form-control" name="tipofactura" id="field_tipofactura" ng-model="vm.ventadetalle.tipofactura" ng-maxlength="2"><div ng-show="editForm.tipofactura.$invalid"><p class="help-block" ng-show="editForm.tipofactura.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.operacion" for="field_operacion">Operacion</label><input type="text" class="form-control" name="operacion" id="field_operacion" ng-model="vm.ventadetalle.operacion" ng-maxlength="30"><div ng-show="editForm.operacion.$invalid"><p class="help-block" ng-show="editForm.operacion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.ventadetalle.descripcion" ng-maxlength="50"><div ng-show="editForm.descripcion.$invalid"><p class="help-block" ng-show="editForm.descripcion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.monto" for="field_monto">Monto</label><input type="number" class="form-control" name="monto" id="field_monto" ng-model="vm.ventadetalle.monto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.cantidad" for="field_cantidad">Cantidad</label><input type="number" class="form-control" name="cantidad" id="field_cantidad" ng-model="vm.ventadetalle.cantidad"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventadetalle.mdepcategoria" for="field_mdepcategoria">Mdepcategoria</label><input type="text" class="form-control" name="mdepcategoria" id="field_mdepcategoria" ng-model="vm.ventadetalle.mdepcategoria" ng-maxlength="10"><div ng-show="editForm.mdepcategoria.$invalid"><p class="help-block" ng-show="editForm.mdepcategoria.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ventadetalle/ventadetalles.html','<div><h2 data-translate="mVtasWebApp.ventadetalle.home.title">Ventadetalles</h2><jhi-alert></jhi-alert><br><br><style>.full button span {\n\t\t\tbackground-color: limegreen;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }\n\t\t  .partially button span {\n\t\t\tbackground-color: orange;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }</style><div class="row"><div class="col-md-5"><p class="input-group"><input type="text" name="start" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" is-open="popup1.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" name="end" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.toDate" ng-change="vm.onChangeDate()" is-open="popup2.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><label for="repeatSelect">Filtrar por Comercio:</label><select name="repeatSelect" class="input-sm" style="font-size:14px" ng-model="vm.seleccionComercio" ng-options="selcomercio as selcomercio for selcomercio in vm.arrayComercios" ng-init="Comercio =\'\'"></select><input type="hidden" name="vm.seleccionComercio" ng-model="vm.seleccionComercio"></div><div class="row"><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><br><br><th>Total de registros a exportar:</th><h4><div ng-bind="calcTotal(vm.seleccionComercio)"></div></h4></div><div class="row"><h6><i>(Columnas incluidas en la exportacion hasta detalle item x item: Comercio,Fecha,NroTicket,EsNcredito,Cliente,Operacion,Descripcion,Monto,Cantidad,MdePago)</i><h6></h6></h6></div></div>');
$templateCache.put('app/entities/ventahoyrealtime/ventahoyrealtime-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ventahoyrealtime.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ventahoyrealtime.delete.question" translate-values="{id: \'{{vm.ventahoyrealtime.id}}\'}">Are you sure you want to delete this Ventahoyrealtime?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ventahoyrealtime/ventahoyrealtime-detail.html','<div><h2><span data-translate="mVtasWebApp.ventahoyrealtime.detail.title">Ventahoyrealtime</span> {{vm.ventahoyrealtime.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.ventahoyrealtime.fechaproceso">Fechaproceso</span></dt><dd><span>{{vm.ventahoyrealtime.fechaproceso}}</span></dd><dt><span data-translate="mVtasWebApp.ventahoyrealtime.cantpv">Cantpv</span></dt><dd><span>{{vm.ventahoyrealtime.cantpv}}</span></dd><dt><span data-translate="mVtasWebApp.ventahoyrealtime.totalmonto">Totalmonto</span></dt><dd><span>{{vm.ventahoyrealtime.totalmonto}}</span></dd><dt><span data-translate="mVtasWebApp.ventahoyrealtime.totaltickets">Totaltickets</span></dt><dd><span>{{vm.ventahoyrealtime.totaltickets}}</span></dd><dt><span data-translate="mVtasWebApp.ventahoyrealtime.totalitems">Totalitems</span></dt><dd><span>{{vm.ventahoyrealtime.totalitems}}</span></dd><dt><span data-translate="mVtasWebApp.ventahoyrealtime.hora">Hora</span></dt><dd><span>{{vm.ventahoyrealtime.hora}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ventahoyrealtime-detail.edit({id:vm.ventahoyrealtime.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVentahoyrealtimeLabel" data-translate="mVtasWebApp.ventahoyrealtime.home.createOrEditLabel">Create or edit a Ventahoyrealtime</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ventahoyrealtime.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ventahoyrealtime.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.fechaproceso" for="field_hora">Fechaproceso</label><input type="text" class="form-control" name="fechaproceso" id="field_fechaproceso" ng-model="vm.ventahoyrealtime.fechaproceso" ng-maxlength="20"><div ng-show="editForm.fechaproceso.$invalid"><p class="help-block" ng-show="editForm.fechaproceso.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.cantpv" for="field_cantpv">Cantpv</label><input type="number" class="form-control" name="cantpv" id="field_cantpv" ng-model="vm.ventahoyrealtime.cantpv"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.totalmonto" for="field_totalmonto">Totalmonto</label><input type="number" class="form-control" name="totalmonto" id="field_totalmonto" ng-model="vm.ventahoyrealtime.totalmonto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.totaltickets" for="field_totaltickets">Totaltickets</label><input type="number" class="form-control" name="totaltickets" id="field_totaltickets" ng-model="vm.ventahoyrealtime.totaltickets"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.totalitems" for="field_totalitems">Totalitems</label><input type="number" class="form-control" name="totalitems" id="field_totalitems" ng-model="vm.ventahoyrealtime.totalitems"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventahoyrealtime.hora" for="field_hora">Hora</label><input type="text" class="form-control" name="hora" id="field_hora" ng-model="vm.ventahoyrealtime.hora" ng-maxlength="5"><div ng-show="editForm.hora.$invalid"><p class="help-block" ng-show="editForm.hora.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="5">This field cannot be longer than 5 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ventahoyrealtime/ventahoyrealtimes.html','<div><h2 data-translate="mVtasWebApp.ventahoyrealtime.home.title">Ventahoyrealtimes</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr><th><span data-translate="mVtasWebApp.ventahoyrealtime.fechaproceso">Fechaproceso</span></th><th><span data-translate="mVtasWebApp.ventahoyrealtime.totalmonto">Totalmonto</span></th><th><span data-translate="mVtasWebApp.ventahoyrealtime.totaltickets">Totaltickets</span></th><th><span data-translate="mVtasWebApp.ventahoyrealtime.totalitems">Totalitems</span></th><th><span data-translate="mVtasWebApp.ventahoyrealtime.cantpv">Cantpv</span></th><th></th></tr></thead><tbody><tr ng-repeat="ventahoyrealtime in vm.ventahoyrealtimes track by ventahoyrealtime.id"><td>{{ventahoyrealtime.fechaproceso| limitTo : 2 : 6}}/{{ventahoyrealtime.fechaproceso| limitTo : 2 : 4}}/{{ventahoyrealtime.fechaproceso| limitTo : 4 : 0}} {{ventahoyrealtime.fechaproceso| limitTo : 2 : 8}}:{{ventahoyrealtime.fechaproceso| limitTo : 2 : 10}}</td><td>{{ventahoyrealtime.totalmonto}}</td><td>{{ventahoyrealtime.totaltickets}}</td><td>{{ventahoyrealtime.totalitems}}</td><td>{{ventahoyrealtime.cantpv}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ventames/ventames-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ventames.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ventames.delete.question" translate-values="{id: \'{{vm.ventames.id}}\'}">Are you sure you want to delete this Ventames?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ventames/ventames-detail.html','<div><h2><span data-translate="mVtasWebApp.ventames.detail.title">Ventames</span> {{vm.ventames.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.ventames.anio">Anio</span></dt><dd><span>{{vm.ventames.anio}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.mes">Mes</span></dt><dd><span>{{vm.ventames.mes}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.diasventa">Diasventa</span></dt><dd><span>{{vm.ventames.diasventa}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.cantcomercios">Cantcomercios</span></dt><dd><span>{{vm.ventames.cantcomercios}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.cantpv">Cantpv</span></dt><dd><span>{{vm.ventames.cantpv}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.monto">Monto</span></dt><dd><span>{{vm.ventames.monto}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.tickets">Tickets</span></dt><dd><span>{{vm.ventames.tickets}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.items">Items</span></dt><dd><span>{{vm.ventames.items}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.filecsv">Filecsv</span></dt><dd><span>{{vm.ventames.filecsv}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.mdepefectivomonto">Mdepefectivomonto</span></dt><dd><span>{{vm.ventames.mdepefectivomonto}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.mdepefectivocantidad">Mdepefectivocantidad</span></dt><dd><span>{{vm.ventames.mdepefectivocantidad}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.mdeptarjetasmonto">Mdeptarjetasmonto</span></dt><dd><span>{{vm.ventames.mdeptarjetasmonto}}</span></dd><dt><span data-translate="mVtasWebApp.ventames.mdeptarjetascantidad">Mdeptarjetascantidad</span></dt><dd><span>{{vm.ventames.mdeptarjetascantidad}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ventames-detail.edit({id:vm.ventames.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ventames/ventames-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVentamesLabel" data-translate="mVtasWebApp.ventames.home.createOrEditLabel">Create or edit a Ventames</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ventames.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ventames.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.anio" for="field_anio">Anio</label><input type="number" class="form-control" name="anio" id="field_anio" ng-model="vm.ventames.anio"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.mes" for="field_mes">Mes</label><input type="number" class="form-control" name="mes" id="field_mes" ng-model="vm.ventames.mes"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.diasventa" for="field_diasventa">Diasventa</label><input type="number" class="form-control" name="diasventa" id="field_diasventa" ng-model="vm.ventames.diasventa"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.cantcomercios" for="field_cantcomercios">Cantcomercios</label><input type="number" class="form-control" name="cantcomercios" id="field_cantcomercios" ng-model="vm.ventames.cantcomercios"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.cantpv" for="field_cantpv">Cantpv</label><input type="number" class="form-control" name="cantpv" id="field_cantpv" ng-model="vm.ventames.cantpv"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.monto" for="field_monto">Monto</label><input type="number" class="form-control" name="monto" id="field_monto" ng-model="vm.ventames.monto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.tickets" for="field_tickets">Tickets</label><input type="number" class="form-control" name="tickets" id="field_tickets" ng-model="vm.ventames.tickets"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.items" for="field_items">Items</label><input type="number" class="form-control" name="items" id="field_items" ng-model="vm.ventames.items"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.filecsv" for="field_filecsv">Filecsv</label><input type="text" class="form-control" name="filecsv" id="field_filecsv" ng-model="vm.ventames.filecsv" ng-maxlength="100"><div ng-show="editForm.filecsv.$invalid"><p class="help-block" ng-show="editForm.filecsv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.mdepefectivomonto" for="field_mdepefectivomonto">Mdepefectivomonto</label><input type="number" class="form-control" name="mdepefectivomonto" id="field_mdepefectivomonto" ng-model="vm.ventames.mdepefectivomonto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.mdepefectivocantidad" for="field_mdepefectivocantidad">Mdepefectivocantidad</label><input type="number" class="form-control" name="mdepefectivocantidad" id="field_mdepefectivocantidad" ng-model="vm.ventames.mdepefectivocantidad"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.mdeptarjetasmonto" for="field_mdeptarjetasmonto">Mdeptarjetasmonto</label><input type="number" class="form-control" name="mdeptarjetasmonto" id="field_mdeptarjetasmonto" ng-model="vm.ventames.mdeptarjetasmonto"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventames.mdeptarjetascantidad" for="field_mdeptarjetascantidad">Mdeptarjetascantidad</label><input type="number" class="form-control" name="mdeptarjetascantidad" id="field_mdeptarjetascantidad" ng-model="vm.ventames.mdeptarjetascantidad"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ventames/ventames.html','<div><h2 data-translate="mVtasWebApp.ventames.home.title">Ventames</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ventames.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="mVtasWebApp.ventames.home.createLabel">Create new Ventames</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="mVtasWebApp.ventames.anio">Anio</span></th><th><span data-translate="mVtasWebApp.ventames.mes">Mes</span></th><th><span data-translate="mVtasWebApp.ventames.diasventa">Diasventa</span></th><th><span data-translate="mVtasWebApp.ventames.cantcomercios">Cantcomercios</span></th><th><span data-translate="mVtasWebApp.ventames.cantpv">Cantpv</span></th><th><span data-translate="mVtasWebApp.ventames.monto">Monto</span></th><th><span data-translate="mVtasWebApp.ventames.tickets">Tickets</span></th><th><span data-translate="mVtasWebApp.ventames.items">Items</span></th><th><span data-translate="mVtasWebApp.ventames.filecsv">Filecsv</span></th><th><span data-translate="mVtasWebApp.ventames.mdepefectivomonto">Mdepefectivomonto</span></th><th><span data-translate="mVtasWebApp.ventames.mdepefectivocantidad">Mdepefectivocantidad</span></th><th><span data-translate="mVtasWebApp.ventames.mdeptarjetasmonto">Mdeptarjetasmonto</span></th><th><span data-translate="mVtasWebApp.ventames.mdeptarjetascantidad">Mdeptarjetascantidad</span></th><th></th></tr></thead><tbody><tr ng-repeat="ventames in vm.ventames track by ventames.id"><td><a ui-sref="ventames-detail({id:ventames.id})">{{ventames.id}}</a></td><td>{{ventames.anio}}</td><td>{{ventames.mes}}</td><td>{{ventames.diasventa}}</td><td>{{ventames.cantcomercios}}</td><td>{{ventames.cantpv}}</td><td>{{ventames.monto}}</td><td>{{ventames.tickets}}</td><td>{{ventames.items}}</td><td>{{ventames.filecsv}}</td><td>{{ventames.mdepefectivomonto}}</td><td>{{ventames.mdepefectivocantidad}}</td><td>{{ventames.mdeptarjetasmonto}}</td><td>{{ventames.mdeptarjetascantidad}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ventames-detail({id:ventames.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ventames.edit({id:ventames.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ventames.delete({id:ventames.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/zeta/zeta-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.zeta.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.zeta.delete.question" translate-values="{id: \'{{vm.zeta.id}}\'}">Are you sure you want to delete this Zeta?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/zeta/zeta-detail.html','<!--\n<head>\n<script>\nfunction goBack() {\n    window.history.back()\n}\n</script>\n</head>\n--><div><h2><span data-translate="mVtasWebApp.zeta.detail.title">Zeta</span> <b>{{vm.zeta.comercio}}</b></h2><h3>Tickets de Fecha: <b>{{vm.zeta.fechadesde | date:\'dd/MM/yyyy\' }}</b></h3><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><jhi-alert-error></jhi-alert-error><h4></h4><div class="table-responsive text-right"><table class="jh-table table table-hover"><thead><tr><th colspan="2" style="text-align:center; background-color:#90ffbc">TOTAL: $ {{vm.totalizado | number: 2}}</th><th colspan="1" style="text-align:center; background-color:#ffc890">PV</th><!-- http://www.chem.utoronto.ca/~dstone/html/col-align.html --><th colspan="9" style="text-align:center; background-color:#daffb4">OPERACION</th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th>Seleccion</th><th><span data-translate="mVtasWebApp.ticket.fecha">Fecha</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.nropv">Nropv</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.nroticket">Nroticket</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.cantitems">Cantitems</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.montototal">Montototal</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.totalefectivo">Totalefectivo</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.totaltarjeta">Totaltarjeta</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.tipofactura">Tipofactura</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.cliente">Cliente</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.codigomoneda">Moneda</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.esncredito">Esncredito</span></th><th class="text-right"><span data-translate="mVtasWebApp.ticket.nrozfiscal">ZFiscal</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticket in vm.tickets track by ticket.id"><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-detail({id:ticket.id})" class="btn btn-primary btn-sm"><span class="hidden-sm-down" data-translate="entity.action.items"></span></button></div></td><td class="text-left">{{ticket.fecha | date:\'HH:mm\'}}</td><td>{{ticket.nropv }}</td><td>{{ticket.nroticket}}</td><td>{{ticket.cantitems}}</td><td>$ {{ticket.montototal | number: 2 }}</td><td>$ {{ticket.totalefectivo | number: 2 }}</td><td>$ {{ticket.totaltarjeta | number: 2 }}</td><td>{{ticket.tipofactura}}</td><td>{{ticket.cliente}}</td><td>{{ticket.codigomoneda}}</td><td>{{ticket.esncredito ? \'Si\':\'No\'}}</td><td>{{ticket.nrozfiscal}}</td></tr></tbody></table></div><!--\n\t<button type="submit"\n            ui-sref="{{vm.previousState}}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>\n\t\n\t\n\t<button type="submit"\n            ui-sref="{{venta.detail({id:venta.id})}}"\n            class="btn btn-info">\n\t\t\tvalue="Atras2" \n    </button>\n\t\n\t--><!--\n\t\t\tzeta-detail({id:zeta.id})\n\t\n\t\t<button type="submit"\n            ui-sref="zeta"\n            class="btn btn-info">\n\t\t\tvalue="Atras1" \n    </button>\n\t\n\tzeta-detail({id:zeta.id})\n\t\n\tui-sref="user-management.edit({login:user.login})"\n\t\n\t<input type="button" value="Atrasss" onclick="goBack()">\t\n\t\n\t<button type="submit"\n\t\t\tui-sref="zeta-detail({id:zeta.id})"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back">Back</span>\n    </button>\n\t\n\t<button type="submit"\n\t\tui-sref="history.back()" \n\t\tBack\n\t</button>\n\t--><!--\n    <button type="submit"\n            ui-sref="{{ vm.previousState }}"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>\n\t--></div>');
$templateCache.put('app/entities/zeta/zeta-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myZetaLabel" data-translate="mVtasWebApp.zeta.home.createOrEditLabel">Create or edit a Zeta</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.zeta.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.zeta.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.comercio" for="field_comercio">Comercio</label><input type="text" class="form-control" name="comercio" id="field_comercio" ng-model="vm.zeta.comercio" ng-maxlength="50"><div ng-show="editForm.comercio.$invalid"><p class="help-block" ng-show="editForm.comercio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.nropv" for="field_nropv">Nropv</label><input type="text" class="form-control" name="nropv" id="field_nropv" ng-model="vm.zeta.nropv" ng-maxlength="18"><div ng-show="editForm.nropv.$invalid"><p class="help-block" ng-show="editForm.nropv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.fechadesde" for="field_fechadesde">Fechadesde</label><div class="input-group"><input id="field_fechadesde" type="text" class="form-control" name="fechadesde" datetime-picker="{{dateformat}}" ng-model="vm.zeta.fechadesde" is-open="vm.datePickerOpenStatus.fechadesde"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechadesde\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.fechahasta" for="field_fechahasta">Fechahasta</label><div class="input-group"><input id="field_fechahasta" type="text" class="form-control" name="fechahasta" datetime-picker="{{dateformat}}" ng-model="vm.zeta.fechahasta" is-open="vm.datePickerOpenStatus.fechahasta"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechahasta\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.ticketsmontoventas" for="field_ticketsmontoventas">Ticketsmontoventas</label><input type="number" class="form-control" name="ticketsmontoventas" id="field_ticketsmontoventas" ng-model="vm.zeta.ticketsmontoventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.ticketsmontoncredito" for="field_ticketsmontoncredito">Ticketsmontoncredito</label><input type="number" class="form-control" name="ticketsmontoncredito" id="field_ticketsmontoncredito" ng-model="vm.zeta.ticketsmontoncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.ticketscantventas" for="field_ticketscantventas">Ticketscantventas</label><input type="number" class="form-control" name="ticketscantventas" id="field_ticketscantventas" ng-model="vm.zeta.ticketscantventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.ticketscantncredito" for="field_ticketscantncredito">Ticketscantncredito</label><input type="number" class="form-control" name="ticketscantncredito" id="field_ticketscantncredito" ng-model="vm.zeta.ticketscantncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.itemscantventas" for="field_itemscantventas">Itemscantventas</label><input type="number" class="form-control" name="itemscantventas" id="field_itemscantventas" ng-model="vm.zeta.itemscantventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.itemscantncredito" for="field_itemscantncredito">Itemscantncredito</label><input type="number" class="form-control" name="itemscantncredito" id="field_itemscantncredito" ng-model="vm.zeta.itemscantncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.zeta.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.nroz" for="field_nroz">Nroz</label><input type="number" class="form-control" name="nroz" id="field_nroz" ng-model="vm.zeta.nroz"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zeta.fechaoperativa" for="field_fechaoperativa">Fechaoperativa</label><div class="input-group"><input id="field_fechaoperativa" type="text" class="form-control" name="fechaoperativa" datetime-picker="{{dateformat}}" ng-model="vm.zeta.fechaoperativa" is-open="vm.datePickerOpenStatus.fechaoperativa"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaoperativa\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="mVtasWebApp.zeta.venta" for="field_venta">Venta</label><select class="form-control" id="field_venta" name="venta" ng-model="vm.zeta.venta" ng-options="venta as venta.id for venta in vm.ventas track by venta.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/zeta/zetas.html','<div><h2 data-translate="mVtasWebApp.zeta.home.title">Zetas</h2><jhi-alert></jhi-alert><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><h5><i></i></h5><style>.full button span {\n\t\t\tbackground-color: limegreen;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }\n\t\t  .partially button span {\n\t\t\tbackground-color: orange;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }</style><div class="row"><div class="col-md-5"><p class="input-group"><input type="text" name="start" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" is-open="popup1.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" name="end" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.toDate" ng-change="vm.onChangeDate()" is-open="popup2.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><br><br><br><label for="repeatSelect">Filtrar por Aeropuerto:</label><select name="repeatSelect" class="input-sm" style="font-size:12px" ng-model="vm.seleccionAeropuerto" ng-change="vm.onChangeAep()" ng-options="selaeropuerto as selaeropuerto for selaeropuerto in vm.arrayAeropuertos" ng-init="Aeropuerto =\'\'"></select><input type="hidden" name="vm.seleccionAeropuerto" ng-model="vm.seleccionAeropuerto"><label for="repeatSelect">Filtrar por RazonSocial:</label><select name="repeatSelect" class="input-sm" style="font-size:12px" ng-model="vm.seleccionRazonSocial" ng-change="vm.onChangeRazonSocial()" ng-options="selrazonsocial as selrazonsocial[0] for selrazonsocial in vm.arrayRazonSocial" ng-init="RazonSocial =\'\'"></select><input type="hidden" name="vm.seleccionRazonSocial" ng-model="vm.seleccionRazonSocial"><label for="repeatSelect">Filtrar por Comercio:</label><select name="repeatSelect" class="input-sm" style="font-size:12px" ng-model="vm.seleccionComercio" ng-options="selcomercio as selcomercio[0] for selcomercio in vm.arrayComercios" ng-init="Comercio =\'\'"></select><input type="hidden" name="vm.seleccionComercio" ng-model="vm.seleccionComercio"></div></div><br><div class="table-responsive"><table class="jh-table table table-hover table-scroll"><thead><tr jh-sort="vm.predicate" callback="vm.transition()"><th><span data-translate="mVtasWebApp.zeta.fechaoperativa">Fecha</span></th><th><span data-translate="mVtasWebApp.zeta.aeropuerto">Aeropuerto</span></th><th><span data-translate="mVtasWebApp.zeta.razonsocial">Razon Social</span></th><th><span data-translate="mVtasWebApp.zeta.comercio">Comercio</span></th><th><span data-translate="mVtasWebApp.zeta.ip">Terminal</span></th><th title="Ventas-NCredito">Ventas Brutas</th><th title="Ventas">Ventas Brutas s/NCred</th><th title="Tickets">Tickets</th><th><span data-translate="mVtasWebApp.zeta.metodo">Metodo</span></th><th><span data-translate="mVtasWebApp.zeta.modimpresora">ModImpresora</span></th><th></th></tr></thead><tbody><tr ng-repeat="zeta in vm.zetas | filter:filter | filter:filtraPorAeropuerto | filter:filtraPorRazonSocial | filter:filtraPorComercio "><td>{{zeta.fechaoperativa | date:\'dd/MM/yyyy\'}}</td><td>{{zeta.aeropuerto}}</td><td>{{zeta.razonsocial}}</td><td>{{zeta.comercio}}</td><td>{{zeta.ip}}</td><td>$ {{zeta.ticketsmontoncredito | number: 2}}</td><td>$ {{zeta.ticketsmontoventas | number: 2}}</td><td>{{zeta.ticketscantventas}}</td><td>{{zeta.metodo}}</td><td>{{zeta.modimpresora}}</td></tr></tbody></table></div>');
$templateCache.put('app/entities/ventamesdia/ventamesdia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ventamesdia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.ventamesdia.delete.question" translate-values="{id: \'{{vm.ventamesdia.id}}\'}">Are you sure you want to delete this Ventamesdia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ventamesdia/ventamesdia-detail.html','<div><h2><span data-translate="mVtasWebApp.ventamesdia.detail.title">Ventamesdia</span> {{vm.ventamesdia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.ventamesdia.fecha">Fecha</span></dt><dd><span>{{vm.ventamesdia.fecha | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.razonsocial">Razonsocial</span></dt><dd><span>{{vm.ventamesdia.razonsocial}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.comercio">Comercio</span></dt><dd><span>{{vm.ventamesdia.comercio}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.nrolocal">Nrolocal</span></dt><dd><span>{{vm.ventamesdia.nrolocal}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.contrato">Contrato</span></dt><dd><span>{{vm.ventamesdia.contrato}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.total">Total</span></dt><dd><span>{{vm.ventamesdia.total}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.tickets">Tickets</span></dt><dd><span>{{vm.ventamesdia.tickets}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.items">Items</span></dt><dd><span>{{vm.ventamesdia.items}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.tax1a">Tax 1 A</span></dt><dd><span>{{vm.ventamesdia.tax1a}}</span></dd><dt><span data-translate="mVtasWebApp.ventamesdia.tax1b">Tax 1 B</span></dt><dd><span>{{vm.ventamesdia.tax1b}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ventamesdia-detail.edit({id:vm.ventamesdia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ventamesdia/ventamesdia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVentamesdiaLabel" data-translate="mVtasWebApp.ventamesdia.home.createOrEditLabel">Create or edit a Ventamesdia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ventamesdia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ventamesdia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.fecha" for="field_fecha">Fecha</label><div class="input-group"><input id="field_fecha" type="text" class="form-control" name="fecha" datetime-picker="{{dateformat}}" ng-model="vm.ventamesdia.fecha" is-open="vm.datePickerOpenStatus.fecha"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fecha\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.razonsocial" for="field_razonsocial">Razonsocial</label><input type="text" class="form-control" name="razonsocial" id="field_razonsocial" ng-model="vm.ventamesdia.razonsocial" ng-maxlength="30"><div ng-show="editForm.razonsocial.$invalid"><p class="help-block" ng-show="editForm.razonsocial.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.comercio" for="field_comercio">Comercio</label><input type="text" class="form-control" name="comercio" id="field_comercio" ng-model="vm.ventamesdia.comercio" ng-maxlength="50"><div ng-show="editForm.comercio.$invalid"><p class="help-block" ng-show="editForm.comercio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.nrolocal" for="field_nrolocal">Nrolocal</label><input type="text" class="form-control" name="nrolocal" id="field_nrolocal" ng-model="vm.ventamesdia.nrolocal" ng-maxlength="50"><div ng-show="editForm.nrolocal.$invalid"><p class="help-block" ng-show="editForm.nrolocal.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.contrato" for="field_contrato">Contrato</label><input type="text" class="form-control" name="contrato" id="field_contrato" ng-model="vm.ventamesdia.contrato" ng-maxlength="10"><div ng-show="editForm.contrato.$invalid"><p class="help-block" ng-show="editForm.contrato.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.total" for="field_total">Total</label><input type="number" class="form-control" name="total" id="field_total" ng-model="vm.ventamesdia.total"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.tickets" for="field_tickets">Tickets</label><input type="number" class="form-control" name="tickets" id="field_tickets" ng-model="vm.ventamesdia.tickets"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.items" for="field_items">Items</label><input type="number" class="form-control" name="items" id="field_items" ng-model="vm.ventamesdia.items"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.tax1a" for="field_tax1a">Tax 1 A</label><input type="number" class="form-control" name="tax1a" id="field_tax1a" ng-model="vm.ventamesdia.tax1a"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.ventamesdia.tax1b" for="field_tax1b">Tax 1 B</label><input type="number" class="form-control" name="tax1b" id="field_tax1b" ng-model="vm.ventamesdia.tax1b"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ventamesdia/ventamesdias.html','<div><h2 data-translate="mVtasWebApp.ventamesdia.home.title">Ventamesdias</h2><jhi-alert></jhi-alert><button class="btn btn-sm btn-success" ng-click="vm.exportDataExcel()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a Excel</span></button> <button class="btn btn-sm btn-success" ng-click="vm.exportDataCSV()"><span class="glyphicon glyphicon-export"></span><span class="hidden-sm-down"> Exportar a CSV</span></button><h5><i>Nota: columna Total es neto</i></h5><style>.full button span {\n\t\t\tbackground-color: limegreen;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }\n\t\t  .partially button span {\n\t\t\tbackground-color: orange;\n\t\t\tborder-radius: 32px;\n\t\t\tcolor: black;\n\t\t  }</style><div class="row"><div class="col-md-5"><p class="input-group"><input type="text" name="start" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" is-open="popup1.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button> </span><input type="text" name="end" current-text="Hoy" clear-text="Limpiar" close-text="Cerrar" class="form-control" uib-datepicker-popup="{{format}}" ng-model="vm.toDate" ng-change="vm.onChangeDate()" is-open="popup2.opened" datepicker-options="dateOptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><label for="repeatSelect">Filtrar por Comercio:</label><select name="repeatSelect" class="input-sm" style="font-size:14px" ng-model="vm.seleccionComercio" ng-options="selcomercio as selcomercio for selcomercio in vm.arrayComercios" ng-init="Comercio =\'\'"></select><input type="hidden" name="vm.seleccionComercio" ng-model="vm.seleccionComercio"></div></div><div class="table-responsive"><table class="jh-table table table-hover table-scroll"><thead><tr><th colspan="1" style="text-align:center; background-color:#90ffbc">TOTAL: $ {{calcTotal(vm.seleccionComercio) | number: 2}}</th><th colspan="4" style="text-align:center; background-color:#ffc890">COMERCIOS</th><!-- http://www.chem.utoronto.ca/~dstone/html/col-align.html --><th colspan="5" style="text-align:center; background-color:#daffb4">TOTALES</th></tr><tr></tr><tr jh-sort="vm.predicate" callback="vm.transition()"><th><span data-translate="mVtasWebApp.ventamesdia.fecha">Fecha</span></th><th><span data-translate="mVtasWebApp.ventamesdia.razonsocial">Razonsocial</span></th><th><span data-translate="mVtasWebApp.ventamesdia.comercio">Comercio</span></th><th><span data-translate="mVtasWebApp.ventamesdia.nrolocal">Nrolocal</span></th><th><span data-translate="mVtasWebApp.ventamesdia.contrato">Contrato</span></th><th><span data-translate="mVtasWebApp.ventamesdia.total">Total</span></th><th><span data-translate="mVtasWebApp.ventamesdia.tickets">Tickets</span></th><th><span data-translate="mVtasWebApp.ventamesdia.items">Items</span></th><th><span data-translate="mVtasWebApp.ventamesdia.tax1a">Tax 1 A</span></th><th><span data-translate="mVtasWebApp.ventamesdia.tax1b">Tax 1 B</span></th><th></th></tr></thead><tbody><tr ng-repeat="ventamesdia in vm.ventamesdias | filter:filter | filter:filtraPorComercio "><td>{{ventamesdia.fecha | date:\'dd/MM/yyyy\'}}</td><td>{{ventamesdia.razonsocial}}</td><td>{{ventamesdia.comercio}}</td><td>{{ventamesdia.nrolocal}}</td><td>{{ventamesdia.contrato}}</td><td>$ {{ventamesdia.total | number: 2}}</td><td>{{ventamesdia.tickets}}</td><td>{{ventamesdia.items}}</td><td>$ {{ventamesdia.tax1a| number: 2}}</td><td>$ {{ventamesdia.tax1b| number: 2}}</td></tr></tbody></table></div>');
$templateCache.put('app/entities/zetasrealtime/zetasrealtime-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.zetasrealtime.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="mVtasWebApp.zetasrealtime.delete.question" translate-values="{id: \'{{vm.zetasrealtime.id}}\'}">Are you sure you want to delete this Zetasrealtime?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/zetasrealtime/zetasrealtime-detail.html','<div><h2><span data-translate="mVtasWebApp.zetasrealtime.detail.title">Zetasrealtime</span> {{vm.zetasrealtime.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="mVtasWebApp.zetasrealtime.fechaproceso">Fechaproceso</span></dt><dd><span>{{vm.zetasrealtime.fechaproceso}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.comercio">Comercio</span></dt><dd><span>{{vm.zetasrealtime.comercio}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.terminal">Terminal</span></dt><dd><span>{{vm.zetasrealtime.terminal}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.pv">Pv</span></dt><dd><span>{{vm.zetasrealtime.pv}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.nroz">Nroz</span></dt><dd><span>{{vm.zetasrealtime.nroz}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.fechadesde">Fechadesde</span></dt><dd><span>{{vm.zetasrealtime.fechadesde | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.fechahasta">Fechahasta</span></dt><dd><span>{{vm.zetasrealtime.fechahasta | date:\'medium\'}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.zetamontoventas">Zetamontoventas</span></dt><dd><span>{{vm.zetasrealtime.zetamontoventas}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.zetamontoncredito">Zetamontoncredito</span></dt><dd><span>{{vm.zetasrealtime.zetamontoncredito}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.ticketsmontoventas">Ticketsmontoventas</span></dt><dd><span>{{vm.zetasrealtime.ticketsmontoventas}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.ticketsmontoncredito">Ticketsmontoncredito</span></dt><dd><span>{{vm.zetasrealtime.ticketsmontoncredito}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.ticketscantventas">Ticketscantventas</span></dt><dd><span>{{vm.zetasrealtime.ticketscantventas}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.ticketscantncredito">Ticketscantncredito</span></dt><dd><span>{{vm.zetasrealtime.ticketscantncredito}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.itemscantventas">Itemscantventas</span></dt><dd><span>{{vm.zetasrealtime.itemscantventas}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.itemscantncredito">Itemscantncredito</span></dt><dd><span>{{vm.zetasrealtime.itemscantncredito}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.nivelproceso">Nivelproceso</span></dt><dd><span>{{vm.zetasrealtime.nivelproceso}}</span></dd><dt><span data-translate="mVtasWebApp.zetasrealtime.fechaoperativa">Fechaoperativa</span></dt><dd><span>{{vm.zetasrealtime.fechaoperativa | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="zetasrealtime-detail.edit({id:vm.zetasrealtime.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/zetasrealtime/zetasrealtime-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myZetasrealtimeLabel" data-translate="mVtasWebApp.zetasrealtime.home.createOrEditLabel">Create or edit a Zetasrealtime</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.zetasrealtime.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.zetasrealtime.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.fechaproceso" for="field_fechaproceso">Fechaproceso</label><input type="text" class="form-control" name="fechaproceso" id="field_fechaproceso" ng-model="vm.zetasrealtime.fechaproceso" ng-maxlength="20"><div ng-show="editForm.fechaproceso.$invalid"><p class="help-block" ng-show="editForm.fechaproceso.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.comercio" for="field_comercio">Comercio</label><input type="text" class="form-control" name="comercio" id="field_comercio" ng-model="vm.zetasrealtime.comercio" ng-maxlength="50"><div ng-show="editForm.comercio.$invalid"><p class="help-block" ng-show="editForm.comercio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.ip" for="field_ip">Ip</label><input type="text" class="form-control" name="ip" id="field_ip" ng-model="vm.zetasrealtime.ip" ng-maxlength="18"><div ng-show="editForm.ip.$invalid"><p class="help-block" ng-show="editForm.ip.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="18">This field cannot be longer than 18 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.pv" for="field_pv">Pv</label><input type="text" class="form-control" name="pv" id="field_pv" ng-model="vm.zetasrealtime.pv" ng-maxlength="10"><div ng-show="editForm.pv.$invalid"><p class="help-block" ng-show="editForm.pv.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.nroz" for="field_nroz">Nroz</label><input type="number" class="form-control" name="nroz" id="field_nroz" ng-model="vm.zetasrealtime.nroz"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.fechadesde" for="field_fechadesde">Fechadesde</label><div class="input-group"><input id="field_fechadesde" type="text" class="form-control" name="fechadesde" datetime-picker="{{dateformat}}" ng-model="vm.zetasrealtime.fechadesde" is-open="vm.datePickerOpenStatus.fechadesde"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechadesde\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.fechahasta" for="field_fechahasta">Fechahasta</label><div class="input-group"><input id="field_fechahasta" type="text" class="form-control" name="fechahasta" datetime-picker="{{dateformat}}" ng-model="vm.zetasrealtime.fechahasta" is-open="vm.datePickerOpenStatus.fechahasta"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechahasta\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.zetamontoventas" for="field_zetamontoventas">Zetamontoventas</label><input type="number" class="form-control" name="zetamontoventas" id="field_zetamontoventas" ng-model="vm.zetasrealtime.zetamontoventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.zetamontoncredito" for="field_zetamontoncredito">Zetamontoncredito</label><input type="number" class="form-control" name="zetamontoncredito" id="field_zetamontoncredito" ng-model="vm.zetasrealtime.zetamontoncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.ticketsmontoventas" for="field_ticketsmontoventas">Ticketsmontoventas</label><input type="number" class="form-control" name="ticketsmontoventas" id="field_ticketsmontoventas" ng-model="vm.zetasrealtime.ticketsmontoventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.ticketsmontoncredito" for="field_ticketsmontoncredito">Ticketsmontoncredito</label><input type="number" class="form-control" name="ticketsmontoncredito" id="field_ticketsmontoncredito" ng-model="vm.zetasrealtime.ticketsmontoncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.ticketscantventas" for="field_ticketscantventas">Ticketscantventas</label><input type="number" class="form-control" name="ticketscantventas" id="field_ticketscantventas" ng-model="vm.zetasrealtime.ticketscantventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.ticketscantncredito" for="field_ticketscantncredito">Ticketscantncredito</label><input type="number" class="form-control" name="ticketscantncredito" id="field_ticketscantncredito" ng-model="vm.zetasrealtime.ticketscantncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.itemscantventas" for="field_itemscantventas">Itemscantventas</label><input type="number" class="form-control" name="itemscantventas" id="field_itemscantventas" ng-model="vm.zetasrealtime.itemscantventas"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.itemscantncredito" for="field_itemscantncredito">Itemscantncredito</label><input type="number" class="form-control" name="itemscantncredito" id="field_itemscantncredito" ng-model="vm.zetasrealtime.itemscantncredito"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.nivelproceso" for="field_nivelproceso">Nivelproceso</label><input type="number" class="form-control" name="nivelproceso" id="field_nivelproceso" ng-model="vm.zetasrealtime.nivelproceso"></div><div class="form-group"><label class="control-label" data-translate="mVtasWebApp.zetasrealtime.fechaoperativa" for="field_fechaoperativa">Fechaoperativa</label><div class="input-group"><input id="field_fechaoperativa" type="text" class="form-control" name="fechaoperativa" datetime-picker="{{dateformat}}" ng-model="vm.zetasrealtime.fechaoperativa" is-open="vm.datePickerOpenStatus.fechaoperativa"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaoperativa\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/zetasrealtime/zetasrealtimes.html','<div><h2 data-translate="mVtasWebApp.zetasrealtime.home.title">Zetasrealtimes</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-hover"><thead><tr><th colspan="4" style="text-align:center; background-color:#ffc890">COLECTORES</th><!-- http://www.chem.utoronto.ca/~dstone/html/col-align.html --><th colspan="3" style="text-align:center; background-color:#daffb4">VENTAS</th><th colspan="3" style="text-align:center; background-color:#d6d6f5">NOTAS DE CREDITO</th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="text-right" jh-sort-by="comercio"><span data-translate="mVtasWebApp.zetasrealtime.comercio">Comercio</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="pv"><span data-translate="mVtasWebApp.zetasrealtime.Terminal">Terminal</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="fechadesde"><span data-translate="mVtasWebApp.zetasrealtime.fechadesde">Fechadesde</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="fechahasta"><span data-translate="mVtasWebApp.zetasrealtime.fechahasta">Fechahasta</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="ticketsmontoventas"><span data-translate="mVtasWebApp.zetasrealtime.ticketsmontoventas">Ticketsmontoventas</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="ticketscantventas"><span data-translate="mVtasWebApp.zetasrealtime.ticketscantventas">Ticketscantventas</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="itemscantventas"><span data-translate="mVtasWebApp.zetasrealtime.itemscantventas">Itemscantventas</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="ticketsmontoncredito"><span data-translate="mVtasWebApp.zetasrealtime.ticketsmontoncredito">Ticketsmontoncredito</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="ticketscantncredito"><span data-translate="mVtasWebApp.zetasrealtime.ticketscantncredito">Ticketscantncredito</span> <span class="glyphicon glyphicon-sort"></span></th><th class="text-right" jh-sort-by="itemscantncredito"><span data-translate="mVtasWebApp.zetasrealtime.itemscantncredito">Itemscantncredito</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="zetasrealtime in vm.zetasrealtimes track by zetasrealtime.id"><td>{{zetasrealtime.comercio}}</td><td class="text-right">{{zetasrealtime.ip}}</td><td class="text-right">{{zetasrealtime.fechadesde | date:\'dd/MM/yyyy HH:mm\'}}</td><td class="text-right">{{zetasrealtime.fechahasta | date:\'dd/MM/yyyy HH:mm\'}}</td><td class="text-right">$ {{zetasrealtime.ticketsmontoventas | number: 2}}</td><td class="text-right">{{zetasrealtime.ticketscantventas}}</td><td class="text-right">{{zetasrealtime.itemscantventas}}</td><td class="text-right">$ {{zetasrealtime.ticketsmontoncredito | number: 2}}</td><td class="text-right">{{zetasrealtime.ticketscantncredito}}</td><td class="text-right">{{zetasrealtime.itemscantncredito}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">MVtasWeb</span> <span class="navbar-version">v{{VERSION}}</span> <img class="logo-img" src="content/images/center.png" alt="logocomercio"></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="monitor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Monitor</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="pais" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.pais">Pais</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="region" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.region">Region</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="provincia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.provincia">Provincia</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="aeropuerto" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.aeropuerto">Aeropuerto</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="comercio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.comercio">Comercio</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="pv" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.pv">Pv</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="rubro" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.rubro">Rubro</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="moneda" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.moneda">Moneda</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="modelosdeimpresora" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.modelosdeimpresora">Modelosdeimpresora</span></a></li><li class="divider"></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="usuario" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.usuario">Usuario</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="usuariolog" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.usuariolog">Usuariolog</span></a></li><li class="divider"></li><!--\n\t\t\t\t\t\t<li ui-sref-active="active">\n                                <a ui-sref="ventahoyrealtime" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.entities.ventahoyrealtime">Ventahoyrealtime</span>\n                                </a>\n                            </li>\n                        <li ui-sref-active="active">\n                                <a ui-sref="zetasrealtime" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.entities.zetasrealtime">Zetasrealtime</span>\n                                </a>\n                            </li>\n\t\t\t\t\t\t<li class="divider"></li>\n\t\t\t\t\t\t--><li ui-sref-active="active"><a ui-sref="venta" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.venta">Venta</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="ventamesdia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ventamesdia">Ventamesdia</span></a></li><li ui-sref-active="active"><a ui-sref="zeta" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.zeta">Zeta</span></a></li><li ui-sref-active="active"><a ui-sref="ventadetalle" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ventadetalle">Ventadetalle</span></a></li><!--\n\t\t\t\t\t\t<li ui-sref-active="active">\n                                <a ui-sref="ticketrealtime" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.entities.ticketrealtime">Ticketrealtime</span>\n                                </a>\n                            </li>\n\t\t\t\t\t\t--><li ui-sref-active="active"><a ui-sref="pvlog" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.pvlog">Pvlog</span></a></li><li ui-sref-active="active"><a ui-sref="estadoactual" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.estadoactual">Estadoactual</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li>\n\t\t\t\t\t\t--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();